import loadable from "@loadable/component";
import { Link, graphql } from "gatsby";
import { StaticImage, getImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import HeaderTypography from "../../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../../components/v2/Typography/ParagraphTypography";
import WhiteButton from "../../components/v2/WhightButton";
import useWidth from "../../hooks/useWidth";

import requestDemoBGImg from "../../images/v2/Gmail-page-footer-img.png";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import HomeCard from "../../components/v2/HomeCard/HomeCard";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CheckIcon from "@material-ui/icons/Check";

// All Images
import integrationBG from "../../images/v2/home/integration-bg.svg";
import remoteReadyBG from "../../images/v2/home/remote-ready-bg.svg";
import responsiveBG from "../../images/v2/home/responsive-bg-img.svg";
import lightBlueBgImg from "../../images/v2/light-blue-bg.svg";
import tickImage from "../../images/v2/whatsapp/tickIconImage.png";
import case1hero from "../../images/v2/crm-integration/aircall-hero-1.png";
import case2hero from "../../images/v2/crm-integration/gmail-hero-image.webp";
import case3hero from "../../images/v2/crm-integration/instagram-hero-1.png";
import case4hero from "../../images/v2/crm-integration/telegram-hero.png";
import case5hero from "../../images/v2/crm-integration/Facebook Form-hero.webp";
import case6hero from "../../images/v2/crm-integration/Facebook Mesanger-hero1.webp";
import case7hero from "../../images/v2/crm-integration/outlook-hero-1.webp";
import case8hero from "../../images/v2/crm-integration/Outlook-calender-hero-1.webp";
import case9hero from "../../images/v2/crm-integration/Outlook-Contacts-hero-1.webp";
import case10hero from "../../images/v2/crm-integration/WhatsApp-hero-1.webp";
import case11hero from "../../images/v2/crm-integration/xero-hero-img.png";
import case12hero from "../../images/v2/crm-integration/mailchimp-hero-img.webp";
import case13hero from "../../images/v2/crm-integration/zoom-hero-img.png";
import case14hero from "../../images/v2/crm-integration/quickbook-hero-img.png";
import case15hero from "../../images/v2/crm-integration/mailerlite-hero-img.png";
import case16hero from "../../images/v2/crm-integration/contact-hero-img.png";
import case17hero from "../../images/v2/crm-integration/gdrive-hero-img.png";
import case18hero from "../../images/v2/crm-integration/one-drive-hero-img.png";
import case19hero from "../../images/v2/crm-integration/gform-hero-img.png";
import case20hero from "../../images/v2/crm-integration/shopify-hero-img.png";
import case21hero from "../../images/v2/crm-integration/gcalendar-hero-img.png";
import case22hero from "../../images/v2/crm-integration/dear-system-hero-img.png";
import case23hero from "../../images/v2/crm-integration/linkdin-hero-img.png";
import case24hero from "../../images/v2/crm-integration/jira-hero-img.png";
import case25hero from "../../images/v2/crm-integration/gsheet-hero-img.png";
import case26hero from "../../images/v2/crm-integration/twilio-hero-img.png";
import case27hero from "../../images/v2/crm-integration/cloud-hero-img.png";
import case28hero from "../../images/v2/crm-integration/krispcall-hero-img.webp";
import case29hero from "../../images/v2/crm-integration/confluence-hero.png";
import airCallLogo from "../../images/v2/crm-integration/logo/aircallLogo.svg";
import confluenceLogo from "../../images/v2/crm-integration/logo/confluenceLogo.svg";
import dearSystem from "../../images/v2/crm-integration/logo/dearSystemLogo.svg";
import facebookLogo from "../../images/v2/crm-integration/logo/facebookLogo.svg";
import facebookMessangerLogo from "../../images/v2/crm-integration/logo/facebookMessangerLogo.svg";
import gmailLogo from "../../images/v2/crm-integration/logo/gmailLogo.svg";
import googleCalendarLogo from "../../images/v2/crm-integration/logo/googleCalendarLogo.svg";
import googleContactsLogo from "../../images/v2/crm-integration/logo/googleContactLogo.svg";
import googleDriveLogo from "../../images/v2/crm-integration/logo/googleDriveLogo.svg";
import googleFormsLogo from "../../images/v2/crm-integration/logo/googleFormsLogo.svg";
import googleSheetLogo from "../../images/v2/crm-integration/logo/googleSheetLogo.svg";
import instagramLogo from "../../images/v2/crm-integration/logo/instagramLogo.svg";
import jiraLogo from "../../images/v2/crm-integration/logo/jiraLogo.svg";
import krispcallLogo from "../../images/v2/crm-integration/logo/krispcallLogo.png";
import linkedinLogo from "../../images/v2/crm-integration/logo/linkedinLogo.svg";
import mailchimpLogo from "../../images/v2/crm-integration/logo/mailchimpLogo.svg";
import mailerLiteLogo from "../../images/v2/crm-integration/logo/mailerLiteLogo.svg";
import onedriveLogo from "../../images/v2/crm-integration/logo/onedriveLogo.svg";
import outlookLogo from "../../images/v2/crm-integration/logo/outlookLogo.svg";
import outlookCalendarLogo from "../../images/v2/crm-integration/logo/outlookCalendarLogo.svg";
import outlookContactLogo from "../../images/v2/crm-integration/logo/outlookContactLogo.svg";
import quickBookLogo from "../../images/v2/crm-integration/logo/quickBookLogo.svg";
import shopifyLogo from "../../images/v2/crm-integration/logo/shopifyLogo.svg";
import telegramLogo from "../../images/v2/crm-integration/logo/telegramLogo.svg";
import whatsappTwilioLogo from "../../images/v2/crm-integration/logo/whatsappTwilioLogo.svg";
import whatsappMetaLogo from "../../images/v2/crm-integration/logo/whatsappMetaLogo.svg";
import xeroLogo from "../../images/v2/crm-integration/logo/xeroLogo.svg";
import zoomLogo from "../../images/v2/crm-integration/logo/zoomLogo.svg";
import backArrow from "../../images/v2/crm-integration/arrow backpage.png";
import pointerIcon from "../../images/v2/crm-integration/pointer.png";
import { useLocation } from "@reach/router";
import { Collapse, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import SEO from "../../components/SEO";
import TrustedByLogoStrip from "../../components/v4/TrustedByLogoStrip/TrustedByLogoStrip";
import { px } from "framer-motion";
import clsx from "clsx";
import NotFoundPage from "../404";
// import WebinarModal from "../../components/v2/WebinarModal";
import "../../styles/index.scss";

const useStyles = makeStyles((theme) => ({
  listItemIcon: {
    color: "#fff",
    fontSize: 20,
    backgroundColor: "#08a742",
    borderRadius: "50%",
    padding: "5px",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      fontSize: 18,
      marginRight: theme.spacing(1.5),
    },
  },
  cardContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: "20px",
    rowGap: "20px",
    width: "100%",
    flexWrap: "wrap",
    margin: "auto",
    marginBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      // padding: '0 25px'
    },
  },
  tagName: {
    marginTop: "20px",
    width: "344px",
    fontSize: "16px",
    fontWeight: "600",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "10px",
    margin: "20px 0",
    "& .primaryButton": {
      minWidth: "130px",
      minHeight: "52px",
    },
    "& .primaryButtonOutline": {
      minWidth: "130px",
      minHeight: "52px",
    },
  },
  footerButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    margin: "20px 0",
    "& .primaryButton": {
      padding: "15px 40px",
    },
  },
  faqbackgroundDivder: {
    marginTop: "60px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "15px",
    },
  },
  pepperCloudCRMHelps: {
    marginTop: "60px",
    [theme.breakpoints.up("md")]: {
      backgroundSize: "100%",
      backgroundPosition: "center",
    },
  },
  platformImageContainer: {
    width: "100%",
    height: "200px",
    border: "1px solid #7fcbe7",
    borderRadius: "12px",
    margin: "10px 0",
    backgroundImage: "linear-gradient(147deg, #fff 67%, #91eafc 119%)",
  },
  customHeader: {
    // width: '376px',
    height: "56px",
    margin: "95px 512px 1px 63px",
    fontFamily: "Poppins",
    fontSize: "40px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "0.8px",
    textAlign: "left",
    color: "#0291ae",
  },
  homeSliderText: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginTop: "-3rem",
    },
  },
  loginButton: {
    marginTop: theme.spacing(2),
    color: "#000000",
    border: "1px solid rgb(0 0 0 / 62%)",
    fontWeight: 600,
  },
  tickImages: {
    paddingLeft: "20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
      padding: "0",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
      padding: "0",
    },
  },
  customButton: {
    fontSize: "22px",
  },
  explorButton: {
    boxShadow:
      " 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    border: "1px solid green",
    "&:hover": {
      border: "1px solid green",
    },
  },
  clientLogoImg: {
    width: "100%",
    height: "auto",
    padding: "0 1rem",
  },
  cycleProcessImg: {
    "& picture img": {
      willChange: "auto !important",
    },
    // maxWidth: "530px",
    // height: "auto",
  },
  img: {
    maxWidth: "100%",
    height: "auto",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "90vw",
    },
  },
  imgLogo: {
    height: "86px",
    width: "86px",
    [theme.breakpoints.down("xs")]: {
      height: "40px",
      width: "40px",
    },
  },
  crmInsightsimg: {
    maxWidth: "480px",
    height: "auto",
  },
  crmheadimg: {
    width: "100%",
    height: "auto",
  },
  crmheadimgContainer: {
    marginBottom: "-45px",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "0px",
    },
  },
  crmheadingsubimg: {
    textAlign: "center",
    marginBottom: "16px",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "0px",
    },
  },
  featureItemContainer: {
    listStyleType: "none",
    padding: "0px",
  },
  featureItem: {
    display: "block",
    cursor: "pointer",
    border: "2px solid",
    borderRadius: theme.shape.borderRadius * 2.5,
    borderColor: "#e7f2ff",
    lineHeight: "22px",
    padding: theme.spacing(2),
    minHeight: "370px",
    "&:hover": {
      background: "#f2f9f9",
      borderColor: "#f2f9f9",
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "380px",
      padding: "1rem",
      "& h3": {
        fontSize: "22px",
      },
    },
  },
  featureItemText: {
    fontSize: "16px !important",
  },
  remoteReadyRoot: {
    background: `url(${remoteReadyBG})`,
    backgroundSize: "cover",
    backgroundPosition: "bottom",
  },
  responsiveRoot: {
    background: `url(${responsiveBG}) center top`,
    backgroundSize: "cover",
    minHeight: "700px",
    paddingTop: "180px",
    [theme.breakpoints.down("sm")]: {
      backgroundImage:
        "linear-gradient(241deg, #00b8d8 100%, #00b8d8 53%, #0893af)",
      paddingTop: "32px",
    },
  },
  integrationRoot: {
    background: `url(${integrationBG})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    marginTop: theme.spacing(8),
    padding: theme.spacing(2),
  },
  collapseDivider: {
    backgroundColor: "#7ad2e2",
  },
  expendButton: {
    backgroundColor: "#5ab6cf",
    marginBottom: theme.spacing(1),
    "&:hover": {
      background: "#a1dae2",
    },
  },
  numberBorder: {
    borderRight: "1px solid #e5e7e9",
  },
  contactUsCard: {
    boxShadow: "0 15px 50px 0 rgba(118, 130, 183, 0.16)",
    padding: theme.spacing(3),
    borderRadius: 10,
    border: "solid 1px #e2f0ff",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0.5),
    },
  },
  blogCard: {
    boxShadow: "0 15px 20px 0 rgba(118, 130, 183, 0.18)",
    borderRadius: 5,
    padding: theme.spacing(2),
    marginTop: -2,
  },
  IntegratedCRMBg: {
    background: "linear-gradaent(to bottom, #ffffff 0%, #e7f2fe 100%)",
  },
  ConnectCrm: {
    background: "linear-gradient(to bottom, #ffffff 0%, #e7f2fe 100%)",
  },
  WhatsAppCrm: {
    background: "linear-gradient(1deg, #dbe9f9 30%, #fff 117%)",
  },
  svg: {
    "& svg g g rect": {
      fill: "none",
    },
  },
  lightBlueBg: {
    background: `url(${lightBlueBgImg}) center top`,
  },
  crmInsightsBg: {
    // background: `url(${crmInsightsBgImg}) left top no-repeat`,
    background: "linear-gradient(179deg, #eaf4fe -6%, #fff 40%)",
  },
  iconContainer: {
    display: "flex",
    columnGap: "100px",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      columnGap: "10px",
      marginLeft: "29px",
      marginTop: "-64px",
    },
  },
  smeSupportImg: {
    maxWidth: "461.2px",
    width: "100%",
    // height: "79.3px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "auto",
    },
  },
  formSubmit: {
    fontSize: "16px",
    fontWeight: "600",
  },
  listItemText: {
    "& *": {
      fontSize: 20,
      color: "#2e3f4f",
      [theme.breakpoints.down("sm")]: {
        fontSize: 16,
      },
    },
  },
  sliderTestimonialImg: {
    boxShadow: "7px 20px 20px 0 rgba(0, 0, 0, 0.16)",
    borderRadius: "10px",
  },
  cimg: {
    "& .gatsby-image-wrapper": {
      filter: "grayscale(100%)",
      "&:hover": {
        filter: "none",
      },
    },
  },
  link: {
    cursor: "pointer",
  },
  getStartedBtn: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  videoContainer: {
    position: "relative",
  },
  "@keyframes smallScale": {
    from: {
      transform: "scale(1)",
      opacity: 1,
    },
    to: {
      transform: "scale(1.5)",
      opacity: 0,
    },
  },
  "@keyframes fadeIn": {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  "@keyframes triangleStroke": {
    from: {
      strokeDashoffset: 90,
    },
    to: {
      strokeDashoffset: 0,
    },
  },

  videoBtnCircle: {
    cursor: "pointer",
    position: "absolute",
    display: "flex",
    backgroundColor: "#4cbb83",
    borderRadius: "50%",
    width: "100px",
    height: "100px",
    padding: "0px",
    top: "62.5%",
    left: "35.5%",
    zIndex: "2",
    "&:before, &:after": {
      content: '""',
      background: "rgba(76, 187, 131, 0.5)",
      borderRadius: "50%",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      height: "100%",
      width: "100%",
      animationName: "$smallScale",
      animationDuration: "3s",
      animationTimingFunction: "linear",
      animationIterationCount: "infinite",
    },
    "&:after": {
      animationDelay: "0.5s",
      zIndex: -1,
    },
  },
  playButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "30px",
    height: "30px",
    transform: "translate(-50%, -50%)",
    "& .triangle": {
      animation: `$fadeIn 1.5s ${theme.transitions.easing.easeIn}`,
    },
    "& .path": {
      strokeDasharray: 90,
      strokeDashoffset: 0,
      animation: "$triangleStroke 1.5s",
      animationTimingFunction: `${theme.transitions.easing.easeIn}`,
    },
  },
  hasScaleAnimation: {
    animationName: "$smallScale",
    animationDuration: "3s",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
  },
  bold: {
    fontWeight: "700",
    color: "#333333",
  },
  IntegrationHeader: {
    marginTop: "0",
    marginLeft: "63px",
    fontFamily: "Poppins",
    fontSize: "40px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "0.8px",
    textAlign: "left",
    color: "#0291ae",
    [theme.breakpoints.down("sm")]: {
      // marginTop: '1rem',
      // marginLeft : '0px',
      // fontSize: "25px",
      // textAlign: "center",
      // lineHeight: "2.4",
      //fontWeight : "bold",
      display: "none",
    },
  },
  smIntegrationHeader: {
    marginTop: "-1rem ",
    // marginBottom : '-1rem',
    width: "auto",
    height: "56px",
    marginLeft: "0px",
    fontFamily: "Poppins",
    fontSize: "25px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "0.8px",
    textAlign: "center",
    color: "#0291ae",
    [theme.breakpoints.up("sm")]: {
      display: "none",
      textAlign: "left",
      height: "auto",
    },
  },
  responsiveToogler: {
    marginLeft: "63px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0",
    },
  },
  bannerImg: {
    margin: "50px auto 0",
    width: "70%",
    background: "#E9F9FF",
    borderRadius: "40px",
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      padding: "10px",
    },
  },
  syncAndSendHeader: {
    maxWidth: "810px",
    width: "100%",
    margin: "-10px 295px 30px 63px",
    fontFamily: "Poppins",
    fontSize: "22px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "0.44px",
    textAlign: "left",
    color: "#000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      textAlign: "center",
      fontWeight: "600",
      lineHeight: "1.4",
      margin: "2rem 0",
      marginBottom: "1rem",
    },
  },
  efficientlyManageTasks: {
    //  width: '763px',
    // height: '65px',
    margin: "20px 0 0px 63px",
    // fontFamily: 'SourceSansPro',
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.56",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
    [theme.breakpoints.down("sm")]: {
      // width : '329px',
      // height : '179px',
      fontSize: "18px",
      textAlign: "center",
      lineHeight: "1.67",
      margin: "0.5rem 0",
    },
  },
  IntegrationFeatures: {
    // width: '650px',
    // height: '31px',
    margin: "51px 0px 0px 63px",
    fontFamily: "Poppins",
    fontSize: "22px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "0.44px",
    textAlign: "left",
    color: "#000",
    [theme.breakpoints.down("sm")]: {
      // width : '255px',
      // height : '25px',
      margin: "2rem 0rem 0.5rem 0rem",
      fontSize: "18px",
      textAlign: "center",
      lineHeight: "1.67",
    },
  },
  customerCommunication: {
    // width: '905px',
    // height: '137px',
    margin: "0px 0px 0px 63px",
    //fontFamily: 'SourceSansPro',
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    marginTop: "20px",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      textAlign: "left",
      lineHeight: "1.5",
      margin: "0px 0px 0px 0px",
      marginTop: "20px",
    },
  },
  gmailIntegration: {
    // width: '650px',
    height: "31px",
    margin: "21px 295px 22px 63px",
    fontFamily: "Poppins",
    fontSize: "22px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "2.73",
    letterSpacing: "0.44px",
    textAlign: "left",
    color: "#000",
  },
  loginto: {
    // width: '605px',
    height: "199px",
    margin: "22px 125px 50px 63px",
    // fontFamily: 'SourceSansPro',
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.56",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
  },
  bottomLine: {
    marginTop: "30px",
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-3rem",
    },
  },
  boostText: {
    paddingBottom: "21px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "28px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "22px",
    },
  },
  boostTextwidth: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up(1120)]: {
      width: "1120px",
    },
  },
  nopadding: {
    display: "block",
    // marginRight: "-76px",

    [theme.breakpoints.up(1200)]: {
      display: "flex",
      marginRight: "-76px",
      paddingLeft: "40px",
    },
  },
  nopad: {
    paddingLeft: "0",
    paddingTop: "0",
  },
  nopads: {
    paddingBottom: "24px",
  },

  nopadtpbtm: {
    paddingTop: "0",
    paddingBottom: "0",
  },
  listPadding: {
    whiteSpace: "pre",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
  },
  listFourpadding: {
    paddingLeft: "56px",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "0px",
    },
  },
  colorChange: {
    color: "#ff7a59",
    fontSize: "30px",
    fontWeight: "700",
    letterSpacing: ".4px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  whitespaceNowrap: {
    whiteSpace: "nowrap",
  },
  requestDemoRoot: {
    background: `linear-gradient(90deg, #011D32 0%, #00182B 100%)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    marginTop: "3rem",
    padding: "60px 0",
  },
  backToIntegration: {
    width: "170px",
    height: "30px",
    marginLeft: "15px",
    // margin: '92.2px 207px 29.8px 15px',
    // fontFamily: 'SourceSansPro',
    fontSize: "18px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.56",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
    [theme.breakpoints.down("sm")]: {
      // marginTop : '2rem',
    },
  },
  resources: {
    width: "84px",
    height: "30px",
    // margin: '38px 323px 0 71px',
    // fontFamily: 'SourceSansPro',
    fontSize: "18px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.56",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#000",
  },
  bottomtextstyle: {
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.56",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#0f27c4",
    display: "inline",
  },
  fordetailed: {
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.56",
    letterSpacing: "normal",
    textAlign: "left",
    marginLeft: "63px",
    display: "block",
  },
  setupGuideHelpAndSupport: {
    textDecoration: "underline",
    // margin: '68px 265px 260px 71px',
    // fontFamily: 'SourceSansPro',
    fontSize: "18px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.56",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#3071ff",
    [theme.breakpoints.down("sm")]: {
      // marginBottom: "-4rem",
    },
  },
  smeBannerTxts: {
    padding: "3px",
    margin: "0",
    marginLeft: "5px",
    paddingBottom: "24px",
    marginLeft: "auto",
    [theme.breakpoints.down("xs")]: {
      marginTop: "-18px",
      lineHeight: "30px",
      paddingBottom: "24px",
      marginLeft: "auto",
    },
  },
  pointer: {
    marginTop: "7px",
    marginRight: "16px",
    width: "18px",
    height: "18px",
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      width: "18px",
      height: "18px",
      objectFit: "contain",
      //  marginLeft : '-20px',
    },
  },
  listItemTextWhite: {
    "& *": {
      fontSize: 20,
      color: "#fff",
      whiteSpace: "noWrap",
      [theme.breakpoints.down("sm")]: {
        fontSize: 18,
      },
      [theme.breakpoints.down("md")]: {
        fontSize: 15,
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 18,
      },
    },
  },
  sidebarContainer: {
    paddingTop: "100px",
    position: "sticky",
    top: "6rem",
    marginTop: "6rem",
    height: "min-content",
    marginBottom: "1rem",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      top: 0,
      position: "relative",
      flexDirection: "column",
      width: "100%",
      margin: 0,
      marginTop: "20px",
      padding: "0 !important",
    },
  },
  responsiveSize: {
    marginTop: "5rem",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      marginTopL: 0,
      padding: "0 !important",
    },
  },

  resourceContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      marginBottom: "30px",
    },
  },

  bottomCardsbottom: {
    maxWidth: "80vw",
    margin: "0 auto",
    marginBottom: "5%",
    marginLeft: "30%",
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
    },
  },
  userCaseContainer: {
    // background:'#DBF3F8',
    // padding:'33px 5px'
  },
  faqTitle: {
    color: "black",
    display: "flex",
    fontSize: 20,
    marginTop: 10,
    fontWeight: 600,
    marginBottom: 8,
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "left",
  },
  faqAnswer: {
    color: "black",
    fontSize: 18,
    marginTop: 8,
    marginBottom: 8,
    maxWidth: 920,
    width: "calc( 100% - 50px )",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  },
  expendButton: {
    backgroundColor: "#eaf0f6",
    "&:hover": {
      background: "#a1dae2",
    },
  },
  mobileResponsive: {
    margin: "0",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: 0,
    },
  },
  mobileHeading: {
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  ytContainer: {
    width: "100%",
    marginTop: "50px",
    marginLeft: "63px",
    borderRadius: "12px",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
      "& iframe": {
        width: "100%",
      },
    },
  },
  // Other styles...
}));

const listOne = `Share catalogs with ease
Send bulk promotions
Chat widget on website`.split(`
`);

const listTwo = `Auto-reply with message templates
Single number for team
Assist customers with AI chatbot`.split(`
`);

const listThree = `Facebook integration
Instagram integration
Telegram integration
Sales management
Sales forecasting`.split(`
`);

const listFour = `Lead  management
Workflow automation
Audio and video calls
Customised dashboard
Integrated with various tools`.split(`
`);

const listFive = `24/7 Local support
No hidden charges
Built for Singapore SMEs`.split(`
`);

const security =
  `Sync your communication channels and expedite sales with instant messaging.
Arm your team with the CRM system to win more opportunities with the least manual work.
Track all the tasks and associated activities and refocus their efforts when necessary. 
Instantly acknowledge the top performers of your team and derive the best practices for everyone.
Reason your won and lost opportunities by analysing your processes and sales strategies.`
    .split(`
`);

const CrmIntegration = ({ pageContext }) => {
  const location = useLocation();
  const company = pageContext?.slug || location.pathname.split("/")[2];
  const [pageLoading, setPageLoading] = useState(false);

  const width = useWidth();
  const classes = useStyles();

  const [showVideo, setShowVideo] = React.useState(false);

  // const bannerImg = {
  //   "aircall-voice-call-integration": (
  //     <StaticImage
  //       alt="aircall-voice-call-integration"
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/aircall-hero.png"
  //     />
  //   ),
  //   "gmail-email-inbox": (
  //     <StaticImage
  //       alt="gmail-email-inbox"
  //       fit="cover"
  //       height={70}
  //       placeholder="blured"
  //       layout="constrained"
  //       src="../../images/v2/crm-integration/gmail-hero-image.webp"
  //       width={236}
  //     />
  //   ),
  //   "instagram-crm-for-sales": (
  //     <StaticImage
  //       alt="instagram-crm-for-sales"
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/instagram-hero.png"
  //     />
  //   ),
  //   "facebook-lead-gen-ads-form": (
  //     <StaticImage
  //       alt="instagram-crm-for-sales"
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/Facebook Form-hero.webp"
  //     />
  //   ),
  //   "best-facebook-messenger-crm-integration": (
  //     <StaticImage
  //       alt="best-facebook-messenger-crm-integration"
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/Facebook Mesanger-hero.webp"
  //     />
  //   ),
  //   "facebook-lead-gen-ads-form": (
  //     <StaticImage
  //       alt="instagram-crm-for-sales"
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/Facebook Form-hero.webp"
  //     />
  //   ),
  //   "xero-accounting-software": (
  //     <StaticImage
  //       alt="Best Xero CRM integration"
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/logo/Xero_software_logo.svg.png"
  //     />
  //   ),
  //   "mailerlite-crm-with-email-marketing": (
  //     <StaticImage
  //       alt=""
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/logo/mailer-lite.png"
  //     />
  //   ),
  //   "mailchimp-crm-with-email-marketing": (
  //     <StaticImage
  //       alt=""
  //       fit="cover"
  //       height={70}
  //       layout="constrained"
  //       placeholder="blured"
  //       src="../../images/v2/crm-integration/logo/Mailchimp.png"
  //     />
  //   ),
  // };

  const pagesData = {
    "aircall-voice-call-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/gmail-rectangle.png"
            alt="Aircall (VOIP) CRM integrations"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
            }}
            className="Group-17887"
          />

          <img
            alt="aircall_logo"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={airCallLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 20,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/telegram-social-media/",
          heading: "Telegram",
          description:
            "Best CRM with Telegram Integration To Maximize Sales | Pepper Cloud",
        },
        {
          id: 21,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/whatsapp-business-api/",
          heading: "WhatsApp Cloud API",
          description:
            "Easily drive communication using CRM integration with WhatsApp Business Cloud API.",
        },
        {
          id: 23,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Video calling",
          badgeColor: "#26c031",
          badgeBackground: "#cafece",
          link: "/crm-integrations/zoom-meetings-for-video-conferencing/",
          heading: "Zoom",
          description:
            "Schedule and manage video meetings with CRM Zoom integration.",
        },
      ],
    },
    "confluence-knowledge-base-software": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Confluence knowledge base Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
            }}
            className="Group-17887"
          />

          <img
            alt="Confluence knowledge base Integration"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={confluenceLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 8,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Data management",
          badgeColor: "#26c031",
          badgeBackground: "#d8ffdc",
          link: "/crm-integrations/google-drive-integration/",
          heading: "Google Drive",
          description:
            "Store and retrieve documents with Google Drive integration.",
        },
        {
          id: 14,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Data management",
          badgeColor: "#be6e51",
          badgeBackground: "#f1e4e0",
          link: "/crm-integrations/onedrive-integration",
          heading: "OneDrive",
          description:
            "Store and retrieve files on OneDrive with CRM integration.",
        },
      ],
    },
    "gmail-email-inbox": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/gmail-rectangle.png"
            alt="Gmail Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
            }}
            className="Group-17887"
          />

          <img
            alt="gmail"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={gmailLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 12,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email marketing",
          badgeColor: "#0bada7",
          badgeBackground: "#cff8f6",
          link: "/crm-integrations/mailchimp-crm-with-email-marketing",
          heading: "Mailchimp",
          description:
            "Optimise email marketing with Mailchimp CRM integration.",
        },
        {
          id: 15,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email inbox",
          badgeColor: "#8f0bc7",
          badgeBackground: "#f0ceff",
          link: "/crm-integrations/microsoft-outlook-365-integration",
          heading: "Outlook",
          description: "Sync and send emails with CRM Outlook integration.",
        },
        {
          id: 13,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email marketing",
          badgeColor: "#0bada7",
          badgeBackground: "#cff8f6",
          link: "/crm-integrations/mailerlite-crm-with-email-marketing",
          heading: "MailerLite",
          description:
            "Enhance email marketing with CRM MailerLite integration.",
        },
      ],
    },
    "instagram-crm-for-sales": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/instagram-rectangle.png"
            alt="Instagram Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
            }}
            className="Group-17887"
          />

          <img
            alt="instagram"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={instagramLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 20,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/telegram-social-media/",
          heading: "Telegram",
          description:
            "Best CRM with Telegram Integration To Maximize Sales | Pepper Cloud",
        },
        {
          id: 21,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/whatsapp-business-api/",
          heading: "WhatsApp Cloud API",
          description:
            "Easily drive communication using CRM integration with WhatsApp Business Cloud API.",
        },
        {
          id: 4,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/best-facebook-messenger-crm-integration",
          heading: "Facebook Messenger",
          description: "Manage Facebook chats with Messenger integration.",
        },
      ],
    },
    "telegram-social-media": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/Telegram-rectangle.png"
            alt="Telegram Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
            }}
            className="Group-17887"
          />

          <img
            alt="Telegram"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={telegramLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 10,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/instagram-crm-for-sales",
          heading: "Instagram",
          description:
            "Close deals quickly  on Instagram with CRM integration.",
        },
        {
          id: 21,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/whatsapp-business-api/",
          heading: "WhatsApp Cloud API",
          description:
            "Easily drive communication using CRM integration with WhatsApp Business Cloud API.",
        },
        {
          id: 4,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/best-facebook-messenger-crm-integration/",
          heading: "Facebook Messenger",
          description: "Manage Facebook chats with Messenger integration.",
        },
      ],
    },
    "facebook-lead-gen-ads-form": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="facebook lead form integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Facebook_lead_form"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={facebookLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 9,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          link: "/crm-integrations/google-form",
          badgeText: "Lead capture",
          badgeColor: "#2d8cff",
          badgeBackground: "#cee3ff",
          heading: "Google Forms",
          description:
            "Record and manage data with CRM Google Forms integration.",
        },
        {
          id: 11,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/linkedin-social-media/",
          heading: "LinkedIn",
          description: "Capture and manage leads via LinkedIn CRM integration.",
        },
      ],
    },
    "best-facebook-messenger-crm-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="facebook crm integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="facebook_messenger"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={facebookMessangerLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 20,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/telegram-social-media/",
          heading: "Telegram",
          description:
            "Best CRM with Telegram Integration To Maximize Sales | Pepper Cloud",
        },
        {
          id: 21,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/whatsapp-business-api/",
          heading: "WhatsApp Cloud API",
          description:
            "Easily drive communication using CRM integration with WhatsApp Business Cloud API.",
        },
        {
          id: 10,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/instagram-crm-for-sales",
          heading: "Instagram",
          description:
            "Close deals quickly  on Instagram with CRM integration.",
        },
      ],
    },
    "microsoft-outlook-365-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/Telegram-rectangle.png"
            alt="Outlook integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Outlook"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={outlookLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 5,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email",
          badgeColor: "#2635c0",
          badgeBackground: "#dadfff",
          link: "/crm-integrations/gmail-email-inbox/",
          heading: "Gmail",
          description: "Sync and send emails with CRM Gmail integration.",
        },
        {
          id: 12,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email marketing",
          badgeColor: "#0bada7",
          badgeBackground: "#cff8f6",
          link: "/crm-integrations/mailchimp-crm-with-email-marketing",
          heading: "Mailchimp",
          description:
            "Optimise email marketing with Mailchimp CRM integration.",
        },
        {
          id: 13,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email marketing",
          badgeColor: "#0bada7",
          badgeBackground: "#cff8f6",
          link: "/crm-integrations/mailerlite-crm-with-email-marketing",
          heading: "MailerLite",
          description:
            "Enhance email marketing with CRM MailerLite integration.",
        },
      ],
    },
    "office365-calendar-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/Telegram-rectangle.png"
            alt="Outlook Calendar Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Outlook Calender"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={outlookCalendarLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 6,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Calendar",
          badgeColor: "#6a42bd",
          badgeBackground: "#f4e1ff",
          link: "/crm-integrations/google-calendar-integration/",
          heading: "Google Calender",
          description:
            "Book meetings quickly with Google Calendar integration.",
        },
      ],
    },
    "microsoft-outlook-contacts-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/Telegram-rectangle.png"
            alt="Outlook Contacts Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Outlook Contacts"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={outlookContactLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 7,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Contacts",
          badgeColor: "#f38129",
          badgeBackground: "#fde3d0",
          link: "/crm-integrations/google-contacts-integration",
          heading: "Google Contacts",
          description:
            "Sync and manage contacts with Google Contacts integration. ",
        },
      ],
    },
    "whatsapp-business-api": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/whatsapp-green.png"
            alt="WhatsApp Business Cloud API integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="WhatsApp"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={whatsappMetaLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),

      bottomCards: [
        {
          id: 20,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/telegram-social-media/",
          heading: "Telegram",
          description:
            "Best CRM with Telegram Integration To Maximize Sales | Pepper Cloud",
        },
        {
          id: 24,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/whatsapp-via-twilio",
          heading: "WhatsApp Twilio API",
          description:
            "Improve engagement with WhatsApp Business API integration.",
        },
        {
          id: 10,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/instagram-crm-for-sales",
          heading: "Instagram",
          description:
            "Close deals quickly  on Instagram with CRM integration.",
        },
      ],
    },
    "xero-accounting-software": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="best crm for xero"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Xero"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={xeroLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 18,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Accounting",
          badgeColor: "#2d8cff",
          badgeBackground: "#cee3ff",
          link: "/crm-integrations/quickbooks-accouting-tool",
          heading: "QuickBooks",
          description:
            "Generate and track estimations with QuickBooks integration.",
        },
      ],
    },
    "mailchimp-crm-with-email-marketing": {
      // platformImage:'../../images/v2/crm-integration/logo/Mailchimp.psvg
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Mailchimp CRM integrations"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Mailchimp"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={mailchimpLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 13,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email marketing",
          badgeColor: "#0bada7",
          badgeBackground: "#cff8f6",
          link: "/crm-integrations/mailerlite-crm-with-email-marketing",
          heading: "MailerLite",
          description:
            "Enhance email marketing with CRM MailerLite integration.",
        },
        {
          id: 15,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email inbox",
          badgeColor: "#8f0bc7",
          badgeBackground: "#f0ceff",
          link: "/crm-integrations/microsoft-outlook-365-integration",
          heading: "Outlook",
          description: "Sync and send emails with CRM Outlook integration.",
        },
        {
          id: 5,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email inbox",
          badgeColor: "#2635c0",
          badgeBackground: "#dadfff",
          link: "/crm-integrations/gmail-email-inbox/",
          heading: "Gmail",
          description: "Sync and send emails with CRM Gmail integration.",
        },
      ],
    },
    "mailerlite-crm-with-email-marketing": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="MailerLite crm integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="MailerLite"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={mailerLiteLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "110px",
              height: "110px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 5,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email inbox",
          badgeColor: "#2635c0",
          badgeBackground: "#dadfff",
          link: "/crm-integrations/gmail-email-inbox/",
          heading: "Gmail",
          description: "Sync and send emails with CRM Gmail integration.",
        },
        {
          id: 15,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email inbox",
          badgeColor: "#8f0bc7",
          badgeBackground: "#f0ceff",
          link: "/crm-integrations/microsoft-outlook-365-integration",
          heading: "Outlook",
          description: "Sync and send emails with CRM Outlook integration.",
        },
        {
          id: 12,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Email marketing",
          badgeColor: "#0bada7",
          badgeBackground: "#cff8f6",
          link: "/crm-integrations/mailchimp-crm-with-email-marketing",
          heading: "Mailchimp",
          description:
            "Optimise email marketing with Mailchimp CRM integration.",
        },
      ],
    },
    "zoom-meetings-for-video-conferencing": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="best crm for zoom"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Zoom"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={zoomLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 1,
          image: "../images/green-grad.png",
          backgroundColor: "#f0f0f0",
          link: "/crm-integrations/aircall-voice-call-integration",
          badgeText: "Calling",
          badgeColor: "#cf2bd5",
          badgeBackground: "#efdbfa",
          heading: "Aircall",
          description:
            "Initiate and manage voice calls with CRM Aircall integration.",
        },
      ],
    },
    "quickbooks-accouting-tool": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="QuickBooks CRM integrations"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="QuickBooks"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={quickBookLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 22,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          link: "/crm-integrations/xero-accounting-software/",
          badgeText: "Accounting",
          badgeColor: "#2d8cff",
          badgeBackground: "#cee3ff",
          heading: "Xero",
          description:
            "Generate and track quotations with Xero CRM integration.",
        },
      ],
    },
    "google-contacts-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Google Contact Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="google-calender"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={googleContactsLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 17,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          link: "/crm-integrations/microsoft-outlook-contacts-integration",
          badgeText: "Contacts",
          badgeColor: "#f38129",
          badgeBackground: "#fde3d0",
          heading: "Outlook Contacts",
          description:
            "Sync and manage contacts with Outlook Contacts integration.",
        },
      ],
    },
    "google-drive-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Google Drive Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="google-drive"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={googleDriveLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 14,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Data management",
          badgeColor: "#be6e51",
          badgeBackground: "#f1e4e0",
          link: "/crm-integrations/onedrive-integration",
          heading: "OneDrive",
          description:
            "Store and retrieve files on OneDrive with CRM integration.",
        },
      ],
    },
    "onedrive-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="OneDrive integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="OneDrive"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={onedriveLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 8,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Data management",
          badgeColor: "#26c031",
          badgeBackground: "#d8ffdc",
          link: "/crm-integrations/google-drive-integration/",
          heading: "Google Drive",
          description:
            "Store and retrieve documents with Google Drive integration.",
        },
      ],
    },
    "whatsapp-via-twilio": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Twilio API for WhatsApp"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Whatsapp Twilio"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={whatsappTwilioLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 21,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/whatsapp-business-api/",
          heading: "WhatsApp Cloud API",
          description:
            "Easily drive communication using CRM integration with WhatsApp Business Cloud API.",
        },
        {
          id: 27,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Messaging",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "https://peppercloud.com/whatsapp-crm/",
          heading: "WhatsApp CRM",
          description:
            "Sell, supervise, and support with WhatsApp CRM integration.",
        },
      ],
    },
    "google-form": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Best CRM with Google Forms integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="google-forms"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={googleFormsLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 3,
          image: "../images/blue-grad.png",
          backgroundColor: "#f0f0f0",
          link: "/crm-integrations/facebook-lead-gen-ads-form/",
          badgeText: "Lead capture",
          badgeColor: "#c7960b",
          badgeBackground: "#fff2d8",
          heading: "Facebook lead form",
          description:
            "Capture and track leads with Facebook lead form integration.",
        },
      ],
    },
    "shopify-ecommerce-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="CRM Shopify integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Shopify"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={shopifyLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 2,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Inventory management",
          badgeColor: "#26c031",
          badgeBackground: "#cafece",
          link: "/crm-integrations/cin7-dear-inventory/",
          heading: "Dear Systems",
          description:
            "Track sales in real-time with Cin7 (Formerly Dear Inventory) and CRM integration.",
        },
        {
          id: 11,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/linkedin-social-media/",
          heading: "LinkedIn",
          description: "Capture and manage leads via LinkedIn CRM integration.",
        },
      ],
    },
    "google-calendar-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Google Calendar integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="google-calender"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={googleCalendarLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 16,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Calendar",
          badgeColor: "#6a42bd",
          badgeBackground: "#f4e1ff",
          link: "/crm-integrations/office365-calendar-integration",
          heading: "Outlook Calender",
          description:
            "Track upcoming sales activities with Outlook Calendar integration.",
        },
      ],
    },
    "cin7-dear-inventory": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Cin7/Dear Inventory integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Dear_Systems"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={dearSystem}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 19,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/shopify-ecommerce-integration/",
          heading: "Shopify",
          description:
            "Sync, manage, and track orders with CRM Shopify integration.",
        },
        {
          id: 25,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Task management",
          badgeColor: "rgb(11, 173, 167)",
          badgeBackground: "rgb(207, 248, 246)",
          link: "/crm-integrations/project-management-jira-integration",
          heading: "Jira",
          description:
            "Streamline tasks and customer relationships with Jira CRM integration.",
        },
        {
          id: 11,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/linkedin-social-media/",
          heading: "LinkedIn",
          description: "Capture and manage leads via LinkedIn CRM integration.",
        },
      ],
    },
    "linkedin-social-media": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="LinkedIn CRM"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="LinkedIn"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={linkedinLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 2,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Inventory management",
          badgeColor: "#26c031",
          badgeBackground: "#cafece",
          link: "/crm-integrations/cin7-dear-inventory/",
          heading: "Dear Systems",
          description:
            "Track sales in real-time with Cin7 (Formerly Dear Inventory) and CRM integration.",
        },
        {
          id: 19,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/shopify-ecommerce-integration/",
          heading: "Shopify",
          description:
            "Sync, manage, and track orders with CRM Shopify integration.",
        },
      ],
    },
    "project-management-jira-integration": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Best Jira CRM Integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="jira"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={jiraLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 11,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/linkedin-social-media/",
          heading: "LinkedIn",
          description: "Capture and manage leads via LinkedIn CRM integration.",
        },
        {
          id: 19,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/shopify-ecommerce-integration/",
          heading: "Shopify",
          description:
            "Sync, manage, and track orders with CRM Shopify integration.",
        },
        {
          id: 2,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Inventory management",
          badgeColor: "#26c031",
          badgeBackground: "#cafece",
          link: "/crm-integrations/cin7-dear-inventory/",
          heading: "Dear Systems",
          description:
            "Track sales in real-time with Cin7 (Formerly Dear Inventory) and CRM integration.",
        },
      ],
    },
    "google-sheets": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Google Sheet CRM"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="google sheet"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={googleSheetLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 19,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/shopify-ecommerce-integration/",
          heading: "Shopify",
          description:
            "Sync, manage, and track orders with CRM Shopify integration.",
        },
        {
          id: 25,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Task management",
          badgeColor: "rgb(11, 173, 167)",
          badgeBackground: "rgb(207, 248, 246)",
          link: "/crm-integrations/project-management-jira-integration",
          heading: "Jira",
          description:
            "Streamline tasks and customer relationships with Jira CRM integration.",
        },
        {
          id: 11,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Lead generation",
          badgeColor: "#f3296b",
          badgeBackground: "#ffdae6",
          link: "/crm-integrations/linkedin-social-media/",
          heading: "LinkedIn",
          description: "Capture and manage leads via LinkedIn CRM integration.",
        },
      ],
    },
    "krispcall-voip-phone-system": {
      backButtonCard: (
        <>
          <StaticImage
            src="../../images/v2/crm-integration/facebook-rectangle.png"
            alt="Krispcall CRM integration"
            style={{
              width: "100%",
              maxWidth: "344px",
              height: "100%",
              maxHeight: "195px",
              objectFit: "contain",
              overflow: "hidden",
            }}
            className="Group-17887"
          />

          <img
            alt="Best KrispCall (VoIP) CRM integration"
            fit="cover"
            height={50}
            layout="constrained"
            placeholder="blured"
            src={krispcallLogo}
            style={{
              position: "absolute",
              top: "48%",
              left: "48%",
              transform: "translate(-48%, -48%)",
              overflow: "hidden",
              width: "80px",
              height: "80px",
            }}
          />
        </>
      ),
      bottomCards: [
        {
          id: 23,
          image: "https://via.placeholder.com/150",
          backgroundColor: "#f0f0f0",
          badgeText: "Video calling",
          badgeColor: "#26c031",
          badgeBackground: "#cafece",
          link: "/crm-integrations/zoom-meetings-for-video-conferencing/",
          heading: "Zoom",
          description:
            "Schedule and manage video meetings with CRM Zoom integration.",
        },
        {
          id: 1,
          image: "../images/green-grad.png",
          backgroundColor: "#f0f0f0",
          link: "/crm-integrations/aircall-voice-call-integration",
          badgeText: "Calling",
          badgeColor: "#cf2bd5",
          badgeBackground: "#efdbfa",
          heading: "Aircall",
          description:
            "Initiate and manage voice calls with CRM Aircall integration.",
        },
      ],
    },
  };

  const titles = {
    "aircall-voice-call-integration":
      "Initiate and manage voice calls with CRM Aircall integration.",
    "gmail-email-inbox": "Sync and send emails with CRM Gmail integration.",
  };

  // const successStories = {
  //   "aircall-voice-call-integration": {
  //     icon: bannerImg["aircall-voice-call-integration"],
  //     title: titles["aircall-voice-call-integration"],
  //     link: "../crm-integrations/aircall-voice-call-integration",
  //   },
  //   "gmail-email-inbox": {
  //     icon: bannerImg["gmail-email-inbox"],
  //     title: titles["gmail-email-inbox"],
  //     link: "../crm-integrations.js/gmail-email-inbox",
  //   },
  //   "instagram-crm-for-sales": {
  //     icon: bannerImg["instagram-crm-for-sales"],
  //     title: titles["instagram-crm-for-sales"],
  //     link: "../crm-integrations/instagram-crm-for-sales",
  //   },
  //   "telegram-social-media": {
  //     icon: bannerImg["telegram-social-media"],
  //     title: titles["telegram-social-media"],
  //     link: "../crm-integrations/telegram-social-media",
  //   },
  //   "facebook-lead-gen-ads-form": {
  //     icon: bannerImg["facebook-lead-gen-ads-form"],
  //     title: titles["facebook-lead-gen-ads-form"],
  //     link: "../crm-integrations.js/facebook-lead-gen-ads-form",
  //   },
  //   "best-facebook-messenger-crm-integration": {
  //     icon: bannerImg["best-facebook-messenger-crm-integration"],
  //     title: titles["best-facebook-messenger-crm-integration"],
  //     link: "../crm-integrations.js/best-facebook-messenger-crm-integration",
  //   },
  //   "microsoft-outlook-365-integration": {
  //     icon: bannerImg["microsoft-outlook-365-integration"],
  //     title: titles["microsoft-outlook-365-integration"],
  //     link: "../crm-integrations/microsoft-outlook-365-integration",
  //   },
  //   "office365-calendar-integration": {
  //     icon: bannerImg["office365-calendar-integration"],
  //     title: titles["office365-calendar-integration"],
  //     link: "../crm-integrations/office365-calendar-integration",
  //   },
  //   "microsoft-outlook-contacts-integration": {
  //     icon: bannerImg["microsoft-outlook-contacts-integration"],
  //     title: titles["microsoft-outlook-contacts-integration"],
  //     link: "../crm-integrations/microsoft-outlook-contacts-integration",
  //   },
  //   "whatsapp-crm": {
  //     icon: bannerImg["whatsapp-crm"],
  //     title: titles["whatsapp-crm"],
  //     link: "../crm-integrations/whatsapp-crm",
  //   },
  // };

  const caseStudies = {
    "aircall-voice-call-integration": {
      seo: {
        title: "VoIP & Telephony CRM for Cold Calling | Call Center Software",
        keywords:
          "aircall CRM integrations - VOIP, voip crm integration, voip crm, crm phone system integration, call center crm software",
        description:
          "Connect Aircall with Pepper Cloud for one-click dialing, smart call routing, and automatic logging. View real-time caller insights and track team performance with ease.",
        link: "https://peppercloud.com/crm-integrations/aircall-voice-call-integration",
      },
      youtube:
        "https://www.youtube.com/embed/bHdNsjHan3s?si=2m3FfGx-kUvrbBG0&amp;",
      contactLink:
        "https://app.peppercloud.com/?utm_source=Aircall&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Aircall&utm_medium=CTA&utm_campaign=marketplace_internal",
      // title: titles["aircall-voice-call-integration"],
      // description:
      //   "Seamlessly handle both incoming and outgoing calls, easily access caller information, and monitor conversations with CRM Aircall integration..",
      heroBg: case1hero,
      tags: "VoIP CRM integration | CRM phone system integration | CRM for cold calling | Call center CRM software | CRM telephony integration",
      alt: "Best Aircall (VOIP) CRM integrations",
      // name: bannerImg["aircall-voice-call-integration"],
      pageTitle: "Aircall (VOIP) CRM",
      heading: "Best Aircall (VOIP) CRM integrations",
      toptitle: "Initiate and manage voice calls with CRM Aircall integration.",
      topdescription:
        "Elevate your business communication with Aircall CRM integrations, the cutting-edge VoIP (Voice over Internet Protocol) solution that seamlessly connects your phone system with your CRM platform. As a leading VoIP service provider, Aircall offers robust integration capabilities that enhance productivity and customer experience.",
      body: [
        {
          title: "Benefits of Aircall CRM integration - VOIP",
          boldPoints: [
            {
              boldText: "Unified communications:",
              text: "Seamlessly merge your Aircall with CRM and form a single, powerful platform. Eliminate app-switching and streamline your workflow and improve overall efficiency.",
            },
            {
              boldText: "Increased productivity:",
              text: "Access caller information instantly within your CRM through VoIP CRM integration. The immediate availability of data allows your team to focus on meaningful conversations rather than searching for information, significantly boosting productivity.",
            },
            {
              boldText: "Improved customer experience:",
              text: "Personalise interactions with contextual data at your fingertips. By having a complete view of the customer's history, preferences, and previous interactions, you can provide a tailor-made experience that enhances customer satisfaction and loyalty.",
            },
            {
              boldText: "Efficient call routing:",
              text: "Utilise smart workflows to direct calls to the right team members. This ensures that customers are quickly connected to the most appropriate person, reducing wait times and improving first-call resolution rates.",
            },
            {
              boldText: "Comprehensive analytics:",
              text: "Track call metrics and agent performance in real-time through CRM phone system integration. With this data-driven approach, identify areas for improvement and make informed decisions to optimise your call centre operations.",
            },
            {
              boldText: "Automated record-keeping:",
              text: "Capture call recordings and notes effortlessly. This automation reduces manual data entry, ensures accurate documentation, and provides valuable resources for training and quality assurance purposes.",
            },
            {
              boldText: "Enhanced team collaboration:",
              text: "Foster better communication among team members by sharing call logs, notes, and customer information. This collaborative approach ensures consistency in customer interactions and enables smoother handoffs between departments.",
            },
            {
              boldText: "Scalability:",
              text: "As your business grows, the Aircall CRM integration can easily scale with you, accommodating increased call volumes and expanding teams without compromising on performance or functionality.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Aircall integration?",
          description:
            "Pepper Cloud is a VoIP CRM that offers a robust and feature-rich Aircall integration that empowers your sales, support, and pre-sales teams to engage in highly effective, contextually relevant voice conversations. Here's why Pepper Cloud stands out:",
          boldPoints: [
            {
              boldText: "One-click outbound calling:",
              text: "Initiate outbound calls with a simple click, eliminating the need for manually typing phone numbers. Save your time and reduce the risk of dialling errors, and thereby increase your overall efficiency.",
            },
            {
              boldText: "Comprehensive caller overview:",
              text: "Get an instant overview of caller details prior to connecting with your customers. Tailor your response and approach, ensuring personalised and relevant interactions from the moment you answer the call.",
            },
            {
              boldText: "Automatic call logging:",
              text: "Call details such as duration and recordings are automatically logged and associated with the respective customer profiles. This feature of VoIP CRM ensures accurate record-keeping without additional effort from your team.",
            },
            {
              boldText: "Enhanced call documentation:",
              text: "Add notes and tags to calls, keeping a comprehensive history of interactions. This feature allows for detailed tracking of customer conversations, making it easier to provide consistent service across multiple touchpoints.",
            },
            {
              boldText: "Real-time analytics:",
              text: "Analyse your team's call metrics in real-time. This immediate access to performance data enables you to make data-driven decisions quickly, optimising your call centre operations on the fly.",
            },
            {
              boldText: "Intelligent call routing:",
              text: "Predefine call distribution workflows to intelligently route inbound calls to the appropriate teams. This ensures that customers are quickly connected to the right person, improving response times and customer satisfaction.",
            },
            {
              boldText: "Omnichannel follow-up:",
              text: "If calls go unanswered, automatically send a WhatsApp message through the CRM workflow automation. This omnichannel approach ensures that no customer inquiry falls through the cracks, maintaining continuous engagement.",
            },
            {
              boldText: "Seamless CRM integration:",
              text: "Aircall CRM integration is designed to work flawlessly within your existing CRM environment, providing a unified interface for all customer interactions and data management.",
            },
          ],
        },
        {
          title: "How to integrate Aircall with Pepper Cloud CRM?",
          pointers: [
            "Navigate to 'Settings' in Pepper Cloud CRM.",
            "Select 'Integration' from the menu.",
            "Choose the 'Voice Calls' option.",
            "Click on the Aircall integration option.",
            "Follow the authorisation process.",
            "Add a phone number to complete the integration.",
          ],
        },
      ],
      additionalText: "For detailed steps, refer to the",
      IinkText: "Aircall CRM integration - VoIP setup guide",
      url: "https://blog.peppercloud.com/aircall-crm-integration/",
      userCases: {
        heading: "Aircall CRM integration - Applications and use cases",
        body: [
          {
            title: "Sales teams",
            points: [
              "Instantly access prospect information during calls.",
              "Log call outcomes and update deal statuses in real-time.",
              "Set up automatic follow-up tasks based on call results.",
            ],
          },
          {
            title: "Customer support",
            points: [
              "View customer history and previous interactions before answering calls.",
              "Route complex issues to specialised agents seamlessly.",
              "Record and transcribe calls for quality assurance and training.",
            ],
          },
          {
            title: "Outbound marketing",
            points: [
              "Automate calling sequences for efficient campaign management.",
              "Track campaign performance with detailed call analytics.",
              "Adjust scripts in real-time based on call outcomes.",
            ],
          },
          {
            title: "Remote teams",
            points: [
              "Ensure consistent communication quality regardless of location.",
              "Maintain team collaboration with shared call logs and notes.",
              "Monitor team performance and productivity across distributed workforces.",
            ],
          },
          {
            title: "Call centre operations",
            points: [
              "With call centre CRM software, implement advanced IVR systems for efficient call routing.",
              "Analyse call patterns to optimise staffing and resource allocation.",
              "Enhance customer satisfaction with reduced wait times and improved first-call resolution rates.",
            ],
          },
        ],
      },
      about: {
        title: "About Aircall",
        text: "Aircall is a cloud-based phone system and call centre software that integrates seamlessly with popular CRM and helpdesk tools. As a leading VoIP service provider, Aircall offers features such as call queuing and routing, real-time dashboard, analytics and reporting, mobile app for on-the-go access, etc. With its user-friendly interface and robust API, Aircall empowers businesses to enhance their communication capabilities and deliver exceptional customer experiences.",
      },
      faq: {
        title: "Aircall CRM integration FAQs",
        body: [
          {
            question: "How does Aircall CRM integration improve call quality?",
            answer: (
              <>
                As a VoIP provider, Aircall uses advanced technology to ensure
                clear audio and reliable connections, often surpassing
                traditional phone systems in quality. The CRM phone system
                integration also helps by providing access to all customer
                information from a single platform, enhancing the overall call
                experience.
              </>
            ),
          },
          {
            question:
              "Can I transfer calls between team members using Aircall CRM integration?",
            answer: (
              <>
                Yes, Aircall allows for seamless call transfers between team
                members. All relevant CRM data is accessible to the receiving
                agent, ensuring a smooth transition and continuity in customer
                interactions.
              </>
            ),
          },
          {
            question: "How does Aircall handle call recording and storage?",
            answer: (
              <>
                Aircall offers automatic call recording with secure storage.
                These recordings are automatically linked to the caller profile
                and can be easily accessed and managed within Pepper Cloud CRM.
              </>
            ),
          },
          {
            question:
              "What is required for integrating Aircall with the Pepper Cloud CRM?",
            answer: (
              <>
                You need Aircall account credentials and Pepper Cloud CRM
                (Admin) credentials for integration.
              </>
            ),
          },
          {
            question:
              "Can we use multiple contact numbers through Pepper Cloud - VoIP CRM integration?",
            answer: (
              <>
                Yes, you can integrate multiple contact numbers with this VoIP
                CRM. During the Aircall CRM integration process, you can choose
                to include multiple numbers.
              </>
            ),
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/aircall-crm-integration/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Aircall website",
          url: "https://aircall.io/",
        },
      ],
      // heading
      // toptitle
      // topdescription
      // body [{title:"", body:""}]
    },
    "confluence-knowledge-base-software": {
      seo: {
        title:
          "CRM with Confluence Integration - Workflow Automation",
        keywords:
          "Pepper Cloud CRM with Confluence Integration,Confluence Knowledge Base CRM Integration,CRM Knowledge Management System,CRM and Confluence Sync,CRM and Documentation Tool Integration,CRM and knowledge sharing platform",
        description:
          "Connect Confluence to Pepper Cloud CRM for real-time document syncing. Empower sales and support teams to fetch product info, answer chats, and manage access securely.",
        link: "https://peppercloud.com/crm-integrations/aircall-voice-call-integration",
      },
      // youtube:
      //   "https://www.youtube.com/embed/bHdNsjHan3s?si=2m3FfGx-kUvrbBG0&amp;",
      contactLink:
        "https://app.peppercloud.com/?utm_source=Instagram&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Instagram&utm_medium=CTA&utm_campaign=marketplace_internal",
      // title: titles["aircall-voice-call-integration"],
      // description:
      //   "Seamlessly handle both incoming and outgoing calls, easily access caller information, and monitor conversations with CRM Aircall integration..",
      heroBg: case29hero,
      tags: "Knowledge base software | Knowledge management software | Documentation tool | Business management | Team collaboration",
      alt: "CRM with Confluence Knowledge Management System",
      pageTitle: "Confluence",
      heading: "CRM with Confluence integration",
      toptitle:
        "Manage AssistAI knowledge base effortlessly by syncing Confluence pages and spaces with CRM.",
      topdescription:
        "Unlock the full potential of your team with Pepper Cloud CRM seamless integration with Confluence. Centralise your knowledge base, enable real-time data syncing, and empower your support teams, sales professionals, and internal staff with instant access to the information they need—right within the CRM.",
      body: [
        {
          title: "Benefits of CRM and Confluence integration",
          boldPoints: [
            {
              boldText: "Centralised knowledge base:",
              text: "Store and manage the entire Confluence space or chosen pages in one unified platform.",
            },
            {
              boldText: "Improved team efficiency:",
              text: "Reduce search time and enable quick access to relevant information through AssistAI floating icon.",
            },
            {
              boldText: "Automated knowledge syncing:",
              text: "Keep your knowledge base consistently up to date with automatic data flow between Confluence and the CRM.",
            },
            {
              boldText: "Enhanced customer support:",
              text: "Support teams can access Confluence data directly in the CRM, leading to faster query resolution and improved customer satisfaction.",
            },
            {
              boldText: "Seamless collaboration:",
              text: "Foster better teamwork by allowing sales, marketing, and support teams to access and share Confluence resources efficiently.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for Confluence integration?",
          description:
            "Pepper Cloud CRM provides a seamless Confluence integration experience, making knowledge management easier and more effective. Here’s why it stands out:",
          boldPoints: [
            {
              boldText: "Answer to customer queries instantly:",
              text: "Respond to customers with just a click using AssistAI knowledge base. Reduce response time and boost conversions.",
            },
            {
              boldText: "Real-time syncing:",
              text: "Automatically update your CRM knowledge base with the latest Confluence documents, ensuring teams have access to accurate information.",
            },
            {
              boldText: "Quick search and access:",
              text: "Instinctively find information from Confluence pages and spaces within the CRM using the AssistAI panel - no app switching needed.",
            },
            {
              boldText: "User permissions and access control:",
              text: "Define role-based access for your teams, ensuring secure handling of documentation and customer interactions.",
            },
            {
              boldText: "Integration with CRM workflows:",
              text: "Seamlessly automate chatflows by configuring knowledge base with the chatbots. Enhance efficiency and collaboration with ease.",
            },
          ],
        },
        {
          title: "How to integrate Confluence with Pepper Cloud CRM?",
          pointers: [
            "Navigate to 'Settings' and go to 'Integration' in your Pepper Cloud CRM account.",
            "Choose 'Connectors' and click 'Integrate' next to Confluence.",
            "Enter the required authentication details (API key, Email, Domain).",
            "Authorise the connection and grant permission for syncing.",
            "Select the Confluence spaces and pages to be imported into the CRM’s knowledge base.",
          ],
        },
      ],
      // additionalText: "For detailed steps, refer to the",
      // IinkText: "Aircall CRM integration - VoIP setup guide",
      // url: "https://blog.peppercloud.com/aircall-crm-integration/",
      userCases: {
        heading: "Confluence CRM integration - Applications and use cases",
        body: [
          {
            title: "Sales teams",
            points: [
              "Access updated sales materials and product info within CRM.",
              "Enhance customer conversations by referring to Confluence-based knowledge without leaving the CRM.",
              "Refer to templates and proposals directly during sales conversations.",
            ],
          },
          {
            title: "Customer support and success teams",
            points: [
              "Provide instant access to troubleshooting guides, FAQs, and knowledge base articles within Pepper Cloud CRM.",
              "Automate knowledge syncing to ensure support agents always have the latest information.",
              "Improve self-service support by integrating Confluence with CRM and configuring it for chatbots.",
            ],
          },
          {
            title: "IT and product teams",
            points: [
              "Maintain bug logs, API references, and release notes in Confluence, synced to CRM.",
              "Capture and organise feature requests and customer feedback from the CRM in Confluence for streamlined product development.",
              "Automate issue tracking by linking customer-reported problems in the CRM to corresponding Confluence documentation.",
            ],
          },
          {
            title: "HR and operations teams",
            points: [
              "Centralise employee training materials, SOPs, and HR policies within Confluence for seamless onboarding via Pepper Cloud CRM.",
              "Track employee CRM adoption and performance using Confluence dashboards.",
              "Maintain structured internal documentation within Confluence, ensuring easy access for HR and operational workflows.",
            ],
          },
        ],
      },
      about: {
        title: "About Confluence by Atlassian",
        text: "Confluence is a collaborative workspace developed by Atlassian for modern teams to create, organise, and manage content. It offers real-time editing, structured documentation, and powerful search functionality—making it a top choice for centralised knowledge management.",
      },
      faq: {
        title: "CRM with Confluence knowledge base Integration FAQs",
        body: [
          {
            question: "What is CRM and Confluence integration?",
            answer: (
              <>
                It connects your CRM with Confluence to allow seamless knowledge
                access for your chatbot and for your internal team reference.
              </>
            ),
          },
          {
            question: "How does Confluence integration benefit my business?",
            answer: (
              <>
                By integrating Confluence with Pepper Cloud CRM, you can
                centralise knowledge base, automate data syncing, and improve
                response times for customer queries.
              </>
            ),
          },
          {
            question: "Can I sync multiple Confluence spaces with the CRM?",
            answer: (
              <>
                Yes, you can integrate multiple Confluence spaces and choose
                specific pages to sync with your CRM knowledge base.
              </>
            ),
          },
          {
            question: "How frequently does Confluence sync with CRM?",
            answer: (
              <>
                Pepper Cloud CRM syncs with Confluence every 24 hours, ensuring
                your knowledge base stays updated with the latest content.
              </>
            ),
          },
          {
            question: "How do I disconnect Confluence from my CRM?",
            answer: (
              <>
                Navigate to Settings {">"} Integration, locate Confluence, click
                the three dots (⋮), and select Remove to disconnect the
                integration.
              </>
            ),
          },
          {
            question: "Can Confluence knowledge be used in CRM chatbots?",
            answer: (
              <>
                Yes, once synced, Confluence knowledge can be used to power
                chatbot responses and self-service customer support within the
                CRM.
              </>
            ),
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/confluence-crm-integration/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Confluence website",
          url: "https://www.atlassian.com/software/confluence",
        },
      ],
      // heading
      // toptitle
      // topdescription
      // body [{title:"", body:""}]
    },
    "gmail-email-inbox": {
      seo: {
        title: "Gmail Integration with CRM | Sync Emails & Google Workspace",
        description:
          "Turn your Gmail inbox into a sales tool. Connect Pepper Cloud CRM to track email threads, trigger automatic notifications, and access full lead records on the go.",
        keywords:
          "Best crm for gmail, gmail crm, gmail integration, crm gmail integration",
        link: "../crm-integrations/gmail-email-inbox",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Gmail&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Xero&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case2hero,
      tags: "Email inbox | Customer service | Sales productivity | Bulk emailing | Email automation | Google Workspace",
      alt: "Best CRM for Gmail Integration",
      // name: bannerImg["Gmail integration"],
      pageTitle: "Gmail",
      heading: "Best CRM for Gmail integration",
      toptitle: "Sync and send emails with Gmail CRM integration.",
      topdescription:
        "Pepper Cloud is one of the best CRM for Gmail, providing seamless integration that allows you to manage your emails and customer relationship directly from your CRM inbox. With Gmail CRM integration, you can streamline your workflow, boost productivity, and never miss an important customer interaction.",
      body: [
        {
          title: "Benefits of Gmail CRM integration",
          boldPoints: [
            {
              boldText: "Centralised communication:",
              text: "Access all customer emails and CRM data in one place, eliminating the need to switch between multiple platforms. This consolidated view ensures that you never miss important customer interactions or context.",
            },
            {
              boldText: "Time-saving:",
              text: "With CRM Gmail integration, you can significantly reduce the time spent on data entry and email management. Automated logging of emails and contacts means less manual work and more time for high-value tasks.",
            },
            {
              boldText: "Enhanced productivity:",
              text: "With all your customer data at your fingertips within Gmail, you can respond to inquiries faster and more effectively. Quick access to customer history, preferences, and past interactions allows for more personalised communication.",
            },
            {
              boldText: "Improved customer insights:",
              text: "Gmail CRM integration provides a 360-degree view of your customers. By capturing all email interactions automatically, you can gain deeper insights into customer behaviour, preferences, and pain points, enabling you to serve them better.",
            },
            {
              boldText: "Data accuracy:",
              text: "Automated syncing between Gmail and your CRM reduces the risk of human error in data entry. This ensures that your customer data is always up-to-date and accurate across all platforms.",
            },
            {
              boldText: "Mobile accessibility:",
              text: "Access your CRM data and Gmail integration features on-the-go, allowing you to stay productive even when you're out of the office.",
            },
            {
              boldText: "Improved email marketing:",
              text: "Leverage CRM data to create more targeted and personalised email campaigns directly from Gmail, increasing the effectiveness of your marketing efforts.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for Gmail integration?",
          boldPoints: [
            {
              boldText: "Seamless two-way sync:",
              text: "Pepper Cloud offers real-time, bidirectional synchronisation between Gmail and your CRM. This ensures that your data is always up-to-date in both platforms, eliminating the need for manual updates and reducing the risk of working with outdated information.",
            },
            {
              boldText: "User-friendly interface:",
              text: "Our intuitive interface makes it easy to navigate between your emails and CRM data. The seamless integration feels like a natural extension of Gmail, reducing the learning curve and increasing adoption rates among team members.",
            },
            {
              boldText: "Capture leads and contacts:",
              text: "Pepper Cloud allows you to capture the email senders as leads or contacts directly from Gmail inbox with just a click. It avoids app switching and ensures no leads slip away.",
            },
            {
              boldText: "Powerful Chrome extension:",
              text: "Pepper Cloud Gmail Chrome extension brings CRM functionality directly into your Gmail inbox. View customer details, update records, and perform CRM actions without leaving your email interface, streamlining your workflow and saving valuable time.",
            },
            {
              boldText: "Comprehensive contact management:",
              text: "Easily import and manage your Gmail contacts within Pepper Cloud CRM. Pepper Cloud CRM system automatically highlights the duplicate records and allows for easy merging of records, keeping your database clean.",
            },
            {
              boldText: "Email automation:",
              text: "Streamline your email workflows by setting up triggers and sending automated follow-up emails to leads or email notifications to users. With this feature, you can define specific actions or conditions, such as a customer signing up for a newsletter or abandoning a shopping cart, that will automatically initiate an email response.",
            },
            {
              boldText: "Scalability:",
              text: "As your business grows, Pepper Cloud's Gmail integration scales with you. Our flexible system can handle increasing volumes of data and users, making it an ideal solution for businesses of all sizes.",
            },
            {
              boldText: "Excellent customer support:",
              text: "Our dedicated support team is always ready to assist you with any questions or issues. We offer comprehensive documentation, video tutorials, and personalised support to ensure you get the most out of your Gmail CRM integration.",
            },
          ],
        },
        {
          title: "How to integrate Gmail with Pepper Cloud CRM?",
          pointers: [
            "Log in to your Pepper Cloud CRM account.",
            "Click on your profile image and select 'User Settings'.",
            "Navigate to the 'Integration' tab on the left side.",
            "Click the 'Integrate' button in the 'Email' box.",
            "Follow the prompts to authorise Pepper Cloud to access your Gmail account.",
            "Customise your sync settings and field mappings.",
          ],
        },
      ],
      userCases: {
        heading: "Gmail CRM integration - Application and use cases",
        body: [
          {
            title: "Sales teams:",
            points: [
              "Track email conversations with leads and prospects.",
              "Set reminders for follow-ups directly from Gmail.",
              "Access deal information while composing emails.",
              "Log calls and meetings automatically.",
            ],
          },
          {
            title: "Customer support:",
            points: [
              "View customer history and previous interactions while responding to emails.",
              "Assign and track support tickets from Gmail.",
              "Collaborate with team members on complex issues.",
              "Monitor response times and customer satisfaction.",
            ],
          },
          {
            title: "Marketing teams:",
            points: [
              "Segment email lists based on CRM data.",
              "Track email campaign performance within the CRM.",
              "Personalise email content using CRM fields.",
              "Automate follow-up sequences based on email interactions.",
            ],
          },
          {
            title: "Project management:",
            points: [
              "Link emails to specific projects or tasks.",
              "Share project updates with clients directly from Gmail.",
              "Track billable hours based on email communication.",
              "Manage project timelines and deadlines within the CRM.",
            ],
          },
          {
            title: "Recruitment:",
            points: [
              "Organise candidate communications in one place.",
              "Schedule interviews and send automated email follow-ups.",
              "Track applicant status throughout the hiring process.",
              "Collaborate with hiring managers on candidate evaluations.",
            ],
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/email-integration-with-crm/#connect-your-gmail-and-outlook-with-pepper-cloud-crm",
        },
        {
          title: "Chrome extension",
          url: "https://chromewebstore.google.com/detail/pepper-cloud-crm-chrome-e/iccmmindhfioainhgehkhdcmapohogff?pli=1",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Gmail website",
          url: "https://www.google.com/intl/en_in/gmail/about/",
        },
      ],
      about: {
        title: "About Gmail",
        text: "Gmail is a free email service provided by Google. It offers users up to 15 GB of storage, spam filtering, and seamless integration with other Google services. With over 1.8 billion active users worldwide, Gmail is one of the most popular email platforms for both personal and business use.",
      },
      faq: {
        title: "Gmail CRM FAQs",
        body: [
          {
            question: "Is Pepper Cloud the best CRM for Gmail integration?",
            answer:
              "While there are many options available, Pepper Cloud offers one of the best CRM integrations for Gmail, providing a seamless experience and powerful features to enhance your productivity.",
          },
          {
            question: "How does Gmail CRM integration improve my workflow?",
            answer:
              "Gmail CRM integration allows you to manage customer relationships, track communications, and access important data without leaving your CRM platform, significantly streamlining your workflow.",
          },
          {
            question: "Is my data secure when using Gmail CRM integration?",
            answer:
              "Pepper Cloud prioritises data security and uses encryption and secure servers to protect your information. We also comply with data protection regulations to ensure your peace of mind.",
          },
          {
            question: "How often does the Gmail CRM integration sync data?",
            answer:
              "Pepper Cloud's Gmail integration offers real-time, two-way syncing to ensure your data is always up-to-date on both platforms.",
          },
          {
            question: "Can I send emails from CRM?",
            answer:
              "Yes, you can send emails from CRM. The sent emails will be automatically logged into your Gmail inbox as well.",
          },
        ],
      },
      additionalText: "Start enjoying the benefits of Gmail CRM integration!",
    },
    "instagram-crm-for-sales": {
      seo: {
        title:
          "CRM with Instagram integration | Pepper Cloud",
        keywords:
          "best crm for instagram, instagram crm, crm for instagram, integrate instagram, best crm for instagram",
        description:
          "Convert Instagram DMs into CRM leads in one click. Pepper Cloud CRM auto-syncs chat history, lets reps send saved templates, and moves deals down the pipeline.",
        link: "../crm-integrations/instagram-crm-for-sales",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Instagram&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Instagram&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case3hero,
      tags: "Customer support | Bot & messaging | Instant messaging | Social media integration",
      alt: "Best CRM for Instagram integration",
      // name: bannerImg["instagram-crm-for-sales"],
      pageTitle: "Instagram",
      heading: "Best CRM for Instagram integration",
      toptitle: "Close deals quickly on Instagram with CRM.",
      topdescription:
        "Drive business success by connecting with your customers through the best CRM for Instagram. Effectively handle leads, track conversations, and seal deals seamlessly from a unified platform.",
      body: [
        {
          title: "Benefits of Instagram CRM integration",
          boldPoints: [
            {
              boldText: "Centralised data management:",
              text: "Integrate the best CRM for Instagram to keep all customer interactions in one place.",
            },
            {
              boldText: "Enhanced customer insights:",
              text: "Gain a 360-degree view of your customers' social media behaviour and preferences.",
            },
            {
              boldText: "Improved engagement:",
              text: "Respond to messages quickly and more efficiently, boosting customer loyalty and satisfaction.",
            },
            {
              boldText: "Targeted marketing:",
              text: "Use Instagram data to send personalised promotions and create targeted campaigns.",
            },
            {
              boldText: "Performance tracking:",
              text: "Monitor key metrics alongside other business KPIs for comprehensive reporting.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for Instagram integration?",
          description:
            "Pepper Cloud stands out as the best CRM for Instagram integration, offering a seamless experience for businesses of all sizes. Here's why:",
          boldPoints: [
            {
              boldText: "Capture leads with just a click:",
              text: "Convert message senders into qualified leads without manual data entry. Create detailed customer profiles based on Instagram interactions and engagement.",
            },
            {
              boldText: "Real-time syncing:",
              text: "Stay on top of your conversations with effortless real-time synchronisation. Every interaction on Instagram is automatically logged as it happens, so your team always has the latest information at their fingertips.",
            },
            {
              boldText: "Reply quickly with message templates:",
              text: "Design and save customisable message templates directly within the CRM. Quickly respond to common queries and FAQs on Instagram with premade templates.",
            },
            {
              boldText: "Effortlessly share media files:",
              text: "Easily share multimedia files by effortlessly inserting images, audio clips, and videos directly into your direct messages. Make your conversations more engaging, interactive, and dynamic.",
            },
            {
              boldText: "Track key performance indicators:",
              text: "Generate detailed reports on response times and resolution rates. Identify top-performing agents and areas for improvement in Instagram customer service.",
            },
            {
              boldText: "360-degree view of customer:",
              text: "Gain a comprehensive understanding of your customers. Access full conversation histories and complete profiles of customers. Engage in contextually relevant conversations and deliver personalised communication.",
            },
            {
              boldText: "Omnichannel communication hub:",
              text: "Connect with your customers everywhere with Pepper Cloud omnichannel feature. Integrates Instagram and other channels right into your CRM to provide a seamless customer experience across all platforms.",
            },
          ],
        },
        {
          title: "How to integrate Instagram with Pepper Cloud CRM?",
          pointers: [
            "Navigate to settings and go to “Integration”",
            " Choose “Channels” and click “Integrate”.",
            "Click “Create New” to create a channel.",
            "Add the required details and integrate the Instagram channel.",
          ],
        },
      ],
      additionalText: "For detailed steps, refer to the",
      IinkText: "Instagram setup guides",
      url: "https://blog.peppercloud.com/integrate-instagram-with-pepper-cloud-crm/",
      userCases: {
        heading: "Instagram CRM integration - Applications and use cases",
        body: [
          {
            title: "Instagram CRM for sales team",
            points: [
              "Automatically add Instagram leads to the sales pipeline with just a click.",
              "Empower sales reps to have personalisedcommunication by providing them with complete conversation history and customer preferences.",
              "Track and nurture relationships through Instagram direct messages.",
            ],
          },
          {
            title: "Instagram CRM for marketing team",
            points: [
              "Personalise conversations by sending customized marketing message templates, deals, and discounts.",
              "Based on customers' conversations and their interests, share relevant offers and find opportunities to upsell or cross-sell.",
              "Leverage customer data and insights from interactions to segment audiences and create targeted marketing campaigns.",
            ],
          },
          {
            title: "Instagram CRM for support team",
            points: [
              "Manage Instagram direct messages as support tickets by creating tasks and assigning them to the right team member.",
              "Track response times, resolution times, and other key metrics to monitor customer satisfaction.",
              "Use quick replies to respond instantly to customer queries, frequently asked questions, and more.",
            ],
          },
          {
            title: "Instagram CRM for remote team",
            points: [
              "Empower your team members to seamlessly collaborate on sales activities and channel management.",
              "Share complete or limited access to conversations and messages by defining user permissions.",
              "Assign chats to individual team members and provide the right support at the right time.",
            ],
          },
          {
            title: "Instagram CRM for Managers",
            points: [
              "Define access to control who can view, respond to, and manage conversations, ensuring only authorized personnel handle customer inquiries.",
              "Empower managers to create tasks associated with Instagram messages and assign them to the right team member.",
              "Managers can keep track of individual performances and team members with a visual message dashboard.",
            ],
          },
        ],
      },
      about: {
        title: "About Instagram",
        text: "As a leading social media platform, Instagram offers immense opportunities for businesses to increase brand visibility, engagement, and revenue. With over 1 billion active users, Instagram presents a vast audience for businesses to target. Users can engage with the followers by responding to comments, hashtags, and direct messages.",
      },
      faq: {
        title: "Instagram CRM integration FAQs",
        body: [
          {
            question: "What is Instagram CRM integration?",
            answer: (
              <>
                Instagram CRM integration is the integration between your
                Instagram account and customer relationship management system
                (such as Pepper Cloud CRM). It allows for seamless data flow and
                management of interactions within your CRM platform.
              </>
            ),
          },
          {
            question: "How can Instagram CRM integration benefit my business?",
            answer: (
              <>
                By integrating Instagram with your CRM, you can centralize
                customer data, improve engagement, automatically capture leads,
                and gain valuable insights into your audience's behaviour.
              </>
            ),
          },
          {
            question: "Is Pepper Cloud the best CRM for Instagram integration?",
            answer: (
              <>
                Pepper Cloud offers a robust and user-friendly Instagram CRM
                integration, making it an excellent choice for businesses to
                engage effectively with their customers. It assists in auto-lead
                capture, personalisedconversations, monitoring conversations,
                and more.
              </>
            ),
          },
          {
            question: "How often does the CRM sync with Instagram?",
            answer: (
              <>
                The frequency of synchronization can vary depending on the CRM
                system. Pepper Cloud offers real-time syncing to ensure you
                always have the most up-to-date information at your fingertips.
              </>
            ),
          },
          {
            question:
              "How to get the blue tick on the Instagram business account?",
            answer: (
              <>
                For this, you need to verify your business on Instagram. Here
                are a few quick steps:
                <ul>
                  <li>Go to your profile and tap settings.</li>
                  <li>Click the account and then request verification.</li>
                  <li>Fill out the form and submit it for review.</li>
                </ul>
                Here are the detailed instructions for getting a{" "}
                <a href="https://help.instagram.com/369148866843923/?helpref=uf_share&ref=blog.peppercloud.com">
                  blue tick on the Instagram business account
                </a>
                .
              </>
            ),
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/integrate-instagram-with-pepper-cloud-crm/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Instagram website",
          url: "https://www.instagram.com/",
        },
      ],
    },
    "telegram-social-media": {
      seo: {
        title:
          "CRM with Telegram Integration | Pepper Cloud",
        description:
          "Manage Telegram customer chats directly inside Pepper Cloud CRM. Send document attachments, videos, and resolve issues fast.",
        keywords:
          "telegram crm integration, integrate Telegram, integration with telegram, telegram integrations, telegram crm",
        link: "../crm-integrations/telegram-social-media",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Telegram&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Telegram&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case4hero,
      tags: "Customer support | Bot & messaging | Instant messaging | Social media integration",
      alt: "Telegram CRM integration",
      // name: bannerImg["telegram-social-media"],
      pageTitle: "Telegram",
      heading: "Best Telegram CRM integration",
      toptitle:
        "Effortlessly convert your Telegram leads with the best Telegram CRM integration.",
      topdescription:
        "Boost your customer communication with native Telegram CRM integration. Connect with your customers in real-time on Telegram and manage leads, conversations, and customer relationships effectively through your CRM.",
      body: [
        {
          title: "Benefits of Telegram CRM integration",
          boldPoints: [
            {
              boldText: "Instant access to customer conversations:",
              text: "Access all your Telegram messages directly within your CRM, eliminating the need to switch between apps.",
            },
            {
              boldText: "Auto lead capture:",
              text: "Automatically convert Telegram enquiries into CRM leads, ensuring no potential customer is missed and saving time on manual data entry.",
            },
            {
              boldText: "Improved team collaboration:",
              text: "Assign Telegram message threads to team members for better coordination and ensure each enquiry is handled by the right person.",
            },
            {
              boldText: "Enhanced customer experience:",
              text: "Leverage Telegram's speed and security for quicker, more secure support, enhancing customer satisfaction, and accelerating query resolution.",
            },
            {
              boldText: "Searchable business profiles:",
              text: "Organise and categorise conversations with customisable tags and labels for quick and easy retrieval of specific customer interactions.",
            },
            {
              boldText: "Seamless file sharing:",
              text: (
                <>
                  Use telegram integrations to easily exchange documents, media,
                  and files without leaving the CRM interface, keeping all
                  customer-related information in one place.
                </>
              ),
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Telegram integration?",
          description:
            "Pepper Cloud excels as the top Telegram CRM with its seamless integration and robust features:",
          boldPoints: [
            {
              boldText: "Native integration:",
              text: "Pepper Cloud offers a built-in Telegram integration, ensuring seamless connectivity.",
            },
            {
              boldText: "Telegram bot configuration:",
              text: "Set up your Telegram bot directly within the CRM for instant integration.",
            },
            {
              boldText: "Conversation categorisation:",
              text: "Organise Telegram chats using tags and assign them to team members.",
            },
            {
              boldText: "Comprehensive communication:",
              text: "Exchange a wide range of file types, including documents, videos, and GIFs.",
            },
            {
              boldText: "Scalable solution:",
              text: "Manage high-volume Telegram conversations with Pepper Cloud's robust capabilities.",
            },
            {
              boldText: "Unparalleled support:",
              text: "Access our team of experts for guidance on leveraging Telegram CRM integration for your business.",
            },
          ],
        },
        {
          title: "How to integrate Telegram with Pepper Cloud CRM?",
          pointers: [
            "Start by searching for BotFather on Telegram.",
            "Send the command /newbot and answer the queries.",
            "Give a name to the bot and provide a username.",
            "Obtain its token by using the /mybots command.",
            "Create a Telegram channel in the CRM and paste the token.",
            "Enter details to complete the integration.",
          ],
        },
      ],
      userCases: {
        heading: "Telegram CRM integration - Application and use cases",
        body: [
          {
            title: "Customer support:",
            points: [
              "Provide instant responses to customer enquiries via Telegram.",
              "Assign message threads to specific support agents for personalised assistance.",
              "Share files and documents to help resolve customer issues more efficiently.",
            ],
          },
          {
            title: "Lead generation and nurturing:",
            points: [
              "Capture Telegram enquiries and automatically convert them into CRM leads.",
              "Engage with potential customers using predefined message templates.",
              "Nurture leads through targeted communications and follow-ups.",
            ],
          },
          {
            title: "Sales enablement:",
            points: [
              "Access customer information and conversation history within the CRM.",
              "Coordinate sales efforts by assigning Telegram threads to the appropriate team members.",
              "Leverage Telegram's speed and security to build trust and close deals faster.",
            ],
          },
          {
            title: "Marketing campaigns:",
            points: [
              "Create Telegram groups and channels to send content and updates.",
              "Segment your audience based on their Telegram engagement and interactions.",
              "Measure the effectiveness of your Telegram-based marketing initiatives.",
            ],
          },
          {
            title: "Internal communication:",
            points: [
              "Establish Telegram groups for team coordination and collaboration.",
              "Share files, documents, and updates within the secure Telegram environment.",
              "Integrate Telegram communication seamlessly with your CRM workflows.",
            ],
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/integrating-telegram-with-crm/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Telegram website",
          url: "https://telegram.org/",
        },
      ],
      about: {
        title: "About Telegram",
        text: "Telegram is a cloud-based instant messaging app known for its focus on speed, security, and user-friendliness. With its robust features, including end-to-end encryption, file sharing, and bot integration, Telegram has become a popular communication platform for businesses and individuals alike. By integrating Telegram with your CRM system, you can leverage the platform's strengths to enhance customer engagement, streamline internal workflows, and drive business growth.",
      },
      faq: {
        title: "Telegram CRM integration FAQs",
        body: [
          {
            question: "What is Telegram CRM integration with Pepper Cloud?",
            answer: (
              <>
                Telegram CRM integration allows you to connect and manage your
                Telegram communication directly within Pepper Cloud CRM,
                enhancing your customer relationship management and team
                collaboration.
              </>
            ),
          },
          {
            question:
              "Can I use Telegram CRM integration for both internal team communication and customer interactions?",
            answer: (
              <>
                Yes, you can use it to manage internal discussions within
                Telegram groups and handle customer interactions through direct
                messages, all within the CRM platform.
              </>
            ),
          },
          {
            question:
              "Can I integrate multiple Telegram accounts or groups into the CRM?",
            answer: (
              <>
                Yes, you can integrate multiple Telegram accounts and groups
                into the CRM, allowing for comprehensive management of different
                communication channels.
              </>
            ),
          },
          {
            question:
              "Is a phone number required for Telegram CRM integration?",
            answer: (
              <>
                While a phone number is not directly needed for the integration
                itself, you do need it to set up a Telegram account, which is
                the essential first step for integrating Telegram with the CRM.
              </>
            ),
          },
          {
            question:
              "Are there any additional costs for using Telegram CRM integration?",
            answer: (
              <>
                The cost of Telegram CRM integration may vary based on your CRM
                subscription plan.{" "}
                <a href="https://peppercloud.com/contact/">
                  Contact our support team
                </a>{" "}
                to get detailed information about pricing and any potential
                additional fees.
              </>
            ),
          },
        ],
      },
      additionalText:
        "For a more detailed setup guide, please refer to our comprehensive",
      IinkText: " Telegram CRM integration documentation",
      url: "https://blog.peppercloud.com/integrating-telegram-with-crm/",
    },
    "facebook-lead-gen-ads-form": {
      seo: {
        title: "Connect Facebook Lead Ads to Pepper Cloud CRM",
        keywords:
          "best crm for facebook leads, facebook lead generation ads, facebook lead form, facebook lead generation, facebook lead ads integration",
        description:
          "Pepper Cloud CRM automatically captures Facebook lead ad submissions in real time. Send fast auto-replies, track campaign performance, and assign deals to your team.",
        link: "https://peppercloud.com/crm-integrations/facebook-lead-gen-ads-form/",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Facebook_lead_form&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Facebook_lead_form&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case5hero,
      tags: "Lead capture | Lead generation | Lead gen web form | Lead generation software | Facebook lead ads",
      alt: "Best CRM for Facebook leads form integration",
      pageTitle: "Facebook leads",
      // name: bannerImg["facebook-lead-gen-ads-form"],
      heading: "Best CRM for Facebook leads form integration",
      toptitle:
        "Capture and track leads using the best CRM for Facebook leads form integration.",
      topdescription:
        "Experience seamless lead management with Pepper Cloud - the best CRM for Facebook Leads Form Integration . Eliminate manual data entry and auto-capture leads for unparalleled convenience.",
      body: [
        {
          title: "Benefits of Facebook lead form CRM integration",
          boldPoints: [
            {
              boldText: "Instant lead capture:",
              text: "Automatically import leads from Facebook ads into your CRM in real-time, ensuring no delay.",
            },
            {
              boldText: "Elimination of manual data entry:",
              text: "Automate the lead import process to save time and reduce the risk of errors.",
            },
            {
              boldText: "Improved lead response time:",
              text: "Quickly follow up with leads while they are still interested.",
            },
            {
              boldText: "Enhanced data accuracy:",
              text: "Ensure accurate capture and storage of all lead information in your CRM.",
            },
            {
              boldText: "Seamless campaign tracking:",
              text: "Monitor Facebook lead generation ad performance directly from your CRM.",
            },
            {
              boldText: "Comprehensive lead insights:",
              text: "Access detailed lead information, including ad source and campaign data, in one place, providing a holistic view.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Facebook lead ad integration?",
          description:
            "Pepper Cloud stands out as the top CRM for Facebook lead ad integration, providing effortless connectivity and powerful features that distinguish it from the rest:",
          boldPoints: [
            {
              boldText: "User-friendly interface:",
              text: "Easily set up and manage your Facebook lead ad integrations.",
            },
            {
              boldText: "Customisable field mapping:",
              text: "Match Facebook form fields to your CRM fields for tailored data collection.",
            },
            {
              boldText: "Multi-form support:",
              text: "Connect multiple Facebook lead ad forms to your CRM effortlessly.",
            },
            {
              boldText: "Real-time syncing:",
              text: "Capture leads instantly as they submit Facebook lead forms.",
            },
            {
              boldText: "Advanced filtering:",
              text: "Quickly search and organise leads based on various criteria.",
            },
            {
              boldText: "Automated lead nurturing:",
              text: "Set up workflows to engage new leads automatically.",
            },
            {
              boldText: "Comprehensive support:",
              text: "Access expert guidance to maximise your Facebook lead generation efforts.",
            },
          ],
        },
        {
          title:
            "How to integrate Facebook lead generation forms with Pepper Cloud CRM?",
          pointers: [
            "In CRM settings navigate to “Integration”.",

            "Choose Facebook from the social integrations page.",

            "Create and  connect a new Facebook page.",

            "Choose the Facebook page to capture leads and complete the integration by submitting.",
          ],
        },
      ],
      userCases: {
        heading:
          "Facebook lead form CRM integration- Application and use cases",
        body: [
          {
            title: "Real estate lead generation:",
            points: [
              "Capture potential homebuyer information through Facebook lead ads.",
              "Automatically assign leads to agents based on property interests.",
              "Set up automated email sequences with relevant property listings.",
            ],
          },
          {
            title: "E-commerce customer acquisition:",
            points: [
              "Collect leads interested in specific product categories.",
              "Trigger personalised product recommendation emails based on form responses.",
              "Track lead-to-customer conversion rates for different ad campaigns.",
            ],
          },
          {
            title: "Event registration:",
            points: [
              "Use Facebook lead generation ads to promote upcoming events.",
              "Automatically add registrants to event-specific mailing lists in your CRM.",
              "Send automated event reminders and follow-ups based on registration data.",
            ],
          },
          {
            title: "Educational institution recruitment:",
            points: [
              "Capture prospective student information through targeted lead ads.",
              "Segment leads based on program interests and automate relevant follow-ups.",
              "Track application progress and conversions from the initial lead to enrollment.",
            ],
          },
          {
            title: "B2B lead qualification:",
            points: [
              "Use Facebook lead forms to collect business-specific information.",
              "Automatically score and route leads to appropriate sales team members.",
              "Trigger tailored nurturing campaigns based on industry or company size.",
            ],
          },
          {
            title: "Service industry appointment booking:",
            points: [
              "Capture lead information and service interests through Facebook ads.",
              "Automatically schedule follow-up calls or send appointment booking links.",
              "Track conversion rates from lead capture to service booking.",
            ],
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/how-to-import-facebook-ad-leads-into-crm/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Facebook lead ads",
          url: "https://www.facebook.com/business/ads/lead-ads",
        },
      ],
      about: {
        title: "About Facebook lead generation form",
        text: "Facebook lead forms, also known as Facebook lead ads, are a robust solution for businesses seeking to gather lead information directly on the Facebook platform. They offer a streamlined experience by allowing users to submit contact details and other relevant data without leaving Facebook. Featuring pre-filled fields and a mobile-optimised design, these forms enhance the user experience and drive higher conversion rates. When integrated with a CRM like Pepper Cloud, this process becomes even more powerful. It ensures that leads are instantly captured and synced in your CRM, allowing for efficient management and automated nurturing.",
      },
      faq: {
        title: "Facebook lead form CRM FAQs",
        body: [
          {
            question:
              "What is Facebook lead form integration with Pepper Cloud CRM?",
            answer:
              "Facebook lead form integration with Pepper Cloud CRM allows businesses to automatically import and manage leads collected from Facebook ads directly within their CRM system.",
          },
          {
            question:
              "Can I customise which lead data is imported into Pepper Cloud CRM?",
            answer:
              "Yes, you can map Facebook lead form fields to corresponding CRM fields, ensuring that relevant data is imported and organised according to your needs.",
          },
          {
            question:
              "How does real-time syncing work with Facebook lead forms and Pepper Cloud CRM?",
            answer:
              "Real-time syncing means that leads submitted through Facebook forms are immediately captured and updated in Pepper Cloud CRM, allowing for instant follow-up.",
          },
          {
            question:
              "What should I do if leads are not appearing in my Pepper Cloud CRM?",
            answer: (
              <>
                Check your integration settings and field mappings to ensure
                they are correctly configured. If issues persist, consult the{" "}
                <a href="https://peppercloud.com/contact/">CRM support team</a>{" "}
                for assistance.
              </>
            ),
          },
          {
            question:
              "Can I manage multiple Facebook lead forms with Pepper Cloud CRM?",
            answer:
              "Yes, Pepper Cloud CRM supports integration with multiple Facebook lead forms, allowing you to manage and track leads from various campaigns efficiently.",
          },
          {
            question:
              "Is there a way to automate lead follow-up with Pepper Cloud CRM?",
            answer:
              "Yes, you can set up automated workflows in Pepper Cloud CRM to engage and nurture leads automatically based on predefined triggers and conditions.",
          },
        ],
      },
      additionalText:
        "For a more detailed setup guide, please refer to our comprehensive",
      IinkText: " Facebook lead form setup guide",
      url: "https://blog.peppercloud.com/how-to-import-facebook-ad-leads-into-crm/",
    },
    "best-facebook-messenger-crm-integration": {
      seo: {
        title:
          "CRM Software With Facebook & Messenger Integration",
        keywords:
          "facebook messenger crm intergation, facebook crm tool, facebook messenger integration, integrate with facebook, best crm for facebook, crm for facebook messenger",
        description:
          "Handle Facebook Messenger chats inside Pepper Cloud CRM. Auto-capture leads, use AI message summaries, assign conversations to teammates, and track team response times.",
        link: " https://peppercloud.com/crm-integrations/best-facebook-messenger-crm-integration",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=FB+Messenger&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=FB+Messenger&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case6hero,
      tags: "Customer support | Bot & messaging | Instant messaging | Social media integration",
      alt: "Best Facebook Messenger CRM integration",
      pageTitle: "Facebook Messenger",
      // name: bannerImg["best-facebook-messenger-crm-integration"],
      heading: "Best Facebook Messenger CRM integration",
      toptitle: "Manage chats with Facebook CRM integration.",
      topdescription:
        "Boost engagement with the seamless Facebook Messenger CRM integration. Manage Facebook business communication without switching between apps. Send and receive Facebook messages, including text, media, and files, directly from the CRM.",
      body: [
        {
          title: "Benefits of Facebook Messenger CRM integration",
          boldPoints: [
            {
              boldText: "Centralised communication:",
              text: "Manage all your Facebook Messenger conversations directly within your CRM.",
            },
            {
              boldText: "Lead generation:",
              text: "Automatically capture and convert Facebook leads into your CRM.",
            },
            {
              boldText: "Team collaboration:",
              text: "Assign conversations to team members for quick and efficient responses.",
            },
            {
              boldText: "Personalised messaging:",
              text: "Send tailored message templates to enhance customer engagement.",
            },
            {
              boldText: "Multi-media support:",
              text: "Share audio files, videos, documents, and emojis directly from your CRM.",
            },
            {
              boldText: "Comprehensive customer view:",
              text: "Access a complete history of customer interactions in one place.",
            },
          ],
        },
        {
          title: "Why Choose Pepper Cloud for Facebook Messenger integration?",
          description:
            "Pepper Cloud stands out as the best CRM for Facebook Messenger, offering a top-tier Facebook Messenger CRM integration experience. Here is why Pepper Cloud is the best CRM for Facebook Messenger integration:",
          boldPoints: [
            {
              boldText: "Seamless real-time synchronisation:",
              text: "All Facebook Messenger interactions are automatically logged in real-time, ensuring your team always has the most up-to-date information.",
            },
            {
              boldText: "User-friendly interface:",
              text: "Easily navigate and manage conversations within the familiar CRM environment as the intuitive design mirrors the familiar Messenger layout.",
            },
            {
              boldText: "Advanced analytics and reporting:",
              text: "Get visual insights into the conversation trends. Track the number of messages received, the response time, resolution time, and more with the CRM dashboard.",
            },
            {
              boldText: "AI-powered chatbot, AssistAI:",
              text: "Use AssistAI to summarise conversations, ensuring you quickly understand key points without reading through entire exchanges. Rephrase responses for clarity, and easily modify replies to suit different contexts and needs.",
            },
            {
              boldText: "Omnichannel communication hub:",
              text: "Integrate Facebook Messenger alongside other communication channels and provide a consistent customer experience across all platforms.",
            },
            {
              boldText: "Auto capture leads:",
              text: "Streamline your lead generation process with automatic capture of leads and contacts from Facebook Messenger. This feature ensures that every interaction on your Facebook page is tracked, and relevant contact information is automatically added to your CRM system.",
            },
            {
              boldText: "Comprehensive customer view:",
              text: "Gain a complete, 360-degree view of each customer with detailed insights, including their Messenger interaction history. This feature allows you to access all relevant information about a customer in one place, making it easier to personalise conversations.",
            },
          ],
        },
        {
          title: "How to integrate Facebook Messenger with Pepper Cloud CRM?",
          pointers: [
            "Navigate to 'Integration' in CRM settings.",
            "Create a new channel.",
            "Connect to Facebook Messenger.",
            "Log in to Facebook Messenger accounts and choose the Facebook page for integration.",
            "Fill in your channel details and complete the integration process.",
          ],
        },
      ],
      userCases: {
        heading:
          "Facebook Messenger CRM integration - Applications and use cases",
        body: [
          {
            title: "E-commerce",
            points: [
              "Provide instant customer support for order inquiries.",
              "Send personalised product recommendations based on customer preferences.",
              "Automate order status updates through Messenger.",
            ],
          },
          {
            title: "Real Estate",
            points: [
              "Schedule property viewings directly through Messenger.",
              "Share property listings and virtual tours with potential buyers.",
              "Provide instant answers to frequently asked questions about listings.",
            ],
          },
          {
            title: "Healthcare",
            points: [
              "Allow patients to book appointments via Messenger.",
              "Send appointment reminders and follow-up messages.",
              "Provide general health information and FAQs through automated responses.",
            ],
          },
          {
            title: "Education",
            points: [
              "Offer course information and enrollment assistance.",
              "Provide student support and answer queries about programs.",
              "Send reminders about upcoming classes or deadlines.",
            ],
          },
          {
            title: "Hospitality",
            points: [
              "Enable hotel bookings and reservations through Messenger.",
              "Provide virtual concierge services for guests.",
              "Share local attractions and respond to guest inquiries in real-time.",
            ],
          },
          {
            title: "Finance and Banking",
            points: [
              "Offer basic account information and balance inquiries via Messenger.",
              "Provide loan application status updates.",
              "Share financial tips and product information.",
            ],
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/how-to-integrate-best-facebook-messenger-crm-integration-with-pepper-cloud-crm/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Facebook website",
          url: "https://www.messenger.com/",
        },
      ],
      about: {
        title: "About Facebook Messenger",
        text: "Facebook Messenger is a popular instant messaging app and platform developed by Meta Platforms. With over 1.3 billion monthly active users, it is an essential channel for businesses to connect with their customers. Facebook Messenger offers features like text messaging, voice calls, video chats, and business integration capabilities, making it a versatile tool for customer communication.",
      },
      faq: {
        title: "Facebook Messenger CRM - FAQs",
        body: [
          {
            question: "What is Facebook CRM integration?",
            answer:
              "Facebook CRM integration is the process of connecting your Facebook Messenger account with a Customer Relationship Management (CRM) system, allowing you to manage Facebook conversations and leads directly within your CRM.",
          },
          {
            question:
              "How does Facebook Messenger CRM integration benefit my business?",
            answer:
              "It centralises customer communication, automates lead capture, enables team collaboration, and provides a comprehensive view of customer interactions, ultimately improving customer service and sales efficiency.",
          },
          {
            question:
              "Is it possible to automatically create leads from Facebook Messenger conversations?",
            answer: (
              <>
                Absolutely! The facebook messenger integration automatically
                captures leads from the Messenger conversations and creates new
                lead entries in your CRM.,
              </>
            ),
          },
          {
            question: "How secure is the Facebook Messenger CRM integration?",
            answer:
              "Pepper Cloud is the best CRM for Facebook Messenger that ensures high-level security measures to protect your data and comply with privacy regulations when integrating Facebook Messenger with your CRM.",
          },
          {
            question:
              "Can I track the performance of my Facebook Messenger communication through the CRM?",
            answer: (
              <>
                Yes, Pepper Cloud CRM's Facebook Messenger Integration provides
                analytics and reporting features to help you track and analyse
                your Facebook Messenger communication performance.
              </>
            ),
          },
        ],
      },
      additionalText: "For detailed steps, refer to the",
      IinkText: "Facebook Messenger setup guide",
      url: "https://blog.peppercloud.com/how-to-integrate-best-facebook-messenger-crm-integration-with-pepper-cloud-crm/",
    },
    "microsoft-outlook-365-integration": {
      seo: {
        title:
          "Outlook Integration with CRM | Pepper Cloud",
        keywords:
          "best CRM for outlook, best CRM for outlook 365, CRM for outlook 365, best CRM outlook integration, outlook integration",
        description:
          "Connect Outlook 365 to Pepper Cloud CRM. Align calendar events, automate follow-up reminders, and keep clean, merged contact records.",
        link: "https://peppercloud.com/crm-integrations/microsoft-outlook-365-integration",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Outlook&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Outlook&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case7hero,
      tags: "Email inbox | Customer service | Sales productivity | Bulk emailing | Email automation",
      alt: "microsoft-outlook-365-integration",
      pageTitle: "Outlook",
      // name: bannerImg["microsoft-outlook-365-integration"],
      heading: "Best CRM for Outlook integration",
      toptitle: "Sync and send emails with the best CRM for Outlook.",
      topdescription:
        "Effortlessly handle your emails through the seamless Outlook integration, making it the best CRM for Outlook 365. Gain direct access and control over your email conversations, all within the CRM inbox.",
      body: [
        {
          title: "Benefits of Outlook CRM integration",
          boldPoints: [
            {
              boldText: "Centralised data management:",
              text: "Sync contacts, emails, and calendar events between Outlook and your CRM.",
            },
            {
              boldText: "Enhanced productivity:",
              text: "Access CRM data directly from Outlook, eliminating the need to switch between applications.",
            },
            {
              boldText: "Improved communication tracking:",
              text: "Automatically log emails and interactions in your CRM for a complete customer history.",
            },
            {
              boldText: "Better team collaboration:",
              text: "Share customer information and communication history across your organisation.",
            },
            {
              boldText: "Time-saving automation:",
              text: "Set up workflows to automate repetitive tasks and email follow-ups.",
            },
            {
              boldText: "Accurate reporting:",
              text: "Generate comprehensive reports based on integrated data for better decision-making.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Outlook integration?",
          description:
            "Pepper Cloud stands out as the best CRM outlook integration solution for several reasons:",
          boldPoints: [
            {
              boldText: "Seamless two-way sync:",
              text: "Our CRM Outlook integration ensures real-time data synchronisation between Outlook and Pepper Cloud CRM.",
            },
            {
              boldText: "User-friendly interface:",
              text: "Easily navigate and manage your CRM data from your Outlook interface using Outlook add-in and streamline your workflow.",
            },
            {
              boldText: "Robust security:",
              text: "Rest assured with our enterprise-grade security measures protecting your sensitive data. We employ state-of-the-art encryption and comply with industry standards to keep your information safe.",
            },
            {
              boldText: "Automated data entry:",
              text: "Save time and reduce errors by automatically capturing contact details and communication history from Outlook into your CRM. This eliminates the need for manual data entry and ensures your CRM records are always up-to-date.",
            },
            {
              boldText: "Contextual CRM data in Outlook:",
              text: "View relevant CRM information such as tasks and events directly within your Outlook interface. This provides valuable context for your communications without the need to switch applications.",
            },
            {
              boldText: "Task and appointment synchronisation:",
              text: "Keep your Outlook calendar and CRM tasks in sync, ensuring you never miss an important deadline or meeting. This feature helps you manage your time more effectively across both platforms.",
            },
            {
              boldText: "Comprehensive contact management:",
              text: "Simplify the import and management of your Outlook contacts with Pepper Cloud CRM. Get automatic notification for merging of records, ensuring your database remains clean and well-organised.",
            },
            {
              boldText: "Email automation:",
              text: "Optimise your email workflows by configuring triggers to send automated follow-up emails to leads or notifications to users. With this feature, you can set specific actions or conditions, like a customer subscribing to a newsletter or abandoning a shopping cart, to automatically generate an email response.",
            },
          ],
        },
        {
          title: "How to integrate Outlook with Pepper Cloud CRM?",
          pointers: [
            "Log in to your Pepper Cloud CRM account.",
            "Navigate to 'Settings' and select 'Integrations'.",
            "Choose 'Outlook' from the list of available integrations.",
            "Click 'Connect' and follow the prompts to authorise the integration.",
            "Configure your sync settings and field mappings as desired.",
            "Start enjoying the benefits of seamless Outlook CRM integration!",
          ],
        },
      ],
      userCases: {
        heading: "Outlook CRM integration - Application and use cases",
        body: [
          {
            title: "Sales teams",
            points: [
              "Track email conversations with leads and prospects.",
              "Schedule follow-up tasks and appointments directly from email interactions.",
              "Access customer information and sales history while composing emails.",
              "Collaborate with team members by sharing customer communication logs.",
            ],
          },
          {
            title: "Customer support",
            points: [
              "Log customer inquiries and support tickets automatically.",
              "Access previous support history when responding to emails.",
              "Assign and track support tasks across the team.",
              "Generate reports on response times and customer satisfaction.",
            ],
          },
          {
            title: "Marketing teams",
            points: [
              "Segment email lists based on CRM data.",
              "Personalise email content using CRM fields.",
              "Track campaign performance and engagement metrics.",
              "Nurture leads through automated email sequences.",
            ],
          },
          {
            title: "Project management",
            points: [
              "Link project-related emails to specific CRM records.",
              "Schedule project milestones and deadlines in both Outlook and CRM.",
              "Collaborate with team members using shared calendars and task lists.",
              "Generate project status reports based on integrated data.",
            ],
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/email-integration-with-crm/#connect-your-gmail-and-outlook-with-pepper-cloud-crm",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Outlook website",
          url: "https://www.microsoft.com/en-us/microsoft-365/outlook/email-and-calendar-software-microsoft-outlook",
        },
      ],
      about: {
        title: "About Outlook",
        text: "Microsoft Outlook is a personal information manager from Microsoft, available as part of the Microsoft Office suite. It is widely used for email management, but also includes features such as calendaring, task managing, contact managing, note-taking, and web browsing. As one of the most popular email clients for businesses, finding the best CRM for outlook 365 is essential for many organisations looking to optimise their customer relationship management.",
      },
      faq: {
        title: "Outlook CRM integration FAQs",
        body: [
          {
            question:
              "What makes Pepper Cloud the best CRM for Outlook 365 integration?",
            answer:
              "Pepper Cloud offers seamless integration, real-time syncing, easy lead capture, and advanced email tracking features, making it the top choice for Outlook 365 users.",
          },
          {
            question:
              "Can I use Pepper Cloud CRM with older versions of Outlook?",
            answer:
              "Yes, Pepper Cloud CRM is compatible with various versions of Outlook, including older ones. However, for the best experience, we recommend using the latest version of Outlook.",
          },
          {
            question: "Can I sync my Outlook calendar with Pepper Cloud CRM?",
            answer:
              "Yes, CRM Outlook integration includes calendar syncing, allowing you to manage your appointments and schedules seamlessly across both platforms.",
          },
          {
            question:
              "Does the Pepper Cloud Outlook integration work with Outlook Web App?",
            answer:
              "Yes, our integration is compatible with both desktop Outlook and Outlook Web App, providing flexibility in how you access your integrated CRM data. You will have to install the Outlook add-in to log emails, tasks, events, etc., into CRM through Outlook inbox.",
          },
          {
            question:
              "Is it possible to create new CRM records directly from Outlook?",
            answer:
              "Absolutely. You can create new leads, contacts, tasks, or other CRM records directly from your Outlook interface without needing to switch to the CRM application.",
          },
          {
            question:
              "Is training provided for using the Pepper Cloud Outlook integration?",
            answer:
              "Yes, Pepper Cloud offers comprehensive training resources, including video tutorials, documentation, and online support to help you make the most of our Outlook integration.",
          },
        ],
      },
    },
    "office365-calendar-integration": {
      seo: {
        title: "Microsoft 365 Outlook calendar integration | Pepper Cloud CRM",
        keywords:
          "best CRM with outlook calendar integration, outlook calendar integration, integration with outlook calendar",
        description:
          "Connect Outlook Calendar to Pepper Cloud CRM. You can auto-sync contract closing dates, schedule rep check-ins, and track meeting notes directly",
        link: "../crm-integrations/office365-calendar-integration",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Outlook_Calendar&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Outlook_Calendar&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case8hero,
      alt: "Best CRM with Outlook Calendar integration",
      tags: "Calendar sync | Meeting scheduler | Schedule appointment | Meeting scheduling | Task, booking, event, meeting management",
      // name: bannerImg["office365-calendar-integration"],
      pageTitle: "Outlook Calendar",
      heading: "Best CRM with Outlook Calendar integration",
      toptitle:
        "Track upcoming sales activities with Outlook Calendar integration.",
      topdescription:
        "Maximise your productivity and streamline your scheduling with the best CRM with Outlook Calendar integration. This powerful CRM for Office 365 integration synchronises your calendar events, tasks, and reminders, ensuring you stay organised and never miss an important appointment or deadline.",
      body: [
        {
          title: "Benefits of CRM with Outlook Calendar integration",
          boldPoints: [
            {
              boldText: "Real-time 2-way sync:",
              text: "Keep your Outlook Calendar and CRM events perfectly in sync, eliminating double-booking and scheduling conflicts.",
            },
            {
              boldText: "Centralised task management:",
              text: "Manage all your tasks and appointments from a single platform, reducing the need to switch between applications.",
            },
            {
              boldText: "Enhanced team collaboration:",
              text: "Easily share calendars and schedule team events directly from your CRM.",
            },
            {
              boldText: "Improved time management:",
              text: "Get a comprehensive view of your schedule, helping you allocate your time more efficiently.",
            },
            {
              boldText: "Automated reminders:",
              text: "Receive timely notifications for upcoming events and tasks within your CRM interface.",
            },
            {
              boldText: "Increased data accuracy:",
              text: "Eliminate manual data entry errors by automatically syncing event details between platforms.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Outlook Calendar integration?",
          description:
            "Pepper Cloud excels as the top CRM for Outlook Calendar, thanks to its smooth integration and advanced features:",
          boldPoints: [
            {
              boldText: "Seamless user experience:",
              text: "The intuitive interface of Pepper Cloud CRM makes managing your calendar within the CRM effortless and user-friendly.",
            },
            {
              boldText: "Customisable permissions:",
              text: "Control who can view and edit your calendar events, ensuring privacy and security.",
            },
            {
              boldText: "Advanced filtering options:",
              text: "Easily categorise and filter events based on various criteria, such as client, project, or event type.",
            },
            {
              boldText: "Robust support:",
              text: (
                <>
                  Easily connect with a dedicated{" "}
                  <a href="https://peppercloud.com/contact/">support team</a> to
                  help you maximise the potential of your Outlook Calendar CRM
                  integration.
                </>
              ),
            },
          ],
        },
        {
          title: "How to integrate Outlook Calendar with Pepper Cloud CRM?",
          pointers: [
            "Navigate to “User Settings” in the CRM.",
            "Go to “Calendar” from the “Integration” screen.",
            "Integrate with the “Office 365 Calendar”",
            "Sign in to your QuickBooks account.",
            "Provide an associated email ID to complete the integration.",
          ],
        },
      ],
      userCases: {
        heading: "Outlook Calendar CRM integration - Application and use cases",
        body: [
          {
            title: "Sales meeting management",
            points: [
              "Schedule client meetings and automatically sync them with your Outlook Calendar.",
              "Set reminders for follow-ups and track meeting outcomes directly in the CRM.",
              "Share relevant calendar events with team members for collaborative selling.",
            ],
          },
          {
            title: "Project timeline tracking",
            points: [
              "Create and manage project milestones as Office 365 Calendar events.",
              "Sync deadlines and deliverable dates between Outlook and CRM.",
              "Visualise project timelines and resource allocation across teams.",
            ],
          },
          {
            title: "Customer support scheduling",
            points: [
              "Book customer support calls and sync them with the support team’s calendars.",
              "Set up recurring maintenance appointments and reminders.",
              "Track support time allocation and optimize scheduling based on historical data.",
            ],
          },
          {
            title: "Marketing campaign management",
            points: [
              "Schedule content publication dates and campaign milestones.",
              "Coordinate team meetings for campaign planning and review.",
              "Set reminders for key marketing activities and deadlines.",
            ],
          },
          {
            title: "HR and recruitment process",
            points: [
              "Schedule interviews and sync them with hiring managers' calendars.",
              "Set up orientation and training sessions for new hires.",
              "Manage employee review schedules and reminders.",
            ],
          },
        ],
      },
      about: {
        title: "About Outlook Calendar",
        text: "Outlook Calendar is a scheduling and time-management tool within the Microsoft Office 365 suite, designed to help users efficiently manage their schedules, arrange meetings, and track events. Its seamless integration with other Office 365 applications offers a comprehensive productivity solution for both individuals and businesses. By integrating Outlook Calendar with your CRM system, you can leverage its powerful scheduling capabilities to enhance organisational efficiency, streamline appointment management, and improve overall productivity.",
      },
      faq: {
        title: "Best CRM with Outlook Calendar integration FAQs",
        body: [
          {
            question:
              "How often does the calendar sync between Outlook and the CRM?",
            answer: (
              <>
                The sync occurs in real-time, ensuring your calendars are always
                up-to-date across platforms.
              </>
            ),
          },
          {
            question:
              "Can I control which events are synced between Outlook and the CRM?",
            answer: (
              <>
                Yes, you can set up filters and rules to determine which events
                are synced based on your preferences.
              </>
            ),
          },
          {
            question:
              "Is it possible to create events in Outlook Calendar and assign them to team members?",
            answer: (
              <>
                Absolutely! You can set up events by determining the event type
                or criteria and easily assign them to the right team members.
              </>
            ),
          },
          {
            question: "Can I view my team members' calendars within the CRM?",
            answer: (
              <>
                Yes, depending on the permissions provided, you can view and
                manage team calendars directly from the CRM interface.
              </>
            ),
          },
          {
            question: "Does the integration support recurring events?",
            answer: (
              <>
                Yes, recurring events are fully supported and will sync
                correctly between Outlook and the CRM.
              </>
            ),
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/email-integration-with-crm/#connect-your-gmail-and-outlook-with-pepper-cloud-crm",
        },
        {
          title: "Outlook Calendar information",
          url: "https://support.microsoft.com/en-us/office/introduction-to-the-outlook-calendar-d94c5203-77c7-48ec-90a5-2e2bc10bd6f8",
        },
      ],
    },
    "microsoft-outlook-contacts-integration": {
      seo: {
        title:
          "Outlook Contacts Integration with CRM | Pepper Cloud",
        keywords:
          "CRM with Outlook contacts integration, Microsoft outlook Contacts integration, Office 365 contacts integration",
        description:
          "Turn Outlook email contacts into leads. Pepper Cloud lets you save contact details, track client communication histories, and set follow-up reminders.",
        link: "https://peppercloud.com/crm-integrations/microsoft-outlook-contacts-integration",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Outlook_Contacts&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Outlook_Contacts&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case9hero,
      tags: "Calendar sync | Meeting scheduler | Schedule appointment | Meeting scheduling | Task, booking, event, meeting management",
      alt: "Best CRM with Outlook Contacts integration",
      pageTitle: "Outlook Contact",
      // name: bannerImg["microsoft-outlook-contacts-integration"],
      heading: "Best CRM with Outlook Contacts integration",
      toptitle:
        "Sync and manage your contacts effortlessly by integrating Outlook Contacts with your CRM system.",
      topdescription:
        "Seamlessly connect your Microsoft Outlook contacts with Pepper Cloud CRM for enhanced productivity and streamlined contact management. The best CRM with Outlook Contacts integration offers a powerful solution to synchronise your data effortlessly, ensuring you always have up-to-date information at your fingertips.",
      body: [
        {
          title: "Benefits of Microsoft Outlook Contacts integration with CRM",
          boldPoints: [
            {
              boldText: "Easy data import:",
              text: "Import contacts from Microsoft Outlook into your CRM system with a single click and access contact information directly within the CRM.",
            },
            {
              boldText: "Eliminate manual data entry:",
              text: "Automatically populate your CRM database with contact information, eliminating constant manual entry and saving you time and effort.",
            },
            {
              boldText: "Improved data accuracy:",
              text: "Reduce errors and maintain consistent records by easily importing contacts into your CRM.",
            },
            {
              boldText: "Time-saving:",
              text: "Spend less time on contact management and focus more on building valuable relationships.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Office 365 Contacts integration?",
          description:
            "Pepper Cloud is the top CRM for Office 365 Contacts, offering seamless integration and robust features:",
          boldPoints: [
            {
              boldText: "Frictionless contact management:",
              text: "Effortlessly store and manage your Office 365 Contacts within Pepper Cloud CRM for streamlined access and organisation.",
            },
            {
              boldText: "User-friendly interface:",
              text: "Enjoy easy setup and management with an intuitive interface designed for CRM users.",
            },
            {
              boldText: "Customisable field mappings:",
              text: "Tailor the integration to meet your specific needs with flexible field mapping options.",
            },
            {
              boldText: "Robust security measures:",
              text: "Protect your data with industry-leading security protocols.",
            },
          ],
        },
        {
          title:
            "How to integrate Microsoft Outlook Contacts with Pepper Cloud CRM?",
          pointers: [
            "Navigate to “User Settings” in the CRM.",
            "Go to Contacts in the Integration screen.",
            "Integrate with Outlook Contacts.",
            "Provide an associated email ID to complete the integration.",
          ],
        },
      ],
      userCases: {
        heading:
          "CRM with Outlook Contacts integration - Application and use cases",
        body: [
          {
            title: "Sales team efficiency",
            points: [
              "Salespeople can access customer contact information directly from their CRM system without switching applications.",
              "New leads from email interactions can be automatically added to the CRM.",
              "Track communication history and set follow-up reminders within the CRM.",
            ],
          },
          {
            title: "Customer service enhancement",
            points: [
              "Support teams can view a customer's complete history when responding to emails.",
              "Automatically log support interactions in the CRM for future reference.",
              "Use CRM data to personalise responses and provide better service.",
            ],
          },
          {
            title: "Marketing campaign management",
            points: [
              "Segment contacts based on CRM data for targeted email campaigns.",
              "Track campaign responses and update contact information automatically.",
              "Use Outlook categories to organise contacts for different marketing initiatives.",
            ],
          },
          {
            title: "Networking and relationship building",
            points: [
              "Sync business card information from Outlook to CRM for new connections.",
              "Set reminders for follow-ups and relationship-building activities.",
              "Keep notes and interaction history synchronised across platforms.",
            ],
          },
          {
            title: "Project management",
            points: [
              "Associate contacts with specific projects in both Outlook and CRM.",
              "Share relevant contact information with team members easily.",
              "Track client communication throughout the project lifecycle.",
            ],
          },
        ],
      },
      about: {
        title: "About Microsoft Outlook Contacts",
        text: "Outlook Contacts, a feature of Microsoft 365's Outlook messaging hub, allows you to store and manage contact information for individuals and businesses seamlessly. With features like custom fields, categories, and distribution lists, Outlook Contacts provides a robust foundation for personal and professional contact management. Integrating Outlook Contacts with your CRM enhances contact management and streamlines communication seamlessly.",
      },
      faq: {
        title: "Outlook Contacts CRM FAQs",
        body: [
          {
            question:
              "What happens to my existing Outlook contacts when integrated with Pepper Cloud CRM?",
            answer: (
              <>
                After you integrate Outlook with Pepper Cloud CRM, you can
                import your Outlook contacts into the CRM.
              </>
            ),
          },
          {
            question:
              "How do I manage duplicate contacts between Outlook and Pepper Cloud CRM?",
            answer: (
              <>
                Pepper Cloud CRM has built-in duplicate detection and merging
                features. If duplicates are detected during the import process,
                you will be prompted to review and merge them to ensure a clean
                and organised contact database.
              </>
            ),
          },
          {
            question:
              "Can I import historical Outlook contact data into Pepper Cloud CRM?",
            answer: (
              <>
                Yes, you can import historical contact data from Outlook into
                Pepper Cloud CRM. The CRM provides options to import contacts
                from specific time frames or categories, ensuring that you
                retain all relevant information.
              </>
            ),
          },
          {
            question:
              "What security measures are in place for the integration between Outlook and Pepper Cloud CRM?",
            answer: (
              <>
                The integration uses secure OAuth protocols to ensure that your
                Outlook account and contact data are protected. Additionally,
                Pepper Cloud CRM adheres to strict data privacy policies to
                safeguard your information.
              </>
            ),
          },
          {
            question: "Can I export contacts from Pepper Cloud CRM?",
            answer: (
              <>
                Yes, Pepper Cloud CRM allows you to export contacts. You can
                select the contacts you want to export and choose the
                appropriate format.
              </>
            ),
          },
          {
            question:
              "Who should I contact if I encounter issues with the Outlook integration?",
            answer: (
              <>
                If you experience any issues with the Outlook integration, you
                can reach out to Pepper Cloud{" "}
                <a href="https://peppercloud.com/contact/">CRM’s support team</a>{" "}
                for assistance. They provide comprehensive support to resolve
                integration-related problems and ensure smooth functionality.
              </>
            ),
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Outlook Contacts information ",
          url: "https://support.microsoft.com/en-us/office/create-view-and-edit-contacts-and-contact-lists-in-outlook-ca469928-4b1c-47e4-ae85-15b6345ce043",
        },
      ],
    },
    "whatsapp-business-api": {
      seo: {
        title: "Best CRM with Telegram Integration To Maximize Sales",
        keywords:
          "CRM integration with WhatsApp Business Cloud API, whatsapp cloud api, whatsapp business cloud api",
        description:
          "Connect WhatsApp Cloud API to Pepper Cloud CRM. Send bulk message broadcasts, live order tracking, handle ticket resolutions faster.",
        link: "https://peppercloud.com/crm-integrations/whatsapp-business-api/",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=WACloudAPI&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=WACloudAPI&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case27hero,
      pageTitle: "WhatsApp Cloud API",
      tags: "Customer support | Bot & messaging | Instant messaging | Social media integration",
      alt: "Best CRM integration with WhatsApp Business Cloud API",
      // name: bannerImg["whatsapp-business-api"],
      heading: "Best CRM integration with WhatsApp Business Cloud API",
      toptitle:
        "Unlock the power of seamless communication by integrating your CRM system with the WhatsApp Business Cloud API.",
      topdescription:
        "CRM WhatsApp Business Cloud API integration bridges the gap between customer relationship management and the world's most popular messaging platform, WhatsApp, and revolutionises how businesses connect with their audience.",
      body: [
        {
          title: "Benefits of WhatsApp Cloud API CRM integration",
          boldPoints: [
            {
              boldText: "Enhanced customer engagement:",
              text: "Leverage real-time messaging to interact with customers instantly, providing timely support and personalised experiences. Reach your customers on their preferred platform, WhatsApp, fostering more natural and convenient interactions.",
            },
            {
              boldText: "Streamlined communication:",
              text: "Manage all customer interactions – from initial inquiries to post-purchase support – within a centralised CRM platform. Eliminate the need to switch between multiple platforms and ensure a cohesive communication strategy.",
            },
            {
              boldText: "Complete customer profile:",
              text: "Automatically sync WhatsApp conversations with your CRM, creating a comprehensive customer profile that includes messaging history, preferences, and behaviour patterns.",
            },
            {
              boldText: "Increased efficiency:",
              text: "Automate routine tasks such as appointment reminders, order delivery updates, follow-ups, and more, freeing up your team to focus on high-value interactions and strategic initiatives.",
            },
            {
              boldText: "Increased sales and conversions:",
              text: "Engage leads more effectively through targeted WhatsApp marketing campaigns, and drive higher sales and conversion rates.",
            },
            {
              boldText: "Improved agent productivity:",
              text: "Empower your agents with a unified platform for managing WhatsApp chats alongside other customer interactions, boosting efficiency.",
            },
          ],
        },
        {
          title:
            "Why choose Pepper Cloud CRM for WhatsApp Cloud API integration?",
          boldPoints: [
            {
              boldText: "Seamless integration:",
              text: "Pepper Cloud, the best CRM for WhatsApp Cloud API integration, offers a smooth and hassle-free integration process, ensuring that your WhatsApp Business Cloud API works flawlessly with our robust CRM system from day one.",
            },
            {
              boldText: "Message broadcast:",
              text: "Send messages to individuals or to multiple contacts at once through message broadcast functionality. Promote your products and services, send deals and discounts, share product updates, and more.",
            },
            {
              boldText: "Advanced automation capabilities:",
              text: "Leverage Pepper Cloud's powerful automation tools to create personalised customer journeys, set up triggered responses, and streamline your WhatsApp communication workflow.",
            },
            {
              boldText: "Comprehensive analytics:",
              text: "Gain deep insights into your WhatsApp communication performance with our detailed analytics suite, helping you make data-driven decisions to improve customer engagement and satisfaction.",
            },
            {
              boldText: "Feature-rich platform:",
              text: "Pepper Cloud CRM platform provides a comprehensive suite of features such as message templates, WhatsApp automation, and more to optimise your WhatsApp Business Cloud API integration.",
            },
            {
              boldText: "Omnichannel solution:",
              text: "Pepper Cloud integrates with multiple communication channels like Instagram, Facebook, Telegram, and more, providing your team with a truly omnichannel platform that allows you to manage all your communications from a single interface.",
            },
          ],
        },
        {
          title: "How to integrate WhatsApp Cloud API with Pepper Cloud CRM?",
          pointers: [
            "Get WhatsApp Cloud API through your Facebook developer account",
            "Generate permanent access token",
            "Use the access token to integrate WhatsApp Cloud API with Pepper Cloud CRM",
          ],
        },
      ],
      userCases: {
        heading:
          "WhatsApp Cloud API CRM integration - Applications and use cases",
        body: [
          {
            title: "Customer support and service",
            points: [
              "Provide instant responses to customer queries.",
              "Offer real-time order tracking and updates.",
              "Handle complaint resolution efficiently.",
              "Schedule and manage appointments.",
            ],
          },
          {
            title: "Sales and lead generation",
            points: [
              "Nurture leads through personalised messaging campaigns.",
              "Send product recommendations based on customer preferences.",
              "Automate follow-ups with potential customers.",
              "Facilitate easy product inquiries and purchases.",
            ],
          },
          {
            title: "Marketing and promotional campaigns",
            points: [
              "Send targeted promotional messages to segmented customer groups.",
              "Create interactive product catalogues within WhatsApp.",
              "Run contests and surveys to engage customers.",
              "Deliver personalised content based on customer interests.",
            ],
          },
          {
            title: "Automated notifications and reminders",
            points: [
              "Send appointment reminders to reduce no-shows.",
              "Notify customers about payment due dates.",
              "Alert users about account activity or security updates.",
              "Remind customers about abandoned carts or incomplete transactions.",
            ],
          },
          {
            title: "Customer onboarding and training",
            points: [
              "Guide new customers through product setup and features.",
              "Provide step-by-step tutorials and how-to guides.",
              "Offer instant access to FAQs and knowledge base.",
              "Deliver personalised onboarding experiences based on user preferences.",
            ],
          },
        ],
      },
      about: {
        title: "About WhatsApp Cloud API",
        text: "WhatsApp Cloud API is a cloud-hosted version of the WhatsApp Business API that enables businesses to communicate with their customers at scale. It provides a secure and reliable way to send and receive messages, media, and other types of content through WhatsApp. The Cloud API simplifies the integration process, allowing businesses to leverage WhatsApp's features without the need for complex infrastructure setup or maintenance.",
      },
      faq: {
        title: "WhatsApp Cloud API CRM FAQs",
        body: [
          {
            question: "What is WhatsApp Business Cloud API?",
            answer: (
              <>
                WhatsApp Business Cloud API is a cloud-hosted version of the
                WhatsApp Business API that allows businesses to communicate with
                customers at scale through WhatsApp.
              </>
            ),
          },
          {
            question:
              "How does WhatsApp Cloud API CRM integration benefit my business?",
            answer: (
              <>
                It enables seamless communication with customers, centralises
                data management, improves efficiency through automation, and
                provides valuable insights for better decision-making.
              </>
            ),
          },
          {
            question: "Is WhatsApp Cloud API integration secure?",
            answer: (
              <>
                Yes, WhatsApp Cloud API uses end-to-end encryption, ensuring
                that all communications between your business and customers are
                secure.
              </>
            ),
          },
          {
            question:
              "Can I automate messages with WhatsApp Cloud API CRM integration?",
            answer: (
              <>
                Absolutely. You can set up automated responses, reminders, and
                notifications based on specific triggers or customer actions
                through Workflow automation.
              </>
            ),
          },
          {
            question:
              "How does WhatsApp Cloud API integration improve customer service?",
            answer: (
              <>
                It allows for instant responses, real-time updates, and
                personalised interactions, leading to improved customer
                satisfaction and loyalty.
              </>
            ),
          },
          {
            question:
              "What types of messages can I send through WhatsApp Cloud API?",
            answer: (
              <>
                You can send text messages, images, videos, documents, and other
                rich media content approved by WhatsApp.
              </>
            ),
          },
          {
            question:
              "How does WhatsApp Cloud API CRM integration help with lead generation?",
            answer: (
              <>
                It enables businesses to engage potential customers through
                personalised messaging campaigns, automated lead capture, and
                sending instant follow-ups, increasing conversion rates.
              </>
            ),
          },
          {
            question:
              "Can I track the performance of my WhatsApp communication with this integration?",
            answer: (
              <>
                Yes, Pepper Cloud CRM, also known as WhatsApp CRM, offers a
                visual dashboard for messages and empowers your team to view and
                analyse key metrics like response time, resolution time, etc.
              </>
            ),
          },
          {
            question:
              "How does WhatsApp Cloud API CRM integration compare to traditional communication channels?",
            answer: (
              <>
                It offers more immediate and interactive communication, higher
                open rates, and the ability to reach customers on their
                preferred messaging platform, leading to better engagement and
                response rates.
              </>
            ),
          },
        ],
      },
      additionalText: "Read our detailed guide on",
      IinkText: "how to integrate WhatsApp Cloud API with Pepper Cloud CRM",
      url: "https://peppercloud.com/crm-support/",
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "WhatsApp Cloud API",
          url: "https://developers.facebook.com/docs/whatsapp/cloud-api/",
        },
      ],
    },
    "xero-accounting-software": {
      seo: {
        title: "Integrate Xero with Pepper Cloud CRM",
        keywords:
          "xero crm integrations, crm and accounting software integration, crm software integration,Xero integration,best crm for xero",
        description:
          "Connect Xero with Pepper Cloud CRM. Sync multi-currency pricing. Track quote status live and trigger instant deal follow-up emails.",
        link: "../crm-integrations/xero-accounting-software",
      },
      youtube: "https://www.youtube.com/embed/xTl3ydqdiMw?si=AxIUxS5gnJdd-AX4",
      contactLink:
        "https://app.peppercloud.com/?utm_source=Xero&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Xero&utm_medium=CTA&utm_campaign=marketplace_internal",
      tags: "Accounting software |  CRM accounting software | Best CRM for accounting firms | CRM for accountants",
      heroBg: case11hero,
      alt: "Best Xero CRM integration",
      pageTitle: "Xero",
      // name: bannerImg["Xero integration"],
      heading: "Xero integration",
      toptitle: "Generate and track quotations with Xero CRM integration.",
      topdescription:
        "Supercharge your sales process with best Xero CRM integration. Effortlessly generate, manage, and track sales quotations. Reduce manual data entry and streamline workflows for maximum efficiency.",
      body: [
        {
          title: "Benefits of Xero CRM Integration",
          boldPoints: [
            {
              boldText: "Seamless quotation generation:",
              text: "Create professional quotations directly within your CRM, pulling accurate product and pricing information from Xero.",
            },
            {
              boldText: "Real-time quotation tracking:",
              text: "Monitor the status of your quotations in real-time, whether they are accepted, declined, or pending, all within your CRM interface.",
            },
            {
              boldText: "Automated data synchronisation:",
              text: "Eliminate manual data entry errors by automatically syncing quotation details between your CRM and Xero.",
            },
            {
              boldText: "Enhanced visibility:",
              text: "Gain a comprehensive view of your sales pipeline by accessing quotation data alongside other customer information in your CRM.",
            },
            {
              boldText: "Improved accuracy:",
              text: "Ensure your quotations always reflect the most up-to-date pricing and product information stored in Xero.",
            },
            {
              boldText:
                "Efficient collaboration and better customer experience:",
              text: "Enable seamless collaboration between sales and finance with shared access to quotation data. Respond to customer inquiries faster and more accurately with instant access to their quotation history.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Xero Integration?",
          description:
            "Pepper Cloud stands out as the best CRM for Xero due to its seamless integration and powerful features:",
          boldPoints: [
            {
              boldText: "Two-way sync: ",
              text: "Access and manage quotations in both Xero and Pepper Cloud CRM.",
            },
            {
              boldText: "Real-time status updates: ",
              text: "Track quotation stages for acceptance, declination, or pending status.",
            },
            {
              boldText: "Readymade templates: ",
              text: "Utilise ready-made email templates and quotation formats to quickly generate and send the quotations.",
            },
            {
              boldText: "Auto-population: ",
              text: "Automatically fill in product information, pricing, tax details and more in CRM with just a click.",
            },
            {
              boldText: "User-friendly interface:",
              text: "Experience an intuitive platform that is easy to use and navigate.",
            },
            {
              boldText: "Instant notifications:",
              text: "Get instant email notifications with the help of workflow automation. ",
            },
          ],
        },
        {
          title: "How to integrate Xero with Pepper Cloud CRM?",
          description:
            "Here are the steps to get started with Pepper Cloud CRM software that integrates with Xero:",
          pointers: [
            "Navigate to Integration in CRM user settings.",
            "Go with Xero accounting tool integration.",
            "Log in to your Xero account.",
            "Provide access to complete the integration process.",
          ],
        },
      ],
      additionalText:
        "For a more detailed setup guide, please refer to our comprehensive",
      IinkText: "CRM Xero integration documentation",
      url: "https://blog.peppercloud.com/guide-to-connect-xero-with-pepper-cloud-crm/",
      userCases: {
        heading: "Xero CRM Integration - Applications and use cases",
        body: [
          {
            title: "Sales process optimisation:",
            points: [
              "Generate and track quotations efficiently, closing deals faster.",
              "Automate follow-ups based on quotation status changes in Xero.",
              "Provide sales teams with real-time financial data to inform negotiations.",
              "Create a seamless quote-to-cash process, reducing administrative overhead.",
            ],
          },
          {
            title: "Financial reporting and analysis:",
            points: [
              "Create accurate reports combining sales pipeline data and financial records.",
              "Forecast sales based on the financial data.",
              "Perform detailed profitability analysis by customer, product, or sales rep.",
              "Track actual vs. forecasted revenue in real-time for better business planning.",
            ],
          },
          {
            title: "Tax compliance and reporting:",
            points: [
              "Ensure accurate tax calculations on quotes.",
              "Simplify tax reporting by having all relevant data in sync between systems.",
              "Easily generate reports for tax audits or financial reviews.",
            ],
          },
          {
            title: "Multi-currency management:",
            points: [
              "Handle international sales with ease, using up-to-date exchange rates from Xero.",
              "Generate quotes and invoices in multiple currencies while maintaining accurate reporting in your base currency.",
              "Analyse profitability of international sales taking currency fluctuations into account.",
            ],
          },
          {
            title: "Team collaboration and productivity:",
            points: [
              "Provide sales, finance, and customer service teams with a single source of truth.",
              "Reduce inter-departmental communication gaps and data discrepancies.",
              "Increase overall productivity by eliminating duplicate data entry and manual reconciliation tasks.",
            ],
          },
        ],
      },
      about: {
        title: "About Xero - Accounting Software",
        text: "Xero is a cloud-based accounting software platform built for small and medium-sized growing businesses. It offers a wide range of features including invoicing, inventory management, payroll, and financial reporting. Xero's user-friendly interface and robust API make it an ideal partner for CRM integrations, allowing businesses to create a powerful, unified business management solution.",
      },
      faq: {
        title: "Xero CRM integration FAQs",
        body: [
          {
            question: "Is Pepper Cloud compatible with all Xero plans? ",
            answer:
              "Yes, Pepper Cloud's Xero CRM integration works with all Xero subscription levels.",
          },
          {
            question: "How often does the integration sync data? ",
            answer:
              "The integration syncs data in real-time, ensuring you always have the most up-to-date information.",
          },
          {
            question: "Is the Xero CRM integration secure?",
            answer:
              "Yes, Pepper Cloud uses industry-standard encryption and security protocols to protect your data and is the best CRM for Xero.",
          },
          {
            question: "Can I try the Xero CRM integration before committing?",
            answer:
              "Pepper Cloud CRM does not offer a free trial. However, you can contact our sales team for a free demo and experience Xero CRM integration.",
          },
          {
            question: "How can I send Xero quotations to my clients?",
            answer:
              "You can generate the quotation link or download the quotation in the PDF format. You can send it through email, WhatsApp, or just share the quotation link as a message. ",
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/guide-to-connect-xero-with-pepper-cloud-crm/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Xero website",
          url: "https://www.xero.com/",
        },
      ],
    },
    "zoom-meetings-for-video-conferencing": {
      seo: {
        title: "Best Sales CRM with Zoom Meetings Integration",
        keywords:
          "zoom CRM integration,Zoom integration, zoom crm, video conferencing",
        description:
          "Schedule Zoom calls inside Pepper Cloud CRM. Join meetings in one click, view prospect logs live, and auto-track video calls.",
        link: "https://peppercloud.com/crm-integrations/zoom-meetings-for-video-conferencing/",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Zoom&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Zoom&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case13hero,
      tags: "Video conferencing software | Video calling software | CRM for sales team | Online meeting scheduling",
      alt: "Best Zoom CRM integration",
      pageTitle: "Zoom",
      // name: bannerImg["Best Zoom CRM integration"],
      heading: "Best CRM Zoom integration",
      toptitle: "Schedule and manage video meetings with CRM Zoom integration.",
      topdescription:
        "Elevate your remote selling experience with the seamless integration of Pepper Cloud and Zoom. Effortlessly schedule and oversee video conferences enabling direct client connections from the CRM.",
      body: [
        {
          title: "Benefits of CRM Zoom integration",
          boldPoints: [
            {
              boldText: "Enhanced communication:",
              text: "Seamlessly connect with clients and prospects through Zoom meetings directly from your CRM, improving engagement and relationship-building.",
            },
            {
              boldText: "Improved productivity:",
              text: "Schedule, manage, and conduct video conferences without having to switch between different platforms, saving time and increasing efficiency.",
            },
            {
              boldText: "Centralised data:",
              text: "Automatically update your CRM records with meeting details and outcomes, ensuring all relevant information is easily accessible and up-to-date.",
            },
            {
              boldText: "Enhanced visibility:",
              text: "Gain a comprehensive view of your sales pipeline by accessing quotation data alongside other customer information in your CRM.",
            },
            {
              boldText: "Improved accuracy:",
              text: "Ensure your quotations always reflect the most up-to-date pricing and product information stored in Xero.",
            },
            {
              boldText: "Streamlined workflow:",
              text: "Start or join Zoom meetings with just a single click within your CRM, simplifying the process and making it more efficient.",
            },
            {
              boldText: "Better collaboration: ",
              text: "Keep your entire team aligned with real-time updates from Zoom meetings, ensuring everyone is informed and on the same page.",
            },
            {
              boldText: "Time-saving:",
              text: "Reduce manual data entry and administrative tasks by automating updates and integration, freeing up more time for productive work.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Zoom integration?",
          description:
            "Pepper Cloud offers a robust and user-friendly Zoom integration that sets it apart from other CRM solutions:",
          boldPoints: [
            {
              boldText: "Seamless integration:",
              text: " Easily connect your Zoom account with Pepper Cloud CRM.",
            },
            {
              boldText: "Comprehensive meeting management:",
              text: "Schedule, edit, and update Zoom meetings directly from the CRM.",
            },
            {
              boldText: "Automated activity tracking:",
              text: "Meeting details are automatically added to your CRM activity list.",
            },
            {
              boldText: "One-click join:",
              text: "Start or join Zoom meetings instantly from within the CRM interface.",
            },
            {
              boldText: "Email integration:",
              text: "Send Zoom meeting links to attendees through the CRM's email functionality.",
            },
          ],
        },
        {
          title: "How to integrate Zoom with Pepper Cloud CRM?",
          pointers: [
            "Navigate to user settings in CRM.",
            "On the integration screen, choose to integrate video chat.",
            "Integrate your CRM with Zoom by logging into your Zoom account.",
            "After successful authorisation, the integration process is complete.",
          ],
        },
      ],
      additionalText:
        "For a more detailed setup guide, please refer to our comprehensive",
      IinkText: "CRM Zoom integration documentation",
      url: "https://blog.peppercloud.com/zoom-meetings-integration/",
      userCases: {
        heading: "Zoom CRM integration - Application and use cases",
        body: [
          {
            title: "Sales demos and presentations:",
            points: [
              "Schedule and conduct product demonstrations directly from the CRM.",
              "Access client information during calls for personalised pitches.",
              "Record video meetings for future reference and team training.",
            ],
          },
          {
            title: "Customer support:",
            points: [
              "Initiate video support calls with a single click from customer records.",
              "Share screens to guide customers through troubleshooting steps.",
              "Document call outcomes directly in the CRM for seamless follow-ups.",
            ],
          },
          {
            title: "Remote team collaboration:",
            points: [
              "Host team meetings and strategy sessions linked to specific projects or accounts.",
              "Easily access relevant CRM data during internal discussions.",
              "Keep remote teams aligned with centralised meeting management.",
            ],
          },
          {
            title: "Client onboarding:",
            points: [
              "Streamline the onboarding process with scheduled video check-ins.",
              "Track client progress and engagement through integrated meeting notes.",
              "Provide face-to-face support at crucial stages of the customer journey.",
            ],
          },
        ],
      },
      about: {
        title: "About Zoom- Video conferencing tool ",
        text: "Zoom is a leading video conferencing platform that has become synonymous with remote communication. Known for its reliability and user-friendly interface, Zoom offers high-quality video and audio capabilities for meetings, webinars, and collaborative sessions. Its integration with CRM systems like Pepper Cloud enhances its functionality, making it an indispensable tool for modern businesses focused on building and maintaining strong client relationships.",
      },
      faq: {
        title: "Zoom CRM FAQs",
        body: [
          {
            question: "What is Zoom CRM integration?",
            answer:
              "Zoom CRM integration allows you to connect your Zoom video conferencing account with a CRM system like Pepper Cloud, enabling you to schedule, manage, and conduct Zoom meetings directly from the CRM platform.",
          },
          {
            question:
              "Can I schedule Zoom meetings directly from Pepper Cloud CRM?",
            answer:
              "Yes, you can schedule Zoom meetings directly from your Pepper Cloud CRM by using the integrated calendar and meeting scheduling features.",
          },
          {
            question: "How does Zoom CRM integration improve productivity?",
            answer:
              "It improves productivity by allowing you to manage Zoom meetings without switching between different platforms, thus saving time and reducing the need for manual updates.",
          },
          {
            question:
              "Can I join Zoom meetings directly from Pepper Cloud CRM?",
            answer:
              "Yes, you can launch or join Zoom meetings with a single click from within Pepper Cloud CRM, streamlining your workflow.",
          },
          {
            question: "Does the Zoom CRM integration support team meetings?",
            answer:
              "Yes, the integration supports team meetings. You can schedule, manage, and track team meetings and ensure all participants are kept up-to-date with real-time updates. ",
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/zoom-meetings-integration/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Zoom website",
          url: "https://zoom.us/",
        },
      ],
    },
    "mailchimp-crm-with-email-marketing": {
      seo: {
        title:
          "Connect Mailchimp to Pepper Cloud CRM",
        keywords:
          "mailchimp crm integration, mailchimp integration, email marketing crm integration",
        description:
          "Connect Mailchimp to Pepper Cloud CRM for real-time contact updates. Segment audiences using CRM data and run targeted promo campaigns.",
        link: "https://peppercloud.com/crm-integrations/mailchimp-crm-with-email-marketing",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Mailchimp&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Mailchimp&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case12hero,
      tags: "Email marketing software |  CRM email marketing software | Best CRM for email marketing | CRM for email marketers",
      alt: "best crm for mailchimp",
      pageTitle: "Mailchimp",
      // name: bannerImg["mailchimp integration"],
      heading: "Best CRM Mailchimp integration",
      toptitle: "Optimise email marketing with Mailchimp CRM integration.",
      topdescription:
        "Supercharge your marketing efforts using the best CRM integration with Mailchimp. Seamlessly sync your customer data with email marketing CRM integration and send personalised campaigns that drive sales.",
      body: [
        {
          title: "Benefits of Mailchimp CRM integration",
          boldPoints: [
            {
              boldText: "Synchronised data",
              text: "Ensure your CRM and Mailchimp lists are always updated with automatic updates, reducing the risk of outdated or inconsistent information.",
            },
            {
              boldText: "Enhanced segmentation",
              text: "Use detailed CRM data to create highly specific audience segments, allowing for more targeted and effective email campaigns.",
            },
            {
              boldText: "Personalised campaigns",
              text: "Leverage customer information from your CRM to craft emails that are tailored to individual preferences and behaviours, increasing engagement.",
            },
            {
              boldText: "Automated workflows",
              text: "Automate your email marketing by setting up triggers based on CRM activities, such as sending follow-ups or promotional offers when specific actions occur.",
            },
            {
              boldText: "Improved analytics",
              text: "Gain deeper insights into campaign performance by accessing comprehensive data within your CRM, helping you make informed decisions.",
            },
            {
              boldText: "Time-saving",
              text: "Reduce administrative workload by eliminating manual data entry, allowing you to focus on more strategic tasks.",
            },
            {
              boldText: "Increased conversion rates",
              text: "Deliver the right message to the right audience at the right time, boosting the effectiveness of your campaigns and driving higher conversion rates.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Mailchimp integration? ",
          description:
            "Pepper Cloud is the best CRM for Mailchimp integration, offering seamless integration and robust features that set it apart:",
          boldPoints: [
            {
              boldText: "Seamless data sync",
              text: "Ensure easy transfer of your CRM records directly to Mailchimp.",
            },
            {
              boldText: "User-friendly interface",
              text: "Easily manage your email marketing efforts directly from your CRM.",
            },
            {
              boldText: "Customisable mapping",
              text: "Tailor the integration to match your specific business needs.",
            },
            {
              boldText: "Real-time updates",
              text: "See changes reflected instantly across both platforms.",
            },
            {
              boldText: "Comprehensive support",
              text: "Access expert guidance and resources to maximise your integration.",
            },
            {
              boldText: "Scalable solution",
              text: "Grow your email marketing efforts alongside your business with ease.",
            },
          ],
        },
        {
          title: "How to integrate Mailchimp with Pepper Cloud CRM?",
          pointers: [
            'Navigate to settings in the CRM and go to "Integration"',
            "Select Mailchimp as the campaign tool and sync your account with the CRM.",
            "Copy and paste the API key from the Mailchimp account into the CRM.",
            "Save it to complete the integration.",
          ],
        },
      ],
      additionalText:
        "For a more detailed setup guide, please refer to our comprehensive",
      IinkText: "CRM Mailchimp integration documentation",
      url: "https://blog.peppercloud.com/mailchimp-crm-integration/",
      userCases: {
        heading: "Mailchimp CRM integration - Application and use cases",
        body: [
          {
            title: "Lead nurturing:",
            points: [
              "Automatically add new CRM leads to specific Mailchimp lists.",
              "Create targeted email sequences based on lead status and behaviour.",
              "Track email engagement to prioritise follow-ups in the CRM.",
            ],
          },
          {
            title: "Customer segmentation:",
            points: [
              "Use CRM data to create highly specific audience segments in Mailchimp.",
              "Send personalised content based on customer preferences and history.",
              "Improve campaign performance with laser-focused targeting.",
            ],
          },
          {
            title: "Sales funnel optimisation:",
            points: [
              "Trigger automated email campaigns as leads progress through your sales funnel.",
              "Use email engagement data to refine your sales approach.",
              "Align your sales and marketing efforts for a cohesive customer journey.",
            ],
          },
          {
            title: "Re-engagement campaigns:",
            points: [
              "Identify inactive customers in your CRM and target them with specialised campaigns.",
              "Use historical data to create compelling offers for past customers.",
              "Track re-engagement success and update CRM records automatically.",
            ],
          },
          {
            title: "Event marketing:",
            points: [
              "Seamlessly manage event invitations and RSVPs between Mailchimp and your CRM.",
              "Send personalised follow-ups based on attendee engagement.",
              "Update CRM records with event participation data for future targeting.",
            ],
          },
          {
            title: "Product updates and upselling:",
            points: [
              "Segment customers based on purchase history and send relevant product updates.",
              "Create targeted upsell campaigns using CRM data on customer preferences.",
              "Track campaign success and update sales opportunities in your CRM.",
            ],
          },
        ],
      },
      about: {
        title: "About Mailchimp",
        text: "Mailchimp is a top-tier marketing platform designed for businesses of all sizes. It provides an array of features, such as email marketing, automation, and audience management. With its intuitive tools and comprehensive capabilities, Mailchimp is perfect for CRM integrations. It enables businesses to seamlessly create, send, and analyse impactful email campaigns within a unified marketing solution.",
      },
      faq: {
        title: "Mailchimp CRM FAQs",
        body: [
          {
            question:
              "What is required to integrate Mailchimp with Pepper Cloud CRM?",
            answer:
              "You need a Mailchimp account with at least one audience list and access to your Pepper Cloud CRM account.",
          },
          {
            question: "Can I sync contacts and leads from CRM to Mailchimp?",
            answer:
              'Yes, you can sync contacts and leads by going to the respective module and selecting "Actions" and then "Sync to Mailchimp."',
          },
          {
            question: "Does syncing create duplicate records in Mailchimp?",
            answer:
              "No, Mailchimp recognises duplicate entries and ignores them during the sync process.",
          },
          {
            question:
              "Can I access Mailchimp campaign reports within Pepper Cloud CRM?",
            answer:
              'Yes, navigate to "Mailchimp" in the CRM dashboard to view an overview and insights about your Mailchimp campaigns.',
          },
          {
            question: "Can I map custom fields during the integration?",
            answer:
              "Yes, default fields are automatically mapped, and you can manually map custom fields as needed.",
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/mailchimp-crm-integration/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Mailchimp website",
          url: "https://mailchimp.com/",
        },
      ],
    },
    "mailerlite-crm-with-email-marketing": {
      seo: {
        title:
          "CRM with MailerLite Integration | Pepper Cloud",
        keywords:
          "mailerlite CRM integrations, mailerlite integrations, email marketing crm integration",
        description:
          "Connect MailerLite to Pepper Cloud CRM. Qualify leads based on email clicks. Track campaign metrics on CRM dashboards, and trigger sales follow-ups.",
        link: "../crm-integrations/mailerlite-crm-with-email-marketing",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=MailerLite&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=MailerLite&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case15hero,
      tags: "Email marketing software |  CRM email marketing software | Best CRM for email marketing | CRM for email marketers",
      alt: "Best MailerLite CRM integration",
      // name: bannerImg["mailerLite integration"],
      pageTitle: "MailerLite",
      heading: "Best MailerLite CRM integration",
      toptitle: "Enhance email marketing with CRM MailerLite integration.",
      topdescription:
        "MailerLite integrations offer powerful solutions for businesses looking to streamline their email marketing efforts. By connecting MailerLite with a robust CRM system, you can automate email marketing campaigns, gain customer behaviour insights, and refine your sales strategies effortlessly.",
      body: [
        {
          title: "Benefits of MailerLite CRM integration",
          boldPoints: [
            {
              boldText: "Seamless data synchronisation:",
              text: "Enjoy two-way data sync between MailerLite and your CRM, ensuring up-to-date information across platforms.",
            },
            {
              boldText: "Enhanced segmentation:",
              text: "Utilise CRM data to create highly targeted email lists for more effective marketing.",
            },
            {
              boldText: "Comprehensive reporting:",
              text: "Gain deeper insights by combining email marketing metrics with CRM data for a holistic view of customer interactions.",
            },
            {
              boldText: "Improved team collaboration:",
              text: "Foster better communication between marketing and sales teams with shared data and insights.",
            },
            {
              boldText: "Personalised customer journeys:",
              text: "Create tailored email sequences based on customer behaviour and preferences. This leads to improved customer satisfaction and loyalty.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for MailerLite integration?",
          description:
            "Pepper Cloud CRM offers a seamless integration with MailerLite, providing several unique advantages that set it apart from other email marketing CRM integration options:",
          boldPoints: [
            {
              boldText: "Fields mapping:",
              text: "Easily map MailerLite fields to CRM fields during integration. This allows you to ensure that all relevant data is accurately transferred and aligned between the two systems, making the integration process smooth and efficient.",
            },
            {
              boldText: "Two-way synchronisation:",
              text: "Maintain consistency and accuracy in your records with two-way sync between your email marketing platform and CRM. This integration ensures that any changes made in one system are automatically reflected in the other, keeping your data up-to-date and reliable across both platforms.",
            },
            {
              boldText: "Real-time insights:",
              text: "Visualise email campaign metrics through intuitive CRM dashboard for informed decision-making. Email marketing CRM integration provides up-to-the-minute data, allowing you to make agile marketing decisions.",
            },
            {
              boldText: "Elimination of manual data entry:",
              text: "Save time and reduce errors by automating data transfer between platforms. This automation is a key feature of Pepper Cloud CRM MailerLite integration, freeing your team to focus on strategy rather than data management.",
            },
            {
              boldText: "Comprehensive customer view:",
              text: "Pepper Cloud combines MailerLite data with other customer interactions, providing a 360-degree view of each contact. This holistic approach is crucial for delivering personalised experiences across all touchpoints.",
            },
            {
              boldText: "Advanced segmentation capabilities:",
              text: "Leverage Pepper Cloud CRM powerful segmentation tools in conjunction with MailerLite's email features to create highly targeted campaigns. This synergy between CRM and email marketing tools is what makes Pepper Cloud's integration stand out.",
            },
          ],
        },
        {
          title: "How to integrate MailerLite with Pepper Cloud CRM?",
          pointers: [
            "Navigate to settings in CRM.",
            "Choose MailerLite as the campaign tool from the Integration screen.",
            "Get the API key from your MailerLite account to integrate.",
            "Save it to complete the integration.",
          ],
        },
      ],
      additionalText:
        "For a more detailed setup guide, please refer to our comprehensive",
      IinkText: "MailerLite integration setup guide",
      url: "https://blog.peppercloud.com/mailerlite-crm-integration/",
      userCases: {
        heading: "MailerLite CRM Integration - Applications and use Cases",
        body: [
          {
            title: "Sales team:",
            points: [
              "Lead qualification: Automatically qualify leads based on email engagement, helping sales prioritise high-potential prospects.",
              "Sales pipeline management: Track leads from initial email contact through the sales funnel, with automated updates based on email interactions.",
              "Personalised follow-ups: Use email engagement data to tailor sales pitches and follow-up communications.",
            ],
          },
          {
            title: "Marketing team:",
            points: [
              "Campaign performance analysis: Combine CRM data with MailerLite metrics for comprehensive campaign evaluation.",
              "Content personalisation: Use CRM insights to create highly targeted email content for different customer segments.",
              "Customer lifecycle marketing: Design and automate email sequences for each stage of the customer journey.",
            ],
          },
          {
            title: "Support team:",
            points: [
              "Proactive customer communication: Send targeted emails based on support ticket history or product usage data from the CRM.",
              "Customer satisfaction surveys: Automate post-interaction surveys and feed results back into the CRM for analysis.",
              "Knowledge base updates: Use common support queries to inform email content, directing customers to relevant resources.",
            ],
          },
          {
            title: "Remote teams:",
            points: [
              "Centralised customer communication: Ensure all team members have access to the latest customer email interactions, regardless of location.",
              "Automated workflow notifications: Set up email alerts for important CRM updates, keeping remote team members in sync.",
              "Collaborative campaign management: Enable remote teams to plan, execute, and analyse email campaigns using shared CRM data.",
            ],
          },
        ],
      },
      about: {
        title: "About MailerLite",
        text: "MailerLite is a user-friendly email marketing platform designed to help businesses of all sizes create, send, and manage effective email campaigns. With its intuitive interface and powerful features, MailerLite enables marketers to design beautiful emails, automate workflows, and analyse campaign performance. By integrating MailerLite with a CRM system, businesses can amplify their email marketing efforts and achieve greater results.",
      },
      faq: {
        title: "MailerLite CRM integration - FAQs",
        body: [
          {
            question:
              "How does MailerLite CRM integration improve email marketing?",
            answer:
              "Email marketing CRM integration allows for better segmentation, personalisation, and automation of email campaigns based on CRM data, leading to more effective marketing efforts.",
          },
          {
            question:
              " Is technical expertise required to set up the MailerLite integration with Pepper Cloud CRM?",
            answer:
              "No, the integration process is designed to be user-friendly and can be completed in just a few steps without technical knowledge.",
          },
          {
            question:
              "Can I track email campaign performance within my CRM after integration?",
            answer:
              "Yes, most integrations allow you to view email metrics directly in your CRM, providing a comprehensive view of customer interactions.",
          },
          {
            question:
              "How secure is the data transfer between MailerLite and my CRM?",
            answer:
              "The best CRM for MailerLite integration, Pepper Cloud, uses industry-standard encryption and security protocols to ensure the safe transfer of data between platforms. So, your data is secure and always protected.",
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/mailerlite-crm-integration/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "MailerLite website",
          url: "https://www.mailerlite.com/",
        },
      ],
    },
    "quickbooks-accouting-tool": {
      seo: {
        title:
          "Quickbooks Integration with CRM | Pepper Cloud",
        keywords:
          "quickbooks crm integration, crm software that integrates with quickbooks, crm quickbooks integration, crm integration with quickbooks",
        description:
          "Connect QuickBooks to Pepper Cloud CRM to unify sales quotes and accounting. Auto-fill pricing and convert quotes into invoices.",
        link: "https://peppercloud.com/crm-integrations/quickbooks-accouting-tool",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=QuickBooks&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=QuickBooks&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case14hero,
      tags: "Accounting software |  CRM accounting software | Best CRM for accounting firms | CRM for accountants",
      alt: "Best QuickBooks CRM integrations",
      // name: bannerImg["mailerLite integration"],
      pageTitle: "QuickBooks",
      heading: "Best QuickBooks CRM integrations",
      toptitle:
        "Create, send, and track estimates with QuickBooks integration.",
      topdescription:
        "Simplify your workflow with Pepper Cloud CRM QuickBooks integration. It empowers you to generate and manage sales estimates. With just a click, you can effortlessly track estimates without constant app switching.",
      body: [
        {
          title: "Benefits of QuickBooks CRM integration",
          boldPoints: [
            {
              boldText: "Enhanced estimate management:",
              text: "Create, send, and track estimates directly from your CRM, with the ability to easily convert them into invoices once approved. This streamlined process reduces errors and speeds up the sales cycle.",
            },
            {
              boldText: "Improved data accuracy:",
              text: "Eliminate manual data entry and reduce errors by syncing customer information and financial data automatically.",
            },
            {
              boldText: "Enhanced customer insights:",
              text: "Get a 360-degree view of your customers by combining financial history with CRM data.",
            },
            {
              boldText: "Real-time estimate tracking:",
              text: "Monitor the status of your estimates in real time, whether they are accepted, declined, or pending, all within your CRM interface.",
            },
            {
              boldText: "Automated data synchronisation:",
              text: "Eliminate manual data entry errors by automatically syncing estimate details between your CRM and QuickBooks.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for QuickBooks integration?",
          description:
            "Pepper Cloud offers a robust CRM solution that integrates seamlessly with QuickBooks, providing numerous advantages for businesses:",
          boldPoints: [
            {
              boldText: "Easy setup and configuration:",
              text: "Pepper Cloud's QuickBooks integration can be set up quickly and easily, with no need for complex technical knowledge. Our user-friendly interface guides you through the process, ensuring a smooth integration experience.",
            },
            {
              boldText: "Real-time data synchronisation:",
              text: "With Pepper Cloud, your CRM and QuickBooks data are synchronised in real-time. This means that any changes made in the QuickBooks account are immediately reflected in the CRM system, ensuring that your team always has access to the most up-to-date information.",
            },
            {
              boldText: "Excellent customer support:",
              text: "Our dedicated support team is always ready to assist you with any questions or issues related to your QuickBooks CRM integration. We provide comprehensive documentation, video tutorials, and personalised support to ensure you get the most out of your integration.",
            },
            {
              boldText: "Real-time status updates:",
              text: "Keep track and monitor estimate statuses in real-time across both platforms. Whether an estimate is accepted, declined, or still pending, the status is instantly updated in both QuickBooks and Pepper Cloud CRM.",
            },
            {
              boldText: "Auto-population of data:",
              text: "With just a click, automatically fill in product details, pricing, tax information, and more in your CRM from QuickBooks. This reduces the risk of manual data entry errors and ensures that estimates are accurate.",
            },
            {
              boldText: "Instant notifications via workflow automation:",
              text: "Stay on top of your estimate process with instant email notifications powered by workflow automation. You can set up custom triggers for various events related to your estimates.",
            },
          ],
        },
        {
          title: "How to integrate QuickBooks with Pepper Cloud CRM Software?",
          pointers: [
            "Navigate to the 'Integration' screen in CRM.",
            "Go with accounting tool integration.",
            "Integrate with QuickBooks.",
            "Sign in to your QuickBooks account.",
            "Connect with QuickBooks to complete the integration.",
          ],
        },
      ],
      additionalText: "For detailed steps, refer to the",
      IinkText: "QuickBooks setup guide",
      url: "https://blog.peppercloud.com/quickbooks-crm-integration-guide/",
      userCases: {
        heading: "CRM QuickBooks integration - Application and use cases",
        body: [
          {
            title: "Sales team",
            points: [
              "Generate accurate quotes and convert them into invoices seamlessly.",
              "Reduce administrative work and improve overall sales process efficiency.",
              "Access real-time financial information directly from the CRM.",
              "Make informed decisions during negotiations based on up-to-date customer data.",
              "Quickly check customer payment history, outstanding balances, and credit limits.",
              "Identify upsell and cross-sell opportunities based on purchase history.",
            ],
          },
          {
            title: "Marketing team",
            points: [
              "Gain valuable insights by combining financial data with customer information.",
              "Segment audience based on purchasing behaviour and lifetime value.",
              "Create more personalised and effective marketing strategies.",
              "Track campaign performance in relation to financial outcomes.",
              "Identify high-value customers for targeted marketing initiatives.",
              "Analyse the financial impact of different marketing channels and campaigns.",
            ],
          },
          {
            title: "Support team",
            points: [
              "Access a customer's complete financial history alongside support tickets.",
              "Provide more informed and personalised assistance to customers.",
              "Quickly resolve billing-related queries and check payment statuses.",
              "Process refunds or credits directly from the CRM when necessary.",
              "Improve response times and enhance overall customer satisfaction.",
              "Prioritise support for high-value customers based on financial information.",
            ],
          },
          {
            title: "Finance team",
            points: [
              "Easily reconcile CRM data with QuickBooks records and ensure accuracy across all systems by reducing manual data entry.",
              "Generate comprehensive financial reports incorporating CRM data and gain deeper insights into customer profitability and sales performance.",
              "Simplify accounts receivable processes by automating invoice creation and payment tracking.",
              "Improve cash flow management with real-time visibility into outstanding invoices.",
              "Enhance budgeting and forecasting accuracy using combined CRM and financial data.",
            ],
          },
        ],
      },
      about: {
        title: "About QuickBooks",
        text: "QuickBooks is a leading accounting software developed by Intuit, designed to help small and medium-sized businesses manage their finances effectively. It offers a range of features including invoicing, expense tracking, payroll management, and financial reporting. QuickBooks is known for its user-friendly interface and robust capabilities, making it a popular choice for businesses across various industries. With its cloud-based and desktop versions, QuickBooks provides flexibility and scalability to meet diverse business needs.",
      },
      faq: {
        title: "QuickBooks CRM integration FAQs",
        body: [
          {
            question: "What is QuickBooks CRM integration?",
            answer:
              "QuickBooks CRM integration refers to the process of connecting your Customer Relationship Management (CRM) software with QuickBooks accounting software. This integration allows for seamless data flow between the two systems, enabling businesses to manage customer relationships and financial data more effectively.",
          },
          {
            question:
              "How does CRM integration with QuickBooks benefit my business?",
            answer:
              "CRM QuickBooks integration offers numerous benefits, including improved data accuracy, enhanced customer insights, streamlined sales estimations, efficient reporting, time-saving automation, and improved cash flow management. It helps businesses make data-driven decisions and provide better customer service.",
          },
          {
            question: "Is it difficult to set up QuickBooks CRM integration?",
            answer:
              "No, with Pepper Cloud, the best CRM for QuickBooks, you can connect QuickBooks in no minutes, even without extensive technical knowledge.",
          },
          {
            question:
              "How secure is the data transfer between my CRM and QuickBooks?",
            answer:
              "Pepper Cloud CRM uses encryption protocols and secure APIs to ensure that data transferred between the systems is protected. Your data is encrypted, safe, and protected.",
          },
          {
            question: "How can I send QuickBooks estimates to my clients?",
            answer:
              "You can generate the estimate link or download the estimate in PDF format. You can send it through email, WhatsApp, or share the estimate link as a message.",
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/quickbooks-crm-integration-guide/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Quickbooks website",
          url: "https://quickbooks.intuit.com/",
        },
      ],
    },
    "google-contacts-integration": {
      seo: {
        title: "Sync & Manage with Google Contacts - CRM",
        keywords:
          "crm with google contacts,Google contact integration, google contacts crm, crm with google contacts",
        description:
          "Import Google Contacts directly into Pepper Cloud CRM. Map custom fields, and organize contacts into targeted lists. You sales follow-ups become faster",
        link: "https://peppercloud.com/crm-integrations/google-contacts-integration",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Google_Contacts&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Google_Contacts&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case16hero,
      alt: "Best CRM with Google Contacts integration",
      pageTitle: "Google Contacts",
      // name: bannerImg["google-contacts-integration"],
      heading: "Best CRM with Google Contacts integration",
      toptitle:
        "Effortlessly sync and manage your contacts with the leading CRM with Google Contacts integration.",
      topdescription:
        "Transform your contact management with the seamless integration of Google Contacts and Pepper Cloud CRM. Eliminate manual data entry and messy CSV files with two-way synchronisation, and handle customer data with ease.",
      tags: "Contact management | Contact sync | Google workspace",
      body: [
        {
          title: "Benefits of Google Contacts CRM integration",
          boldPoints: [
            {
              boldText: "Effortless contact import:",
              text: "Seamlessly import all your Google Contacts into the CRM, eliminating the need for any back and forth.",
            },
            {
              boldText: "Unified contact management:",
              text: "Access all contacts from a single, centralised location within your CRM.",
            },
            {
              boldText: "Improved data accuracy:",
              text: "Minimise duplicates and maintain consistent records by eliminating manual intervention.",
            },
            {
              boldText: "Enhanced productivity:",
              text: "Streamline workflows by integrating the two essential business tools.",
            },
            {
              boldText: "Seamless Google Workspace integration:",
              text: "Leverage the full power of Google's ecosystem within your CRM.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Google Contacts integration?",
          description:
            "Pepper Cloud is the top CRM for Google Contacts, offering seamless integration and robust features:",
          boldPoints: [
            {
              boldText: "Advanced segmentation: ",
              text: "Categorise imported contacts into custom segments based on predefined criteria, enhancing your ability to target and personalise communications.",
            },
            {
              boldText: "Smart deduplication: ",
              text: "Our proprietary algorithm not only prevents duplicates but also merges existing records found within the CRM.",
            },
            {
              boldText: "Custom activity logging: ",
              text: "Create and log activities in your CRM based on interactions detected in your Google account, such as emails sent or calendar events.",
            },
            {
              boldText: "Privacy controls: ",
              text: "Granular privacy settings allow you to control which team members can access synced Google Contacts data within the CRM.",
            },
          ],
        },
        {
          title: "How to integrate Google Contacts with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Navigate to “Integration” through CRM user settings.",
            "Choose “Contacts” and integrate with Google Contacts.",
            "Complete the integration process by choosing a Google account.",
          ],
        },
      ],
      additionalText: "",
      IinkText: "",
      url: "",
      userCases: {
        heading: "Google Contacts CRM integration - Application and use cases",
        body: [
          {
            title: "Sales team efficiency:",
            points: [
              "Automatically import leads from personal Google Contacts into the CRM.",
              "Ensure sales representatives always have the latest contact information.",
              "Streamline follow-ups by having all contact details readily available in the CRM.",
            ],
          },
          {
            title: "Networking and relationship building:",
            points: [
              "Easily transfer professional contacts from personal Google accounts to the CRM.",
              "Track and nurture relationships with key industry figures and potential partners.",
              "Maintain a comprehensive network database within your CRM.",
            ],
          },
          {
            title: "Customer support enhancement:",
            points: [
              "Provide support teams with up-to-date customer contact information.",
              "Improve response times by eliminating the need to search for contact details.",
              "Enhance the customer experience with personalised support based on accurate information.",
            ],
          },
          {
            title: "Event management:",
            points: [
              "Seamlessly import event attendees from Google Contacts to your CRM.",
              "Efficiently manage follow-ups and communications post-event.",
              "Track event participation and engagement over time.",
            ],
          },
          {
            title: "Marketing campaign optimisation:",
            points: [
              "Create targeted marketing lists using imported Google Contacts data.",
              "Ensure marketing communications reach the right individuals with accurate contact information.",
              "Improve campaign effectiveness with up-to-date contact details.",
            ],
          },
        ],
      },
      about: {
        title: "About Google Contacts",
        text: "Google Contacts is a contact management tool that comes as part of the Google Workspace (formerly G Suite) productivity suite. It allows users to store and organise contact information, including names, phone numbers, email addresses, and other details. Google Contacts syncs across devices and integrates seamlessly with other Google services like Gmail and Google Calendar. Its user-friendly interface and robust features make it a popular choice for both personal and professional contact management. By integrating Google Contacts with your CRM, you can enhance contact management and streamline communication easily.",
      },
      faq: {
        title: "Google Contacts CRM FAQs",
        body: [
          {
            question:
              "What is Google Contacts integration with Pepper Cloud CRM? ",
            answer:
              "Google Contacts integration allows you to import your Google Contacts directly within Pepper Cloud CRM.",
          },
          {
            question:
              "How secure is my data with Google Contacts integration? ",
            answer:
              "Pepper Cloud CRM adheres to stringent data security protocols, ensuring your contact information is protected.",
          },
          {
            question:
              "Will the integration help in eliminating duplicate contacts? ",
            answer:
              "Yes, the integration ensures data accuracy by preventing duplicate entries. An error message is triggered whenever a record with a matching email ID (which serves as the unique identifier) is detected.",
          },
          {
            question:
              "Can I import historical Google contact data into Pepper Cloud CRM?",
            answer:
              "Yes, you can easily import historical contact data from Google into Pepper Cloud CRM. The system allows you to bring in contacts from specific time frames or categories, ensuring all essential information is preserved.",
          },
          {
            question: "Can I export Google contacts from Pepper Cloud CRM?",
            answer:
              "Yes, Pepper Cloud CRM allows you to export Google contacts. You can select the contacts you want to export and choose the appropriate format.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Google Contacts website",
          url: "https://contacts.google.com/",
        },
      ],
    },
    "google-drive-integration": {
      seo: {
        title: "Google Drive Integration | Pepper Cloud CRM",
        keywords: "google drive crm integration, google drive crm",
        description:
          "Link Google Drive to Pepper Cloud CRM. Store files in Google Drive, edit in real time with teammates, and track client document views in Pepper Cloud.",
        link: "https://peppercloud.com/crm-integrations/google-drive-integration/",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Google_Drive&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Google_Drive&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case17hero,
      alt: "Best Google Drive CRM integration",
      pageTitle: "Google Drive",
      // name: bannerImg["google-drive-integration"],
      heading: "Best Google Drive CRM integration",
      toptitle: "Store and retrieve documents with Google Drive integration.",
      topdescription:
        "Elevate your document management and collaboration with Pepper Cloud CRM's seamless Google Drive CRM integration. This powerful combination allows you to effortlessly store, access, and manage your files directly within your CRM system.",
      tags: "Data management | Storage management | Best CRM for Google Workspace",
      body: [
        {
          title: "Benefits of Google Drive CRM integration",
          boldPoints: [
            {
              boldText: "Centralised document management:",
              text: "Store and access all your important files in one place, eliminating the need to switch between platforms.",
            },
            {
              boldText: "Enhanced collaboration:",
              text: "Share documents with team members and clients easily, fostering better communication and teamwork.",
            },
            {
              boldText: "Improved organisation:",
              text: "Link files to specific CRM records, ensuring that relevant documents are always at your fingertips.",
            },
            {
              boldText: "Efficient attachment handling:",
              text: "Store attachments from and messages directly in your CRM, keeping your inbox clutter-free and your documents organised.",
            },
          ],
        },
        {
          title: "Why Choose Pepper Cloud for Google Drive integration?",
          description:
            "Pepper Cloud stands out as the best Google Drive CRM, offering seamless integration and robust features:",
          boldPoints: [
            {
              boldText: "User-friendly interface: ",
              text: "Pepper Cloud’s intuitive design makes it easy to navigate and manage your Google Drive files within the CRM.",
            },
            {
              boldText: "Adaptive file handling: ",
              text: "Seamlessly work with files between the CRM and Google Drive, maintaining format consistency.",
            },
            {
              boldText: "Customisable file structure: ",
              text: "Create an organised file hierarchy that aligns with your business processes and workflow.",
            },
            {
              boldText: "Robust security: ",
              text: "Benefit from enterprise-level security measures to protect your sensitive documents and data.",
            },
            {
              boldText: "Comprehensive support: ",
              text: "Access our dedicated support team and resources to maximise the potential of your Google Drive CRM integration.",
            },
          ],
        },
        {
          title: "How to integrate Google Drive with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Navigate to “User Settings” in your Pepper Cloud CRM.",
            "Select “Storage” in the integration screen.",
            "Click on “Integrate with Google Drive.”",
            "Provide the email ID associated with your Google account to complete the integration.",
            "Configure your preferences for file handling and synchronisation.",
          ],
        },
      ],
      additionalText: "",
      IinkText: "",
      url: "",
      userCases: {
        heading: "Google Drive CRM integration - Application and use cases",
        body: [
          {
            title: "Sales document management:",
            points: [
              "Store and organise sales proposals, contracts, and presentations linked to specific deals or contacts.",
              "Collaborate on documents in real-time with team members during the sales process.",
              "Track document engagement (views and edits) to gauge client interest and involvement.",
            ],
          },
          {
            title: "Customer support documentation:",
            points: [
              "Maintain a repository of product manuals, troubleshooting guides, and FAQs.",
              "Quickly access and share relevant support documents during customer interactions.",
              "Collaborate on and update support materials based on customer feedback.",
            ],
          },
          {
            title: "Project management:",
            points: [
              "Store project plans, timelines, and deliverables linked to specific client accounts.",
              "Share progress reports and updates with clients directly through the CRM.",
              "Collaborate on project documents with team members and stakeholders.",
            ],
          },
          {
            title: "Marketing asset management:",
            points: [
              "Organise and store marketing collateral, brand guidelines, and campaign assets.",
              "Link marketing materials to specific campaigns or leads within the CRM.",
              "Collaborate on content creation and easily share assets with external partners.",
            ],
          },
          {
            title: "Human resources:",
            points: [
              "Maintain employee records, contracts, and performance reviews securely within the CRM.",
              "Share onboarding documents and company policies with new hires efficiently.",
              "Collaborate on job descriptions and interview feedback forms.",
            ],
          },
          {
            title: "Financial document management:",
            points: [
              "Store invoices, receipts, and financial reports linked to specific accounts or deals.",
              "Collaborate on budget proposals and financial forecasts with team members.",
              "Securely share financial documents with clients or stakeholders when necessary.",
            ],
          },
        ],
      },
      about: {
        title: "About Google Drive",
        text: "Google Drive is a cloud-based file storage and synchronisation service developed by Google. It provides a comprehensive set of features for storing, syncing, and sharing files across devices. With integrated office tools like Google Docs, Sheets, and Slides, Google Drive facilitates real-time collaboration on documents, spreadsheets, and presentations. Its seamless integration capabilities make it an excellent choice for businesses looking to enhance their CRM systems with effective file management and collaborative features.",
      },
      faq: {
        title: "Google Drive CRM FAQs",
        body: [
          {
            question:
              "Can I access my Google Drive files directly from within Pepper Cloud CRM? ",
            answer:
              "Yes, you can access and view your Google Drive files directly within the CRM interface.",
          },
          {
            question:
              "Is it possible to link Google Drive folders to specific CRM records? ",
            answer:
              "Absolutely! You can associate Google Drive folders with contacts, deals, or any other CRM record type.",
          },
          {
            question:
              "Can I control who has access to specific files or folders within the integration? ",
            answer:
              "Yes, as an admin you can set permissions and sharing settings for files and folders.",
          },
          {
            question:
              "Does the integration support Google Workspace accounts? ",
            answer:
              "Yes, our Google Drive CRM integration fully supports both personal Google accounts and Google Workspace accounts.",
          },
          {
            question:
              "Can I search for Google Drive files from within the CRM? ",
            answer:
              "Yes, you can search for and access your Google Drive files directly from the CRM's search function.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Google Drive website",
          url: "https://www.google.com/intl/en_in/drive/",
        },
      ],
    },
    "onedrive-integration": {
      seo: {
        title: "Connect OneDrive to Pepper Cloud CRM",
        keywords: "CRM with onedrive integration,onedrive integration",
        description:
          "Connect Microsoft OneDrive to Pepper Cloud CRM to access client invoices, support docs directly from individual contact profiles",
        link: "https://peppercloud.com/crm-integrations/onedrive-integration",
      },
      heroBg: case18hero,
      contactLink:
        "https://app.peppercloud.com/?utm_source=OneDrive&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=OneDrive&utm_medium=CTA&utm_campaign=marketplace_internal",
      alt: "Best CRM with OneDrive integration",
      // name: bannerImg["onedrive-integration"],
      pageTitle: "OneDrive",
      heading: "Best CRM with OneDrive integration",
      toptitle: "Store and retrieve files on OneDrive with CRM integration.",
      topdescription:
        "Elevate your document management and collaboration capabilities with Pepper Cloud CRM's seamless OneDrive integration. This powerful CRM with OneDrive integration allows you to effortlessly store, access, and manage your files directly within your CRM system, streamlining your workflow and boosting productivity across your organisation.",
      tags: "File sharing & collaboration | Attachment & file management | Storage management",
      body: [
        {
          title: "Benefits of OneDrive CRM integration",
          boldPoints: [
            {
              boldText: "Unified document hub:",
              text: "Consolidate all your critical files in one central location, streamlining access and management without the hassle of juggling multiple platforms.",
            },
            {
              boldText: "Seamless team synergy:",
              text: "Boost interpersonal dynamics and project efficiency by effortlessly sharing and collaborating on files with colleagues and clients alike.",
            },
            {
              boldText: "Contextual file architecture:",
              text: "Create intelligent connections between documents and CRM entries, ensuring instant access to files whenever and wherever you need them.",
            },
            {
              boldText: "Smart attachment integration:",
              text: "Seamlessly store email and chat attachments directly into your CRM ecosystem, maintaining a clutter-free inbox while keeping documents at your fingertips.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for OneDrive integration?",
          description:
            "Pepper Cloud is the top choice when it comes to CRM for OneDrive, offering seamless integration and a host of powerful features:",
          boldPoints: [
            {
              boldText: "Intuitive CRM file management: ",
              text: "Navigate and organise your OneDrive documents effortlessly within Pepper Cloud’s user-friendly CRM interface.",
            },
            {
              boldText: "Seamless file integration: ",
              text: "Effortlessly import OneDrive files into your CRM, streamlining document access and utilisation.",
            },
            {
              boldText: "Tailored file organisation: ",
              text: "Design a bespoke file structure that mirrors your unique business processes, enhancing efficiency and accessibility.",
            },
            {
              boldText: "Enterprise-grade security: ",
              text: "Safeguard your critical documents and data with advanced, industry-standard security protocols.",
            },
            {
              boldText: "Dedicated integration support: ",
              text: (
                <>
                  Reach out to the expert{" "}
                  <a href="https://peppercloud.com/contact/">support team</a> and
                  leverage comprehensive resources to unlock the full potential
                  of your OneDrive-CRM integration.
                </>
              ),
            },
          ],
        },
        {
          title: "How to integrate OneDrive with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Navigate to CRM “User settings”.",
            "Choose “Storage” in the “Integration” screen.",
            "Integrate with OneDrive.",
            "Provide an email ID to complete the integration.",
          ],
        },
      ],
      additionalText: "",
      IinkText: "",
      url: "",
      userCases: {
        heading: "CRM OneDrive integration - Application and use cases",
        body: [
          {
            title: "Sales document management:",
            points: [
              "Store and organise sales proposals, contracts, and presentations linked to specific deals or contacts.",
              "Collaborate on documents in real-time with team members during the sales process.",
              "Track document engagement to gauge client interest and involvement.",
            ],
          },
          {
            title: "Customer support documentation:",
            points: [
              "Maintain a repository of product manuals, troubleshooting guides, and FAQs.",
              "Quickly access and share relevant support documents during customer interactions.",
              "Collaborate on and update support materials based on customer feedback.",
            ],
          },
          {
            title: "Project management:",
            points: [
              "Store project plans, timelines, and deliverables linked to specific client accounts.",
              "Share progress reports and updates with clients directly through the CRM.",
              "Collaborate on project documents with team members and stakeholders in real-time.",
            ],
          },
          {
            title: "Marketing asset management:",
            points: [
              "Organise and store marketing collateral, brand guidelines, and campaign assets.",
              "Link marketing materials to specific campaigns or leads within the CRM.",
              "Collaborate on content creation and easily share assets with external partners.",
            ],
          },
          {
            title: "Human resources:",
            points: [
              "Maintain employee records, contracts, and performance reviews securely within the CRM.",
              "Share onboarding documents and company policies with new hires efficiently.",
              "Collaborate on job descriptions and interview feedback forms.",
            ],
          },
          {
            title: "Financial document management:",
            points: [
              "Store invoices, receipts, and financial reports linked to specific accounts or deals.",
              "Collaborate on budget proposals and financial forecasts with team members.",
              "Securely share financial documents with clients or stakeholders when necessary.",
            ],
          },
        ],
      },
      about: {
        title: "About OneDrive",
        text: "OneDrive is a cloud storage service developed by Microsoft that allows users to store files and personal data in the cloud. With seamless integration with Microsoft Office applications and real-time collaboration features, OneDrive is an essential tool for businesses within the Microsoft ecosystem. By integrating OneDrive with your CRM system, you can enhance file management, improve team collaboration, and ensure data consistency across platforms, driving efficiency and business growth.",
      },
      faq: {
        title: "CRM with OneDrive integration FAQs",
        body: [
          {
            question:
              "Can I directly access my OneDrive files from Pepper Cloud CRM? ",
            answer:
              "Yes, you can easily access and view your OneDrive files directly within the CRM interface.",
          },
          {
            question:
              "Is it possible to link OneDrive folders to specific records in the CRM? ",
            answer:
              "Yes, you can link OneDrive folders to contacts, deals, or any other record type within the CRM.",
          },
          {
            question: "Is OneDrive for business supported in the integration? ",
            answer:
              "Yes, the integration fully supports both personal OneDrive accounts and OneDrive for business accounts.",
          },
          {
            question:
              "How long does it take to import files from OneDrive into the CRM? ",
            answer:
              "Importing files from OneDrive to Pepper Cloud CRM only takes a few seconds.",
          },
          {
            question: "Can I search for OneDrive files directly from the CRM? ",
            answer:
              "Yes, you can use the CRM's search function to find and access your OneDrive files directly.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "OneDrive website",
          url: "https://www.microsoft.com/en-in/microsoft-365/onedrive/online-cloud-storage",
        },
      ],
    },
    "whatsapp-via-twilio": {
      seo: {
        title:
          "Integrate Twilio API for WhatsApp with Pepper Cloud CRM",
        keywords:
          "CRM integration with Twilio API for WhatsApp Buisness,twilio whatsapp integration,twilio api for whatsapp,whatsapp business api integration,how to integrate whatsapp business api,whatsapp business api crm integration,whatsapp business api",
        description:
          "Manage Twilio WhatsApp chats directly inside Pepper Cloud CRM. Send real-time order updates. Send instant lead replies, and automate sales follow-ups",
        link: "https://peppercloud.com/crm-integrations/whatsapp-via-twilio",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=WATwilio&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=WATwilio&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case26hero,
      alt: " Best CRM integrated with Twilio API for WhatsApp Business",
      // name: bannerImg["whatsapp-via-twilio"],
      pageTitle: "WhatsApp with Twilio",
      heading: "Best CRM integration with Twilio API for WhatsApp Business",
      toptitle:
        "Effortlessly link your CRM with WhatsApp Business using Twilio's API for real-time customer communication and improved engagement.",
      topdescription:
        "Revolutionise your customer interactions with Pepper Cloud's seamless CRM integration with Twilio API for WhatsApp Business. This powerful integration allows you to manage all your WhatsApp Business conversations directly within your CRM platform, streamlining communication, boosting efficiency, and enhancing customer engagement like never before.",
      tags: "Customer support | Bot & messaging | Instant messaging | Social media integration",
      body: [
        {
          title: "Benefits of WhatsApp Business API CRM integration",
          boldPoints: [
            {
              boldText: "Enhanced customer experience:",
              text: "Offer a convenient and familiar communication channel preferred by billions worldwide, improving customer satisfaction.",
            },
            {
              boldText: "Streamlined sales and support:",
              text: "Accelerate lead nurturing, improve sales pipeline management, and provide efficient customer service through real-time conversations.",
            },
            {
              boldText: "Data-driven insights:",
              text: "Gather valuable customer data and track communication history for informed decision-making and personalised interactions.",
            },
            {
              boldText: "Increased team productivity:",
              text: "Eliminate app switching and manage all communications within the CRM, saving time and boosting efficiency.",
            },
            {
              boldText: "Automated workflows:",
              text: "Set up automated responses and triggers based on customer interactions, ensuring timely follow-ups and consistent communication.",
            },
          ],
        },
        {
          title:
            "Why choose Pepper Cloud for WhatsApp Business API integration?",
          description:
            "Pepper Cloud stands out as the top CRM for WhatsApp Business API integration, providing seamless connectivity and advanced features:",
          boldPoints: [
            {
              boldText: "Seamless integration: ",
              text: "Experience effortless setup with Pepper Cloud's intuitive interface, eliminating complex configurations.",
            },
            {
              boldText: "Advanced CRM features: ",
              text: "Leverage Pepper Cloud's robust CRM functionalities alongside WhatsApp communication for a comprehensive business solution.",
            },
            {
              boldText: "Exceptional support: ",
              text: "Benefit from dedicated customer support to ensure a smooth integration experience and ongoing assistance.",
            },
            {
              boldText: "Scalability and security: ",
              text: "Enjoy a secure and scalable solution that adapts to your growing business needs while protecting sensitive data.",
            },
            {
              boldText: "Cost-effectiveness: ",
              text: "Maximise your return on investment with Pepper Cloud's competitive pricing plans and feature-rich integration.",
            },
          ],
        },
        {
          title:
            "How to integrate the WhatsApp Business API with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Sign up for a Twilio account and activate the WhatsApp Business API.",
            "Log in to your Pepper Cloud CRM account and select “Twilio WhatsApp Business API” integration option.",
            "Enter your Twilio account SID and Auth Token.",
            "Configure your WhatsApp business number and messaging preferences.",
            "Map WhatsApp fields to corresponding CRM fields.",
            "Set up any desired automations or workflows to complete the integration process.",
          ],
        },
      ],
      additionalText:
        "For a more detailed setup guide, please refer to our comprehensive",
      IinkText:
        "documentation on CRM integration with the Twilio API for WhatsApp Business.",
      url: "https://blog.peppercloud.com/how-to-integrate-your-whatsapp-with-pepper-cloud-crm/",
      userCases: {
        heading:
          "WhatsApp Business API CRM integration - Applications and use cases",
        body: [
          {
            title: "Sales and lead nurturing:",
            points: [
              "Engage leads instantly through WhatsApp, qualifying them faster and increasing conversion rates",
              "Send personalised product recommendations based on customer data stored in the CRM.",
              "Automate follow-up messages to nurture leads through the sales funnel.",
            ],
          },
          {
            title: "Customer support:",
            points: [
              "Provide real-time assistance and resolve issues efficiently within the familiar WhatsApp platform.",
              "Use CRM data to offer personalised support and anticipate customer needs.",
              "Set up automated responses for common queries, improving response times.",
            ],
          },
          {
            title: "Order tracking and notifications:",
            points: [
              "Send automated updates about order status, shipping information, and delivery confirmations.",
              "Allow customers to track their orders or make changes via WhatsApp.",
              "Gather feedback post-delivery to improve customer satisfaction.",
            ],
          },
          {
            title: "Marketing and promotions:",
            points: [
              "Launch targeted marketing campaigns based on customer segments in your CRM.",
              "Share product updates, special offers, and event invitations directly through WhatsApp.",
              "Measure campaign effectiveness by tracking engagement within the CRM.",
            ],
          },
          {
            title: "Appointment scheduling:",
            points: [
              "Enable customers to book, reschedule, or cancel appointments via WhatsApp.",
              "Send automated reminders and confirmations to reduce no-shows.",
              "Sync appointments directly with your CRM calendar.",
            ],
          },
          {
            title: "Feedback collection:",
            points: [
              "Send post-interaction surveys through WhatsApp for immediate feedback.",
              "Automatically update customer profiles in the CRM based on feedback received.",
              "Identify and address issues quickly to improve customer satisfaction.",
            ],
          },
        ],
      },
      about: {
        title: "About WhatsApp Business API",
        text: "The WhatsApp Business API is a powerful tool that enables businesses, especially medium and large enterprises, to communicate with customers at scale through the WhatsApp platform. It offers features such as automated messages, chatbots, and seamless integration with CRM systems. Unlike the WhatsApp Business app, the API is designed for high-volume messaging and complex business needs and requires integration through a Business Solution Provider (BSP) like Twilio.",
      },
      faq: {
        title: "CRM integration with Twilio API for WhatsApp Business FAQs",
        body: [
          {
            question:
              "Is the WhatsApp Business API different from the WhatsApp Business app? ",
            answer:
              "Yes, the API is designed for growing and larger businesses and offers more advanced features and integration capabilities.",
          },
          {
            question:
              "How does the Twilio integration work with the WhatsApp Business API? ",
            answer:
              "Twilio acts as a middleware, simplifying the process of connecting your CRM to the WhatsApp Business API.",
          },
          {
            question:
              "Can I automate responses using the WhatsApp Business API CRM integration? ",
            answer:
              "Yes, you can set up automated workflows and responses based on customer interactions and CRM data.",
          },
          {
            question:
              "Is it possible to have multiple team members use the WhatsApp integration simultaneously? ",
            answer:
              "Yes, Pepper Cloud CRM allows multiple users to manage WhatsApp conversations with proper access controls.",
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/how-to-integrate-your-whatsapp-with-pepper-cloud-crm/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "WhatsApp Twilio website",
          url: "https://www.twilio.com/en-us/messaging/channels/whatsapp",
        },
      ],
    },
    "google-form": {
      seo: {
        title: "Google Forms Integration | Pepper Cloud CRM",
        keywords:
          "CRM with google form integration, integrate google forms into website, google forms crm",
        description:
          "Convert Google Forms submissions into Pepper Cloud CRM leads via Zapier. Auto-map custom form fields, trigger instant follow-up alerts, and eliminate manual entry.",
        link: "https://peppercloud.com/crm-integrations/google-form",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Google_Forms&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Google_Forms&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case19hero,
      alt: "Google Forms CRM",
      pageTitle: "Google Form",
      // name: bannerImg["google-form"],
      heading: "Best CRM with Google Forms integration",
      toptitle: "Record and manage data with CRM Google Forms integration.",
      topdescription:
        "Elevate your data collection and lead management processes with Pepper Cloud CRM's seamless Google Forms integration. This powerful CRM with Google Form integration allows you to effortlessly capture, organise, and utilise data from your forms directly within your CRM, streamlining your workflow.",
      tags: "Online form builder | Web forms | Lead generation | Survey form | Lead capture form | Data management | Google Workplace",
      body: [
        {
          title: "Benefits of Google Forms CRM integration",
          boldPoints: [
            {
              boldText: "Automated data entry:",
              text: "Eliminate manual data input by automatically transferring Google Forms responses into your CRM.",
            },
            {
              boldText: "Real-time data synchronisation:",
              text: "Ensure your team always has the most up-to-date information with instant syncing between Google Forms and your CRM.",
            },
            {
              boldText: "Customisable data capture:",
              text: "Tailor your forms to collect specific information that aligns with your business needs and CRM structure.",
            },
            {
              boldText: "Enhanced lead management:",
              text: "Convert form responses into leads, contacts, or opportunities within your CRM for immediate follow-up.",
            },
            {
              boldText: "Improved data organisation:",
              text: "Utilise advanced filtering and sorting options to effectively organise and analyse form data within your CRM.",
            },
            {
              boldText: "Seamless website integration:",
              text: "Easily integrate Google Forms into your website and automatically funnel responses into your CRM.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Google Forms integration?",
          description:
            "Pepper Cloud excels as the premier CRM for Google Forms, thanks to its effortless integration and robust capabilities:",
          boldPoints: [
            {
              boldText: "User-friendly interface: ",
              text: "Navigate and manage your Google Forms data effortlessly within the intuitive CRM platform.",
            },
            {
              boldText: "Flexible data mapping: ",
              text: "Customise how form fields map to your CRM fields for precise data organisation.",
            },
            {
              boldText: "Advanced automation: ",
              text: "Set up workflows to automatically trigger actions based on form submissions.",
            },
            {
              boldText: "Comprehensive analytics: ",
              text: "Gain valuable insights from form data within the CRM.",
            },
            {
              boldText: "Robust security measures: ",
              text: "Protect sensitive form data with enterprise-level security protocols.",
            },
          ],
        },
        {
          title: "How to integrate Google Forms with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Create a Zapier account to enable the integration.",
            "In Zapier, create a new Zap with Google Forms as the trigger app and Pepper Cloud CRM as the action app.",
            "Set up the Zap to map Google Forms lead data to the corresponding fields in Pepper Cloud CRM.",
            "Test the integration to confirm that data is transferring correctly between the platforms.",
            "Activate the Zap and start automatically syncing your Google Forms lead data with Pepper Cloud CRM.",
          ],
        },
      ],
      additionalText: "",
      IinkText: "",
      url: "",
      userCases: {
        heading: "Google Forms CRM integration - Application and use cases",
        body: [
          {
            title: "Lead generation:",
            points: [
              "Create custom lead capture forms and automatically add responses to your CRM as new leads.",
              "Set up automated follow-up sequences based on form submissions.",
              "Track lead sources and conversion rates from different forms.",
            ],
          },
          {
            title: "Customer feedback collection:",
            points: [
              "Design customer satisfaction surveys and link responses to customer profiles in your CRM.",
              "Automatically create support tickets based on negative feedback.",
              "Analyse feedback trends to improve products or services.",
            ],
          },
          {
            title: "Event registration:",
            points: [
              "Manage event sign-ups through Google Forms and sync attendee information with your CRM.",
              "Automate confirmation emails and reminders based on registration data.",
              "Track event participation and engagement for future marketing efforts.",
            ],
          },
          {
            title: "Product orders:",
            points: [
              "Create order forms for products or services and automatically generate opportunities in your CRM.",
              "Track order details and customer preferences for personalised follow-ups.",
              "Analyse purchasing trends to inform inventory and marketing decisions.",
            ],
          },
          {
            title: "Internal data collection:",
            points: [
              "Streamline internal processes by using forms for expense reports, time tracking, or project updates.",
              "Automatically link form submissions to relevant projects or departments within your CRM.",
              "Generate reports on internal operations for improved efficiency.",
            ],
          },
        ],
      },
      about: {
        title: "About Google Forms",
        text: "Google Forms is a free, web-based tool designed for creating surveys, quizzes, and forms, and is part of the Google Workspace suite. It simplifies the process of collecting and organising information, with responses automatically saved in Google Sheets. Google Forms offers a variety of question types, customisable themes, and real-time result analysis. Integrating Google Forms with your CRM system can streamline data collection and enhance customer insights. It also improves overall efficiency by seamlessly importing responses into your CRM for better tracking and management.",
      },
      faq: {
        title: "Google Forms CRM FAQs",
        body: [
          {
            question:
              "Can I integrate multiple Google Forms with my Pepper Cloud CRM? ",
            answer:
              "Yes, you can integrate multiple Google Forms and manage data from within your CRM.",
          },
          {
            question:
              "How quickly does data sync between Google Forms and the CRM? ",
            answer:
              "Data syncs in real-time, ensuring that form submissions are immediately available in your CRM.",
          },
          {
            question:
              "Can I use Google Forms CRM integration for customer surveys on my website? ",
            answer:
              "Absolutely! You can easily integrate Google Forms into your website and automatically funnel responses into your CRM.",
          },
          {
            question:
              "Is it possible to create CRM tasks or notifications based on form submissions? ",
            answer:
              "Yes, you can set up automated workflows to create tasks, send notifications, or trigger other actions based on form submissions.",
          },
          {
            question: "Can I customise how form data is mapped to CRM fields? ",
            answer:
              "Yes, Pepper Cloud CRM allows you to flexibly map Google Forms fields to corresponding CRM fields.",
          },
          {
            question:
              "How secure is the data transfer between Google Forms and the CRM? ",
            answer:
              "We use industry-standard encryption and security protocols to ensure your data remains safe and private during transfer and storage.",
          },
          {
            question:
              "Can I use the integration to update existing CRM records with new form data? ",
            answer:
              "Yes, you can set up the integration to update existing records based on unique identifiers in the form submissions.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Google Forms website",
          url: "https://www.google.com/forms/about/",
        },
      ],
    },
    "shopify-ecommerce-integration": {
      seo: {
        title: "Integrate Shopify with Pepper Cloud CRM",
        keywords:
          "crm shopify integration, crm with shopify, best crm for shopify, shopify crm integrations",
        description:
          "Connect your Shopify store to Pepper Cloud CRM. Auto-sync order status and manage customer support inquiries in one dashboard.",
        link: "https://peppercloud.com/crm-integrations/shopify-ecommerce-integration/",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Shopify&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Shopify&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case20hero,
      pageTitle: "Shopify",
      alt: "best Shopify Forms CRM",
      // name: bannerImg["shopify-ecommerce-integration"],
      heading: "Best CRM Shopify integration",
      toptitle: "Streamline your e-commerce with best CRM for Shopify.",
      topdescription:
        "Enhance your eCommerce shop’s performance with the best CRM Shopify integration through Zapier. This integration offers a seamless solution to sync, manage, and nurture your leads and contacts automatically. By connecting your Shopify store with our powerful CRM, you will empower your team to provide exceptional customer service and drive sales growth.",
      tags: "Ecommerce business | Commerce platform | Shopping and online store",
      body: [
        {
          title: "Benefits of Shopify CRM integration",
          boldPoints: [
            {
              boldText: "Real-time data synchronisation:",
              text: "Automatically sync leads and customer data from Shopify to your CRM, ensuring your team always has the most up-to-date information at their fingertips.",
            },
            {
              boldText: "Improved customer relationships:",
              text: "Access detailed client profiles within the CRM, allowing your team to provide personalised service and build stronger connections with your customers.",
            },
            {
              boldText: "Automated lead nurturing:",
              text: "Set up auto-triggered messages to engage leads and customers at crucial touchpoints, increasing conversion rates and customer retention rates.",
            },
            {
              boldText: "Multichannel communication:",
              text: "Seamlessly continue conversations across different messaging channels within the CRM, providing a consistent and cohesive customer experience.",
            },
            {
              boldText: "Enhanced order management:",
              text: "Keep customers informed with automated order updates, ensuring a smooth fulfilment process and reducing support inquiries.",
            },
            {
              boldText: "Abandoned cart recovery:",
              text: "Leverage the integration to re-engage potential customers who have abandoned their carts, minimising lost sales opportunities.",
            },
            {
              boldText: "Data-driven marketing:",
              text: "Utilise the wealth of customer data collected to create targeted marketing strategies and improve the effectiveness of your promotional efforts.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for Shopify integration?",
          description: "",
          boldPoints: [
            {
              boldText: "WhatsApp integration: ",
              text: "Pepper Cloud, WhatsApp sales CRM allows you to communicate with customers directly through their preferred messaging app, WhatsApp, increasing engagement and responsiveness.",
            },
            {
              boldText: "Capture leads and customer data: ",
              text: "Automatically sync customer information from Shopify store directly into Pepper Cloud CRM and ensure your teams have access to comprehensive customer profiles.",
            },
            {
              boldText: "Instant coupon codes: ",
              text: "Automatically send personalised coupon codes to encourage cart completion, boosting your conversion rates and sales.",
            },
            {
              boldText: "Automated feedback collection: ",
              text: "Set up triggers to gather customer feedback instantly via WhatsApp, helping you improve your products and services with real customer insights.",
            },
            {
              boldText: "Seamless customer support: ",
              text: "Address customer queries, resolve issues and provide support directly through the WhatsApp CRM, ensuring quick and efficient issue resolution.",
            },
            {
              boldText: "User-friendly interface: ",
              text: "With CRM Shopify integration, empower your team to manage customer relationships from a centralised platform, even without extensive technical knowledge.",
            },
          ],
        },
        {
          title: "How to integrate Shopify with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Sign up for a Zapier account.",
            "Choose Shopify as your trigger app in Zapier.",
            "Select the desired trigger event.",
            "Connect your Shopify account to Zapier.",
            "Choose Pepper Cloud CRM as your action app.",
            "Select the corresponding action.",
            "Map the fields between Shopify and Pepper Cloud CRM.",
            "Test the Zap to ensure proper data flow.",
            "Activate the Zap and monitor its performance.",
          ],
        },
      ],
      additionalText:
        "To know how to integrate Shopify with Pepper Cloud CRM, contact our",
      IinkText: "support team.",
      url: "https://peppercloud.com/crm-support/",
      userCases: {
        heading: "Shopify CRM integration - Application and use cases",
        body: [
          {
            title: "Personalised marketing campaigns:",
            points: [
              "Segment customers based on purchase history and browsing behaviour.",
              "Create targeted WhatsApp marketing campaigns for each segment.",
              "Automate follow-up messages based on customer actions.",
              "Track campaign performance and adjust strategies in real-time.",
            ],
          },
          {
            title: "Product recommendations:",
            points: [
              "Analyse customer purchase patterns and browsing history.",
              "Customise recommendations based on customer preferences.",
              "Display personalised suggestions on product pages and in marketing emails.",
              "Track and measure the impact of recommendations on sales and customer satisfaction.",
            ],
          },
          {
            title: "Customer support automation:",
            points: [
              "Set up automated responses for frequently asked questions.",
              "Create a knowledge base integrated with your CRM for quick issue resolution.",
              "Implement chatbots for 24/7 customer support.",
              "Escalate complex issues to human agents seamlessly.",
            ],
          },
          {
            title: "Sales forecasting:",
            points: [
              "Analyse historical sales data to identify trends and patterns.",
              "Use Pepper Cloud CRM sales forecasting feature to predict future sales.",
              "Adjust inventory, staffing, and marketing strategies based on forecasts.",
              "Monitor and improve forecast accuracy over time.",
            ],
          },
        ],
      },
      about: {
        title: "About Shopify",
        text: "Shopify is a leading e-commerce platform that enables businesses of all sizes to create and manage online stores. With its user-friendly interface, extensive app ecosystem, and robust features, Shopify has become a popular choice for entrepreneurs and established brands alike. By integrating Shopify with a powerful CRM like Pepper Cloud, businesses can unlock the full potential of their online stores and provide exceptional customer experiences.",
      },
      faq: {
        title: "Shopify CRM integration FAQs",
        body: [
          {
            question: "What is CRM Shopify integration? ",
            answer:
              "CRM Shopify integration is the process of connecting your Shopify online store with a Customer Relationship Management (CRM) system, such as Pepper Cloud. This integration allows for seamless data synchronisation, automated customer communications, and improved order management.",
          },
          {
            question: "Why do I need a CRM with Shopify? ",
            answer:
              "A CRM with Shopify helps you centralise customer data, automate marketing efforts, and provide better customer support. It enables you to build stronger relationships with your customers, increase sales, and streamline your e-commerce operations.",
          },
          {
            question: "What is the best CRM for Shopify? ",
            answer:
              "While there are several CRMs available for Shopify, Pepper Cloud stands out as the best CRM for Shopify. This is because of its WhatsApp integration, automated marketing features, user-friendly interface, and more.",
          },
          {
            question:
              "How does Shopify CRM integration improve customer service? ",
            answer:
              "Shopify CRM integration provides your support team with comprehensive customer profiles, including purchase history and communication logs. This enables them to offer personalised and efficient support, leading to higher customer satisfaction and loyalty.",
          },
          {
            question: "Is it difficult to set up a CRM Shopify integration? ",
            answer: (
              <>
                With Pepper Cloud, setting up a CRM Shopify integration is
                straightforward and simple. Contact our friendly{" "}
                <a href="https://peppercloud.com/contact/">support team</a> for
                quick set up.
              </>
            ),
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Shopify website",
          url: "https://www.shopify.com/",
        },
      ],
    },
    "google-calendar-integration": {
      seo: {
        title: "Best Sales CRM with Google Calendar Integration",
        keywords:
          "crm with google calendar integration,google calendar integration,integrate calendar google",
        description:
          "Manage all appointment invites inside Pepper Cloud CRM. Real-time Google Calendar sync lets teams share availability, track meeting notes, and set automated alerts.",
        link: "https://peppercloud.com/crm-integrations/google-calendar-integration/",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Google_calendar&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Google_calendar&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case21hero,
      pageTitle: "Google Calendar",
      alt: "Best CRM with Google Calendar integration",
      // name: bannerImg["google-calendar-integration"],
      heading: "Best CRM with Google Calendar integration",
      toptitle:
        "Manage meetings and events effortlessly by integrating Google Calendar within your CRM.",
      topdescription:
        "Supercharge your scheduling and task management with the best CRM with Google Calendar integration. This powerful integration allows you to effortlessly synchronise your personal and professional appointments, eliminating double bookings and streamlining your workflow.",
      tags: "Calendar sync | Meeting scheduler | Schedule appointment | Meeting scheduling | Task, booking, meeting management",
      body: [
        {
          title: "Benefits of Google Calendar CRM integration",
          boldPoints: [
            {
              boldText: "Improved time management:",
              text: "Efficiently schedule and monitor customer interactions by syncing your CRM with Google Calendar.",
            },
            {
              boldText: "Centralised task management:",
              text: "CRM Google Calendar integration lets you manage all tasks and appointments in one place, simplifying schedule tracking and organisation.",
            },
            {
              boldText: "Enhanced productivity:",
              text: "Automate calendar entries and updates to streamline your workflow, saving time and reducing errors by eliminating manual data entry.",
            },
            {
              boldText: "Team collaboration:",
              text: "Share your calendar with team members to easily coordinate schedules and enhance collaboration by keeping everyone informed of availability and appointments.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for Google Calendar integration?",
          description:
            "Pepper Cloud excels as the leading CRM for Google Calendar integration, offering seamless connectivity and advanced features that set it apart from others:",
          boldPoints: [
            {
              boldText: "User-friendly interface: ",
              text: "Easily set up and manage your Google Calendar from within the CRM system.",
            },
            {
              boldText: "Customisable sync options: ",
              text: "Choose which events and calendars to sync based on your needs.",
            },
            {
              boldText: "Real-time updates: ",
              text: "Instant synchronisation ensures your schedule is always up-to-date.",
            },
            {
              boldText: "Comprehensive event details: ",
              text: "Sync full event information, including attendees and notes.",
            },
            {
              boldText: "Multiple calendars support: ",
              text: "Integrate and manage multiple Google Calendars within your CRM.",
            },
            {
              boldText: "Automated reminders: ",
              text: "Set up and sync reminders for important tasks and meetings.",
            },
          ],
        },
        {
          title: "How to integrate Google Calendar with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "In CRM “User settings”, navigate to “Integration”",
            "Choose Calendar from the integrations page.",
            "Click on the “Integrate” button next to Google Calendar.",
            "Enter your Google account or email ID.",
            "Grant the necessary permissions for Pepper Cloud to access your calendar.",
          ],
        },
      ],
      additionalText: "",
      IinkText: "",
      url: "",
      userCases: {
        heading: "Google Calendar CRM integration - Application and use cases",
        body: [
          {
            title: "Sales team scheduling:",
            points: [
              "Sync sales meetings and follow-ups between CRM and Google Calendar.",
              "Automatically block out time for prospecting and customer calls.",
              "Coordinate team schedules for joint client meetings and presentations.",
            ],
          },
          {
            title: "Customer support management:",
            points: [
              "Schedule and track support calls and appointments.",
              "Set reminders for follow-up actions after support interactions.",
              "Manage team availability for customer support shifts.",
            ],
          },
          {
            title: "Project management:",
            points: [
              "Sync project milestones and deadlines with your Google Calendar.",
              "Schedule and track client meetings and project reviews.",
              "Coordinate team member availability for project-related tasks.",
            ],
          },
          {
            title: "Event planning and marketing:",
            points: [
              "Manage marketing campaign timelines across CRM and Google Calendar.",
              "Schedule and track event-related tasks and deadlines.",
              "Coordinate with vendors and team members for event logistics.",
            ],
          },
          {
            title: "Consultancy services:",
            points: [
              "Book and manage client consultations with automatic calendar updates.",
              "Set reminders for preparation and follow-up tasks.",
              "Track billable hours by syncing work sessions to your CRM.",
            ],
          },
        ],
      },
      about: {
        title: "About Google Calendar",
        text: "Google Calendar is a time-management and scheduling calendar service developed by Google. It allows users to create and edit events, set reminders, and share calendars with others. With its user-friendly interface and robust features, Google Calendar has become an essential tool for personal and professional scheduling. Its ability to integrate with other applications, particularly CRM systems like Pepper Cloud, makes it an invaluable asset for businesses looking to streamline their scheduling and customer management processes.",
      },
      faq: {
        title: "Google Calendar CRM FAQs",
        body: [
          {
            question:
              "Can I choose which events sync between my CRM and Google Calendar?",
            answer:
              "Yes, you can customise which types of events and specific calendars are synced between Pepper Cloud CRM and Google Calendar.",
          },
          {
            question:
              "Does the integration work with multiple Google Calendars?",
            answer:
              "Absolutely! You can integrate and manage multiple Google Calendars within Pepper Cloud CRM.",
          },
          {
            question: "Can I create CRM events directly from Google Calendar?",
            answer:
              "Yes, events created in Google Calendar can be automatically synced to your CRM, depending on your settings.",
          },
          {
            question:
              "How often does the integration sync data between Google Calendar and the CRM?",
            answer:
              "The integration syncs in real-time, ensuring that your calendar and CRM are always up-to-date.",
          },
          {
            question:
              "Can I control who sees my synced calendar events within the CRM?",
            answer:
              "Yes, you can set permissions within Pepper Cloud CRM to control which team members have access to your synced calendar events.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Google Calendar website",
          url: "https://workspace.google.com/intl/en_in/products/calendar/",
        },
      ],
    },
    "cin7-dear-inventory": {
      seo: {
        title:
          "Best CRM and Cin7 (formerly Dear Inventory) Integration",
        keywords:
          "Cin7 (Formerly Dear Inventory) CRM integrations,dear systems crm,dear inventory integrations,dear systems integrations,cin7 crm",
        description:
          "Sync Cin7 sales and customer data with Pepper Cloud CRM via Zapier. Automate opportunities, track inventory levels, and eliminate manual data entry.",
        link: "https://peppercloud.com/crm-integrations/cin7-dear-inventory/",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=cin7&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=cin7&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case22hero,
      pageTitle: "Cin7",
      alt: "Cin7 CRM",
      // name: bannerImg["cin7-dear-inventory"],
      heading: "Best Cin7 (Formerly Dear Inventory) CRM integration",
      toptitle:
        "Streamline your business operations with Cin7 CRM integration.",
      topdescription:
        "Our seamless solution connects your Cin7 (formerly Dear Inventory) system with CRM, enabling real-time syncing of sales data and customer data. The Cin7 CRM integration, facilitated through Zapier, ensures that your CRM always has the most up-to-date information from Dear Systems, enhancing your sales process and customer management.",
      tags: "ERP software | Inventory management",
      body: [
        {
          title: "Benefits of Cin7 CRM integration",
          boldPoints: [
            {
              boldText: "Real-time data synchronisation:",
              text: "Keep your CRM constantly updated with the latest sales information from Cin7, ensuring all team members have access to accurate, timely data for informed decision-making.",
            },
            {
              boldText: "Enhanced sales tracking:",
              text: "Automatically update opportunities and accounts in your CRM based on Cin7 sales and customer data, allowing for more precise sales forecasting and performance analysis.",
            },
            {
              boldText: "Improved customer insights:",
              text: "By integrating Cin7 with your CRM, gain a comprehensive view of customer interactions, purchase history, and preferences, enabling more personalised customer service and targeted marketing efforts.",
            },
            {
              boldText: "Improved sales process:",
              text: "Automatically create and update opportunities in CRM based on Cin7 sales, keeping your sales team informed and prepared. This streamlined process helps to shorten sales cycles, improve follow-ups, and ultimately increase conversion rates.",
            },
            {
              boldText: "Increased efficiency:",
              text: "Eliminate manual data entry and reduce human errors by automating the flow of information between Cin7 and your CRM. This automation not only saves time but also optimises resources, allowing your team to focus on more strategic tasks.",
            },
            {
              boldText: "Better inventory management:",
              text: "With real-time sales data synced to your CRM, make more accurate inventory forecasts and optimise stock levels to meet customer demand effectively. This reduces the risk of overstocking or stockouts.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for Cin7 integration?",
          description: "",
          boldPoints: [
            {
              boldText: "Seamless integration process: ",
              text: "Our experts ensure a smooth connection between Cin7 and Pepper Cloud CRM, minimising disruption to your daily operations. We handle the technical complexities, allowing you to focus on leveraging the integration to drive your business forward.",
            },
            {
              boldText: "Customisable solution: ",
              text: "Tailor the integration to match your unique business requirements, ensuring it aligns perfectly with your workflow. Our flexible approach allows you to configure field mappings and data flow, creating an integration that works exactly as you need it to.",
            },
            {
              boldText: "Expert support: ",
              text: "Access our knowledgeable support team for any integration-related queries, ensuring you always have assistance when you need it. We provide ongoing support to help you maximise the value of your integration, adapting it as your business grows and evolves.",
            },
            {
              boldText: "Scalable solution: ",
              text: "Easily adapt the integration as your business grows and evolves, without the need for complex reconfigurations. Our scalable approach allows you to add or modify Zaps to accommodate changing needs, ensuring the integration continues to serve your business.",
            },
            {
              boldText: "Comprehensive training: ",
              text: "Receive thorough training on using the integrated systems effectively, empowering your team to leverage its full potential. Our training sessions cover best practices and advanced features, helping you extract maximum value from the Cin7 CRM integration.",
            },
            {
              boldText: "Supported by Zapier: ",
              text: "Create multiple Zaps to suit your specific business needs, allowing for a tailored integration that aligns with your unique processes. This flexibility enables you to choose which data fields to sync and how to assign opportunities in CRM, ensuring the integration works exactly as you need it to.",
            },
          ],
        },
        {
          title: "How to integrate Cin7 with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Sign up for a Zapier account.",
            "Choose Cin7 (Dear Systems) as your trigger app in Zapier.",
            "Select the desired trigger event (e.g., new sale, updated customer).",
            "Connect your Cin7 account to Zapier.",
            "Choose Pepper Cloud CRM as your action app.",
            "Select the corresponding action (e.g., create/update opportunity, create/update account).",
            "Map the fields between Cin7 and Pepper Cloud CRM.",
            "Test the Zap to ensure proper data flow.",
            "Activate the Zap and monitor its performance.",
          ],
        },
      ],
      additionalText:
        "To know how to integrate Cin7 with Pepper Cloud CRM, contact our",
      IinkText: "support team.",
      url: "https://peppercloud.com/crm-support/",
      userCases: {
        heading: "Cin7 CRM integration - Applications and use cases",
        body: [
          {
            title: "E-commerce businesses:",
            points: [
              "Automatically create CRM opportunities for online sales.",
              "Update customer information in real-time across both systems.",
              "Track inventory levels and reorder points based on sales data.",
            ],
          },
          {
            title: "Wholesale distributors:",
            points: [
              "Sync bulk orders with CRM opportunities for better pipeline management.",
              "Update account information for B2B customers in both systems.",
              "Monitor product popularity and stock levels across multiple warehouses.",
            ],
          },
          {
            title: "Retail chains:",
            points: [
              "Centralise customer data from multiple store locations.",
              "Track sales performance and inventory levels across all outlets.",
              "Identify cross-selling and upselling opportunities based on purchase history.",
            ],
          },
          {
            title: "Manufacturing companies:",
            points: [
              "Link production orders with sales opportunities in CRM.",
              "Update customer specifications and requirements in real-time.",
              "Monitor raw material inventory and finished goods stock levels.",
            ],
          },
          {
            title: "Subscription-based services:",
            points: [
              "Automatically create and update recurring opportunities in CRM.",
              "Track subscription renewals and potential churn risks.",
              "Manage inventory for physical products associated with subscriptions.",
            ],
          },
        ],
      },
      about: {
        title: "About Cin7",
        text: "Cin7 (formerly known as Dear Inventory) is a powerful, cloud-based inventory management system designed for growing businesses. It offers comprehensive features including multi-channel sales management, purchase order and supplier management, and warehouse management and stock control. With its robust API and integration capabilities, Cin7 seamlessly connects with various business tools, including CRM systems, to provide a unified solution for modern businesses.",
      },
      faq: {
        title: "Cin7 CRM integration FAQs",
        body: [
          {
            question: "What is Cin7 CRM integration? ",
            answer:
              "Cin7 CRM integration is the process of connecting Cin7 (formerly Dear Inventory) with a Customer Relationship Management (CRM) system to synchronise data and streamline business operations.",
          },
          {
            question: "How does Cin7 integrate with Pepper Cloud CRM?",
            answer:
              "Cin7 integrates with Pepper Cloud CRM through Zapier, allowing for real-time data synchronisation between the two systems.",
          },
          {
            question: "Is the integration between Cin7 and CRM bidirectional?",
            answer:
              "The integration is currently one-way, with data flowing from Cin7 to the CRM system.",
          },
          {
            question: "What types of data can be synced between Cin7 and CRM?",
            answer: (
              <>
                Currently, sales, customer information, opportunities, and
                account details can be synced between Cin7 and CRM. However, if
                any other data syncing is required, talk to our{" "}
                <a href="https://peppercloud.com/crm-support/">support team</a>{" "}
                and they will assist you.
              </>
            ),
          },
          {
            question:
              "Can I customise the fields that are synced during integration?",
            answer:
              "Yes, you can customise which fields are synced and how they are mapped between Cin7 and your CRM system.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Cin7 website",
          url: "https://www.cin7.com/",
        },
      ],
    },
    "linkedin-social-media": {
      seo: {
        title:
          "CRM with LinkedIn Integration | Pepper Cloud",
        keywords:
          "linkedin crm integration,linkedin crm tool,linkedin crm,crm that integrates with linkedin",
        description:
          "Connect LinkedIn to Pepper Cloud.Turn LinkedIn connections into qualified opportunities. Import lead data instantly and track lead stages in real time.",
        link: "https://peppercloud.com/crm-integrations/linkedin-social-media/",
      },
      pageTitle: "LinkediIn",
      contactLink:
        "https://app.peppercloud.com/?utm_source=Linkedin&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Linkedin&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case23hero,
      alt: "Best LinkedIn CRM integration",
      // name: bannerImg["linkedin-social-media"],
      heading: "Best LinkedIn CRM integration",
      toptitle: "Capture and manage LinkedIn leads in CRM.",
      topdescription:
        "Pepper Cloud CRM offers a seamless LinkedIn CRM integration, allowing you to automatically sync leads and contacts from LinkedIn into your CRM system. This powerful LinkedIn CRM tool empowers your team to nurture leads efficiently, turning potential connections into valuable customers.",
      tags: "Customer support | Bot & messaging | Instant messaging | Social media integration",
      body: [
        {
          title: "Benefits of LinkedIn CRM integration",
          boldPoints: [
            {
              boldText: "Automated lead capture:",
              text: "Save time and eliminate manual data entry by automatically importing LinkedIn leads into your CRM. This ensures that no potential opportunity slips through the cracks and allows your team to focus on high-value activities.",
            },
            {
              boldText: "Centralised data management:",
              text: "Keep all your lead information in one place, creating a single source of truth for your sales team. This centralisation improves collaboration and ensures everyone has access to the most up-to-date information.",
            },
            {
              boldText: "Enhanced lead nurturing:",
              text: "With leads automatically synced to your CRM, your team can start nurturing them immediately. This quick response time increases the chances of converting leads into customers and improves overall sales efficiency.",
            },
            {
              boldText: "Improved data accuracy:",
              text: "Eliminate errors associated with manual data entry and ensure that your CRM always has the most current information from LinkedIn. This accuracy leads to better decision-making and more effective sales strategies.",
            },
            {
              boldText: "Streamlined workflow:",
              text: "By integrating LinkedIn with your CRM, you create a smooth, automated workflow that reduces administrative tasks and allows your team to focus on building relationships and closing deals.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for LinkedIn integration?",
          description: "",
          boldPoints: [
            {
              boldText: "User-friendly interface: ",
              text: "Our intuitive interface makes it easy for your team to access and manage LinkedIn leads within the CRM. This ease of use leads to higher adoption rates and more effective utilisation of the integration.",
            },
            {
              boldText: "Customisable lead fields: ",
              text: "Tailor the data you import from LinkedIn to match your specific business needs. This flexibility ensures that you capture the most relevant information for your sales process.",
            },
            {
              boldText: "Real-time syncing: ",
              text: "Enjoy up-to-date lead information with real-time syncing between LinkedIn and Pepper Cloud CRM. This ensures your team always has the latest data at their fingertips.",
            },
            {
              boldText: "Comprehensive support: ",
              text: "Our dedicated support team is always ready to assist you with any questions or issues related to the LinkedIn CRM integration, ensuring you get the most out of this powerful tool.",
            },
            {
              boldText: "Seamless Zapier integration: ",
              text: "Pepper Cloud CRM utilises Zapier to connect with LinkedIn, ensuring a robust and reliable integration. This connection allows for smooth data flow between platforms, enhancing your lead management capabilities.",
            },
          ],
        },
        {
          title: "How to integrate LinkedIn with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Sign up for a Pepper Cloud CRM account if you haven't already.",
            "Set up a Zapier account to facilitate the integration.",
            "Create a new Zap in Zapier, selecting LinkedIn as the trigger app and Pepper Cloud CRM as the action app.",
            "Configure the Zap to map LinkedIn lead data to the appropriate fields in Pepper Cloud CRM.",
            "Test the integration to ensure data is flowing correctly between the platforms.",
            "Activate the Zap and start automatically syncing your LinkedIn leads to Pepper Cloud CRM.",
          ],
        },
      ],
      additionalText:
        "To know how to integrate LinkedIn with Pepper Cloud CRM, contact our",
      IinkText: "support team.",
      url: "https://peppercloud.com/crm-support/",
      userCases: {
        heading: "LinkedIn CRM integration - Application and use cases",
        body: [
          {
            title: "B2B lead generation:",
            points: [
              "Automatically capture leads directly into your CRM from LinkedIn lead gen form.",
              "Streamline nurturing and follow-up processes with predefined workflows within CRM.",
              "Ensure no leads slip through the crack and streamline the sales pipeline management.",
            ],
          },
          {
            title: "Event marketing:",
            points: [
              "Gather leads from LinkedIn events or sponsored content.",
              "Seamlessly integrate event attendees into your CRM.",
              "Facilitate efficient post-event follow-up and relationship building.",
            ],
          },
          {
            title: "Recruitment:",
            points: [
              "Manage and track potential candidates within your CRM.",
              "Streamline the recruitment process with customisable sales pipelines.",
              "Improve hiring outcomes through better candidate relationship management.",
            ],
          },
        ],
      },
      about: {
        title: "About LinkedIn",
        text: "LinkedIn is the world's largest professional network, with over 700 million members globally. It serves as a platform for professionals to connect, share insights, and explore career opportunities. By integrating LinkedIn with your CRM, you can tap into this vast network and streamline your lead generation and management processes.",
      },
      faq: {
        title: "LinkedIn CRM integration FAQs",
        body: [
          {
            question: "What is LinkedIn CRM integration? ",
            answer:
              "LinkedIn CRM integration refers to the process of connecting your LinkedIn account with a Customer Relationship Management (CRM) system, allowing for seamless data transfer between the two platforms.",
          },
          {
            question: "How does LinkedIn CRM integration benefit my business?",
            answer:
              "It automates lead capture, centralises data management, enhances lead nurturing, improves data accuracy, and streamlines your sales workflow.",
          },
          {
            question:
              "Can I customise which LinkedIn data is synced to my CRM?",
            answer:
              "Yes, with Pepper Cloud CRM that integrates with LinkedIn, you can customise the lead fields to ensure you're capturing the most relevant information for your business needs.",
          },
          {
            question: "Is the LinkedIn CRM integration process complicated?",
            answer:
              "No, with Pepper Cloud CRM, the integration process is straightforward and user-friendly, utilising Zapier to connect the platforms seamlessly.",
          },
          {
            question:
              "How secure is the data transfer between LinkedIn and the CRM?",
            answer:
              "Pepper Cloud CRM ensures secure data transfer through encrypted connections and adheres to data protection regulations to safeguard your information.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "LinkedIn lead gen forms",
          url: "https://business.linkedin.com/marketing-solutions/native-advertising/lead-gen-ads",
        },
      ],
    },
    "project-management-jira-integration": {
      seo: {
        title: "Connect Jira to Pepper Cloud CRM | Automate Workflows",
        keywords:
          "Best Jira CRM Integration,jira crm - 20,jira crm - 120,jira crm system - 110,jira crm integration - 20,crm integration with jira - 20",
        description:
          "Link Jira ticket requests straight to Pepper Cloud lead accounts. Auto-update ticket statuses and resolve bugs fast.",
        link: "https://peppercloud.com/crm-integrations/project-management-jira-integration",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=Jira&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=Jira&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case24hero,
      alt: "Jira CRM",
      pageTitle: "Jira",
      // name: bannerImg["project-management-jira-integration"],
      heading: "Best Jira CRM integration",
      toptitle: "Streamline your task management and customer relationship.",
      topdescription:
        "Experience the best Jira CRM system integration that provides seamless two-way synchronisation between Jira and your CRM. This integration ensures that when a ticket is created, updated, or closed in Jira, the corresponding activity is automatically reflected in your CRM, and vice versa.",
      tags: "Project management | Team collaboration software | Team productivity | Task management",
      body: [
        {
          title: "Benefits of Jira CRM integration",
          boldPoints: [
            {
              boldText: "Enhanced productivity:",
              text: "By eliminating the need for manual data entry across platforms, our Jira CRM integration saves valuable time and reduces the risk of human error. Your team can focus on high-value tasks instead of juggling between different systems.",
            },
            {
              boldText: "Real-time synchronisation:",
              text: "With our two-way sync, any changes made in Jira are instantly reflected in your CRM, and vice versa. This ensures that all team members have access to the most up-to-date information, enabling faster decision-making and more efficient problem-solving.",
            },
            {
              boldText: "Improved communication:",
              text: "The best Jira CRM integration bridges the gap between your project management and customer relationship tools. This seamless flow of information reduces misunderstandings and improves overall communication between teams.",
            },
            {
              boldText: "Centralised data management:",
              text: "With Jira CRM system, you create a single source of truth for all project and customer-related information. This centralised approach simplifies data management and reduces the risk of inconsistencies across platforms.",
            },
            {
              boldText: "Enhanced customer experience:",
              text: "With all customer interactions and project updates in one place, your team can provide more accurate and timely responses to customer inquiries. This leads to improved customer satisfaction and loyalty.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for Jira integration?",
          description: "",
          boldPoints: [
            {
              boldText: "Seamless two-way sync: ",
              text: "Pepper Cloud's Jira CRM integration offers robust bidirectional synchronisation between Jira and your CRM. This ensures that your task management and customer relationship data are always in perfect alignment.",
            },
            {
              boldText: "User-friendly interface: ",
              text: "The CRM integration with Jira  is designed with ease of use in mind. The intuitive interface makes it simple to navigate between Jira and CRM system, reducing the learning curve and increasing adoption rates across your organisation.",
            },
            {
              boldText: "Comprehensive support: ",
              text: "When you choose Pepper Cloud for your Jira CRM integration, you are not just getting a product - you're gaining a partner. Our dedicated support team is always ready to assist you with any questions or issues, ensuring a smooth integration process and ongoing success.",
            },
            {
              boldText: "Regular updates and improvements: ",
              text: "We are committed to continually enhancing our Jira CRM integration. By choosing Pepper Cloud, you will benefit from regular updates and new features that keep your integration at the cutting edge.",
            },
            {
              boldText: "Powered by Zapier: ",
              text: "Pepper Cloud CRM leverages Zapier to connect seamlessly with Jira, ensuring a strong and dependable integration. This connection enables smooth data transfer between platforms, boosting your lead management efficiency.",
            },
          ],
        },
        {
          title: "How to integrate Jira with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Log in to the Pepper Cloud CRM account.",
            "Set up a Zapier account to facilitate the Jira integration.",
            "Create a new Zap in Zapier, selecting Jira as the trigger app and Pepper Cloud CRM as the action app.",
            "Configure the Zap to map Jira data to the appropriate fields in Pepper Cloud CRM.",
            "Test the integration to ensure data is flowing correctly between the platforms.",
            "Activate the Zap.",
          ],
        },
      ],
      additionalText:
        "To know how to integrate Jira with Pepper Cloud CRM, contact our",
      IinkText: "support team.",
      url: "https://peppercloud.com/crm-support/",
      userCases: {
        heading: "Jira CRM integration - Applications and use cases",
        body: [
          {
            title: "Software development teams:",
            points: [
              "Track customer-reported issues alongside internal development tasks.",
              "Prioritise bug fixes and feature requests based on customer impact.",
              "Provide real-time progress updates to customers directly from Jira.",
              "Analyse trends in customer-reported issues to improve product quality.",
            ],
          },
          {
            title: "Customer support departments:",
            points: [
              "Create Jira tickets automatically from customer support requests.",
              "Update customers on issue resolution progress through CRM.",
              "Track support team performance metrics across both systems.",
              "Identify recurring issues and escalate them to the development team seamlessly.",
            ],
          },
          {
            title: "Sales and account management teams:",
            points: [
              "Create Jira tasks for custom feature requests or implementations.",
              "Track progress on customer-specific projects.",
              "Provide accurate timelines and updates during sales processes.",
              "Coordinate handoffs between sales and implementation teams efficiently.",
            ],
          },
          {
            title: "Marketing teams:",
            points: [
              "Coordinate marketing campaigns with product release schedules in Jira.",
              "Track content creation and approval processes across teams.",
              "Align marketing activities with customer needs identified in CRM.",
              "Measure the impact of marketing initiatives on customer engagement and support requests.",
            ],
          },
          {
            title: "Product management teams:",
            points: [
              "Prioritise feature development based on customer feedback and requests.",
              "Track the progress of product roadmap items in both Jira and CRM.",
              "Gather and organise customer insights for future product iterations.",
              "Communicate product updates and new features to customers efficiently.",
            ],
          },
          {
            title: "Leaders and managers:",
            points: [
              "Gain a holistic view of project progress and customer satisfaction.",
              "Make data-driven decisions based on insights from both systems.",
              "Monitor key performance indicators across departments.",
              "Identify areas for process improvement and resource allocation.",
            ],
          },
        ],
      },
      about: {
        title: "About Jira",
        text: "Jira is a powerful project management tool developed by Atlassian. It's widely used for issue tracking, bug tracking, and agile project management. Jira's flexibility and extensive feature set make it an ideal choice for teams of all sizes, from small startups to large enterprises. By integrating Jira with a CRM system like Pepper Cloud, organisations can create a comprehensive workflow that bridges the gap between project management and customer relationship management, ensuring seamless communication and data flow across teams.",
      },
      faq: {
        title: "Jira CRM FAQs",
        body: [
          {
            question: "What is Jira CRM integration? ",
            answer:
              "Jira CRM integration is the process of connecting Jira, a project management tool, with a Customer Relationship Management (CRM) system to synchronise data and streamline workflows between the two platforms.",
          },
          {
            question: "How does Jira CRM integration benefit my business?",
            answer:
              "Jira CRM integration enhances productivity, improves communication, provides real-time updates, centralises data management, and streamlines workflows, ultimately leading to better project management and customer relationships.",
          },
          {
            question: "Is the integration between Jira and CRM bidirectional?",
            answer:
              "Yes, our Jira CRM integration offers a two-way sync, meaning changes made in either system are reflected in the other automatically.",
          },
          {
            question:
              "How often does the integration sync data between Jira and CRM?",
            answer:
              "The integration syncs data in real-time, ensuring that both systems always have the most up-to-date information.",
          },
          {
            question:
              "Is technical expertise required to set up the Jira CRM integration? ",
            answer:
              "While some technical knowledge can be helpful, our integration is designed to be user-friendly and easy to set up. Our support team is also available to assist you throughout the process.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Jira website",
          url: "https://www.atlassian.com/software/jira",
        },
      ],
    },
    "google-sheets": {
      seo: {
        title: "Google Sheets integration with Pepper Clooud CRM",
        keywords: "google sheets crm,google sheets crm,crm for google sheets",
        description:
          "Connect Google Sheets to Pepper Cloud CRM. Map spreadsheet columns to CRM fields, update lead statuses, and trigger team tasks.",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=GoogleSheets&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=GoogleSheets&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case25hero,
      alt: "Best Google Sheets CRM integration",
      // name: bannerImg["google-sheets"],
      pageTitle: "Google Sheets",
      heading: "Best Google Sheets CRM integration",
      toptitle:
        "Boost your business efficiency with robust Google Sheets CRM integration",
      topdescription:
        "Revolutionise your business process with Google Sheets CRM. Seamlessly transfer data, automate tasks, and enhance your team's productivity. With Google Sheets CRM integration, you will experience a smooth and efficient workflow that saves time and reduces errors.",
      tags: "Accounting software |  CRM accounting software | Best CRM for accounting firms | CRM for accountants",
      body: [
        {
          title: "Benefits of Google Sheets CRM integration",
          boldPoints: [
            {
              boldText: "Real-time data synchronisation:",
              text: "Keep your CRM and spreadsheets in perfect harmony. As soon as you add or update a row in Google Sheets, a lead or contact is automatically created or updated in your CRM, ensuring your teams always have access to the latest information.",
            },
            {
              boldText: "Improved data accuracy:",
              text: "Eliminate manual data entry errors by automating the transfer of information between Google Sheets and your CRM. This seamless integration reduces the risk of duplicate entries and ensures data consistency across platforms.",
            },
            {
              boldText: "Enhanced productivity:",
              text: "Save valuable time by automating repetitive tasks. Your team can focus on high-value activities instead of spending hours on data entry and management, leading to increased efficiency and productivity.",
            },
            {
              boldText: "Better collaboration:",
              text: " Foster teamwork by allowing multiple users to access and update information simultaneously. With Google Sheets CRM integration, everyone stays on the same page, improving communication and decision-making processes.",
            },
            {
              boldText: "Customisable workflows:",
              text: "Tailor the integration to fit your specific business needs. Create custom triggers and actions to automate complex processes, making your workflow more efficient and adaptable to changing requirements.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud CRM for Google Sheets integration?",
          description: "",
          boldPoints: [
            {
              boldText: "Real-time data sync: ",
              text: "Create or update records in CRM as soon a row in the Google Sheets is added or updated. This seamless Google Sheets CRM integration keeps your CRM data updated and accurate across platforms.",
            },
            {
              boldText: "User-friendly interface: ",
              text: "Pepper Cloud offers an intuitive platform that makes it easy to set up and manage your Google Sheets CRM integration. Even team members with limited technical expertise can quickly learn to use the system effectively.",
            },
            {
              boldText: "Robust feature set: ",
              text: "Enjoy a comprehensive suite of tools designed to enhance your CRM experience. From advanced reporting to customisable dashboards, Pepper Cloud provides everything you need to make the most of your Google Sheets integration.",
            },
            {
              boldText: "Scalable solution: ",
              text: "As your business grows, Pepper Cloud grows with you. Our flexible platform can accommodate increasing data volumes and complex workflows, ensuring that your Google Sheets CRM integration remains effective as your needs evolve.",
            },
            {
              boldText: "Excellent customer support: ",
              text: "Benefit from our dedicated support team, always ready to assist you with any questions or issues. Access comprehensive documentation, video tutorials, and personalised guidance to ensure you get the most out of your integration.",
            },
            {
              boldText: "Regular updates and improvements: ",
              text: "Stay ahead of the curve with Pepper Cloud commitment to continuous improvement. We regularly update our platform with new features and enhancements, ensuring that your Google Sheets CRM integration remains cutting-edge and efficient.",
            },
          ],
        },
        {
          title: "How to integrate Google Sheets with Pepper Cloud CRM?",
          description: "",
          pointers: [
            "Log in to the Pepper Cloud CRM account.",
            "Set up a Zapier account to facilitate the Google Sheets integration.",
            "Create a new Zap in Zapier, selecting Google Sheets as the trigger app and Pepper Cloud CRM as the action app.",
            "Configure the Zap to map Google Sheets data to the appropriate fields in Pepper Cloud CRM.",
            "Test the integration to ensure data is flowing correctly between the platforms.",
            "Activate the Zap.",
          ],
        },
      ],
      additionalText:
        "To know how to integrate Google Sheets with Pepper Cloud CRM, contact our",
      IinkText: "support team.",
      url: "https://peppercloud.com/crm-support/",
      userCases: {
        heading: "Google Sheets CRM integration - Applications and use cases",
        body: [
          {
            title: "Lead management:",
            points: [
              "Automatically create new leads in your CRM from Google Sheets entries.",
              "Update lead status and information in real-time.",
              "Track lead sources and conversion rates effortlessly.",
            ],
          },
          {
            title: "Sales pipeline tracking:",
            points: [
              "Visualise your sales pipeline using Google Sheets.",
              "Automatically update deal stages in your CRM as you move rows in your spreadsheet.",
              "Generate accurate sales forecasts based on real-time data.",
            ],
          },
          {
            title: "Customer onboarding:",
            points: [
              "Create a streamlined onboarding process using Google Sheets.",
              "Automatically trigger welcome emails and tasks in your CRM.",
              "Track customer progress and satisfaction throughout the onboarding journey.",
            ],
          },
          {
            title: "Event management:",
            points: [
              "Use Google Sheets to manage event registrations.",
              "Automatically create attendee profiles in your CRM.",
              "Track event participation and follow-up activities seamlessly.",
            ],
          },
          {
            title: "Inventory management:",
            points: [
              "Keep track of product inventory using Google Sheets.",
              "Automatically update product availability in your CRM.",
              "Generate low stock alerts and reorder notifications.",
            ],
          },
          {
            title: "Customer feedback collection:",
            points: [
              "Use Google Forms linked to Google Sheets for customer surveys.",
              "Automatically create or update customer records in your CRM based on feedback.",
              "Analyse customer satisfaction trends and take prompt action.",
            ],
          },
        ],
      },
      about: {
        title: "About Google Sheets",
        text: "Google Sheets is a powerful, cloud-based spreadsheet application that offers real-time collaboration, automatic saving, and a wide range of features. As part of the Google Workspace suite, it integrates seamlessly with other Google tools and third-party applications. Google Sheets provides a flexible platform for data management, analysis, and visualisation, making it an ideal companion for CRM systems.",
      },
      faq: {
        title: "Google Sheets CRM FAQs",
        body: [
          {
            question: "What is a Google Sheets CRM integration? ",
            answer:
              "A Google Sheets CRM integration is a connection between Google Sheets and a Customer Relationship Management (CRM) system that allows for automatic data synchronisation and workflow automation between the two platforms.",
          },
          {
            question:
              "How does the integration between Google Sheets and Pepper Cloud CRM work?",
            answer:
              "The integration uses Zapier to create a connection between Google Sheets and Pepper Cloud CRM. When you add or update a row in Google Sheets, it triggers an action in Pepper Cloud CRM, such as creating or updating a lead or contact.",
          },
          {
            question: "Can I use Google Sheets as a CRM? ",
            answer:
              "Google Sheets lacks many features (such as auto-lead capture, real-time updating, workflow automation, etc.) of a dedicated CRM system. The best Google Sheets CRM like Pepper Cloud provides a more robust solution for customer relationship management.",
          },
          {
            question:
              "Is it difficult to set up the Google Sheets CRM integration?",
            answer:
              "No, the integration process is designed to be user-friendly. Pepper Cloud provides step-by-step guidance to help you set up the integration quickly and easily.",
          },
          {
            question:
              "How often does the data sync between Google Sheets and the CRM?",
            answer:
              "The synchronisation occurs in real-time or near real-time, depending on your specific setup and the volume of data being transferred.",
          },
          {
            question:
              "Can I customise the integration to fit my specific business needs?",
            answer:
              "Yes, Pepper Cloud's Google Sheets CRM integration is highly customisable. You can set up specific triggers and actions to automate your unique workflows.",
          },
          {
            question:
              "Can multiple team members use the Google Sheets CRM simultaneously?",
            answer:
              "Absolutely. The Google Sheets CRM, Pepper Cloud, supports collaborative work, allowing multiple team members to access and update information in both Google Sheets and the CRM simultaneously.",
          },
          {
            question:
              "What if I need help with my Google Sheets CRM integration?",
            answer:
              "Pepper Cloud offers comprehensive customer support, including documentation, video tutorials, and personalised assistance to help you make the most of your integration.",
          },
        ],
      },
      resources: [
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "Google Sheet",
          url: "https://workspace.google.com/intl/en_in/products/sheets/",
        },
      ],
    },
    "krispcall-voip-phone-system": {
      seo: {
        url: "https://peppercloud.com/crm-integrations/krispcall-voip-phone-system",
        title:
          "KrispCall VoIP Integration with Pepper Cloud CRM",
        keywords:
          "CRM VOIP/telephony integration, crm VOIP/telephony integration, crm phone calls, voip crm integration, crm telephony, Cloud telephony, sales call tracking software, voip crm, call center crm software",
        description:
          "Make calls and send SMS directly inside Pepper Cloud CRM using KrispCall. Automatically record call audio, log timestamps, and update contact history in real time.",
      },
      contactLink:
        "https://app.peppercloud.com/?utm_source=KrispCall&utm_medium=CTA&utm_campaign=marketplace_internal",
      getStarted:
        "https://peppercloud.com/contact/?utm_source=KrispCall&utm_medium=CTA&utm_campaign=marketplace_internal",
      heroBg: case28hero,
      alt: "Best VoIP (KrispCall) CRM integration",
      // name: bannerImg["KrispCall"],
      pageTitle: "KrispCall",
      heading: "Best VoIP (KrispCall) CRM integration",
      toptitle:
        "Effortlessly manage calls, SMS, and customer interactions—all from your CRM.",
      topdescription:
        "Take complete control of your customer communications with KrispCall, now seamlessly integrated with Pepper Cloud CRM. This powerful CRM VoIP and telephony integration lets you handle voice calls, SMS, call logs, and customer interactions directly from your CRM, eliminating the need to switch between tools. Streamline your sales and support workflows, boost team collaboration, and deliver exceptional customer service from a single, unified platform.",
      tags: "VoIP CRM integration | CRM phone system integration | CRM for cold calling | Call center CRM software | CRM telephony integration",
      body: [
        {
          title: "Benefits of KrispCall CRM integration",
          boldPoints: [
            {
              boldText: "Centralized call and SMS management:",
              text: "Manage all your voice calls and SMS directly within Pepper Cloud CRM. Eliminate the need to toggle between apps, improve operational efficiency, and gain full visibility into your customer communication.",
            },
            {
              boldText: "Automatic call logging and tracking:",
              text: "All inbound and outbound calls are automatically logged with duration, time, and even call recordings. This automated call tracking ensures full transparency, supports better follow-up, and helps close deals faster.",
            },
            {
              boldText: "Two-way and bulk contact sync:",
              text: "Easily sync contacts between KrispCall and Pepper Cloud CRM with one-way and bulk contact sync. Avoid duplicates and ensure your teams always work with the most up-to-date contact information.",
            },
            {
              boldText: "Enhanced team collaboration:",
              text: "Share access to call logs, notes, and tags so that sales, support, and operations teams can collaborate more efficiently. Everyone stays on the same page with consistent customer data.",
            },
            {
              boldText: "Detailed caller insights:",
              text: "Instantly view caller information, past interactions, and history right before you pick up the phone. Deliver personalized conversations that resonate and convert.",
            },
            {
              boldText: "Real-time call analytics:",
              text: "Monitor call metrics like volume, duration, and agent performance with real-time analytics dashboards. Optimize workflows and track KPIs effortlessly.",
            },
            {
              boldText: "Call recordings and notes sync:",
              text: "Access full call recordings and sync notes from the KrispCall dialer directly into customer profiles in Pepper Cloud CRM. Enhance visibility, accountability, and compliance.",
            },
            {
              boldText: "Multi-account CRM support:",
              text: "Integrate multiple Pepper Cloud CRM accounts into a single KrispCall workspace—each with individual settings. Perfect for agencies and large teams handling multiple clients or departments.",
            },
            {
              boldText: "Improved productivity and automation:",
              text: "Save hours of manual work with automated call and SMS logging, quick dialing, and synced notes—all boosting team output and reducing errors.",
            },
            {
              boldText: "Cloud-based scalability:",
              text: "Whether you're a startup or scaling enterprise, KrispCall’s cloud-based VoIP solution grows with your business—no hardware, no hassle.",
            },
          ],
        },
        {
          title: "Why choose Pepper Cloud for KrispCall integration?",
          description: "",
          boldPoints: [
            {
              boldText: "Effortless outbound calling:",
              text: "Start calls with a single click from within the CRM. No more copy-pasting or dialing mistakes—just fast, efficient communication.",
            },
            {
              boldText: "Comprehensive caller insights:",
              text: "Know who’s calling before you answer. View contact details, tags, and previous interactions in real time for more contextual conversations.",
            },
            {
              boldText: "Real-time call performance monitoring:",
              text: "Track every call’s outcome with live metrics to quickly analyze team activity and drive smarter decisions.",
            },
            {
              boldText: "Automatic call and SMS logging:",
              text: "No more manual data entry. Every call and SMS is logged automatically with timestamps, call duration, and recordings synced into your CRM.",
            },
            {
              boldText: "Detailed call documentation with notes & tags:",
              text: "Add and sync tags and notes during or after calls to maintain a complete and organized record of every conversation.",
            },
            {
              boldText: "Smart call routing and transfer:",
              text: "Route incoming calls to the right agents or departments using custom workflows. Supports internal and external call transfers to ensure customer queries are handled by the right person.",
            },
            {
              boldText: "Native dialer with SMS support:",
              text: "Use the built-in KrispCall dialer inside Pepper Cloud to make calls or send SMS. Send Quick SMS during calls for fast, real-time communication.",
            },
            {
              boldText: "Simultaneous multi-platform login:",
              text: "Log in to KrispCall and the Pepper Cloud dialer at the same time without disruptions or logout issues.",
            },
          ],
        },
        // {
        //   title: "How to integrate Google Sheets with Pepper Cloud CRM?",
        //   description: "",
        //   pointers: [
        //     "Log in to the Pepper Cloud CRM account.",
        //     "Set up a Zapier account to facilitate the Google Sheets integration.",
        //     "Create a new Zap in Zapier, selecting Google Sheets as the trigger app and Pepper Cloud CRM as the action app.",
        //     "Configure the Zap to map Google Sheets data to the appropriate fields in Pepper Cloud CRM.",
        //     "Test the integration to ensure data is flowing correctly between the platforms.",
        //     "Activate the Zap.",
        //   ],
        // },
      ],
      userCases: {
        heading: "KrispCall CRM integration - Applications and use cases",
        body: [
          {
            title: "Sales Teams",
            points: [
              "Initiate and manage calls seamlessly within the CRM interface.",
              "Track leads effectively, schedule follow-up tasks, and enhance conversion rates.",
              "Tailor your sales approach with complete access to caller history and relevant tags.",
            ],
          },
          {
            title: "Customer Support",
            points: [
              "Quickly retrieve past call logs and notes to resolve issues efficiently.",
              "Ensure ongoing communication with thorough documentation of each call.",
              "Enhance customer satisfaction through personalized and proactive support strategies.",
            ],
          },
          {
            title: "Call Center Operations",
            points: [
              "Establish a unified communication platform for remote teams.",
              "Work together using shared notes, tags, and synchronized logs.",
              "Automatically route and record calls for streamlined operations.",
              "Easily scale to accommodate varying call volumes.",
              "Evaluate agent performance and refine workflows in real-time.",
            ],
          },
          {
            title: "Remote & Hybrid Teams",
            points: [
              "Access call logs, dialer, and SMS features from any location.",
              "Maintain smooth connectivity across different time zones and regions.",
              "Enable remote teams to collaborate as if they were in a single office space.",
            ],
          },
        ],
      },
      about: {
        title: "About KrispCall",
        text: (
          <>
            <p>
              KrispCall is an AI-powered phone app built for modern businesses.
              It enhances team performance by bringing advanced calling features
              directly into CRM platforms, helping companies streamline
              operations, scale efficiently, and stay ahead in competitive
              markets. Designed to empower startups, SMBs, and enterprises,
              KrispCall offers powerful capabilities like smart call routing,
              multi-level IVR, call recording, SMS functionality, and real-time
              analytics. With its intuitive web and mobile apps, teams can stay
              connected, manage workflows, and maintain customer focus from
              anywhere—supporting remote work, global reach, and consistent
              execution across departments.
            </p>{" "}
            <br />{" "}
            <p>
              KrispCall is built to accelerate deal closures, boost
              responsiveness, and improve team collaboration at every stage of
              the customer journey.
            </p>
          </>
        ),
      },
      faq: {
        title: "KrispCall CRM integration - FAQs",
        body: [
          {
            question:
              "Can I transfer calls between team members with KrispCall CRM integration?",
            answer:
              "Yes. You can easily transfer calls internally (to active team members) or externally (to any number), ensuring calls are routed to the right person.",
          },
          {
            question:
              "What is required to integrate KrispCall with Pepper Cloud CRM?",
            answer:
              "You just need active accounts on both platforms. From KrispCall, head to Settings > Integrations, select Pepper Cloud CRM, log in, and authorize access. That’s it — integration is live in a few clicks.",
          },
          {
            question:
              "Can I manage call queues using KrispCall CRM integration?",
            answer:
              "Absolutely. You can view and manage call queues directly from the CRM to ensure timely responses and reduce wait times.",
          },
          {
            question:
              "Can I log customer calls automatically with CRM KrispCall integration?",
            answer:
              "Yes, KrispCall automatically logs all incoming and outgoing calls in your CRM, making it easy to track customer interactions without manual input.",
          },
          {
            question:
              "Can we use multiple contact numbers through the Pepper Cloud - KrispCall VoIP CRM integration?",
            answer:
              "Yes! You can integrate multiple KrispCall numbers during setup. Each number’s call and SMS activity will be tracked individually and logged within Pepper Cloud CRM.",
          },
        ],
      },
      resources: [
        {
          title: "Setup guide",
          url: "https://blog.peppercloud.com/krispcall-and-crm-integration-guide/",
        },
        {
          title: "Help and support",
          url: "https://peppercloud.com/crm-support/",
        },
        {
          title: "KrispCall website",
          url: "https://krispcall.com/",
        },
      ],
    },
  };

  if (!caseStudies[company]) {
    return <NotFoundPage />;
  }

  const caseStudy = caseStudies[company];
  const pageData = pagesData[company];

  const [open, setOpen] = React.useState(0);
  const handleClickCollapse = (index) => () => {
    setOpen((res) => (res === index ? -1 : index));
  };

  return (
    <React.Fragment>
      <SEO
        description={caseStudy.seo.description}
        keywords={caseStudy.seo.keywords}
        pathname={caseStudy.seo.link}
        title={caseStudy.seo.title}
      />
      <Box style={{ position: "relative" }}>
        <Container>
          <Grid
            container
            justify="center"
            spacing={7}
            className={classes.mobileResponsive}
          >
            <Grid
              item
              justifyContent="flex-start"
              className={classes.sidebarContainer}
              md={4}
              mt={4}
              sm={12}
            >
              <div style={{ position: "relative" }}>
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    marginBottom: "20px",
                  }}
                >
                  <Link
                    to="/crm-integrations"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img
                      src={backArrow}
                      alt="Arrow"
                      placeholder="blurred"
                      style={{ cursor: "pointer" }}
                      width={21}
                      height={13.5}
                    />
                  </Link>

                  <ParagraphTypography className={classes.backToIntegration}>
                    Back to integration
                  </ParagraphTypography>
                </div>
                {/* <div className={classes.platformImageContainer}>
                  <StaticImage
                    src={pageData.platformImage}
                    placeholder="blurred"
                    width={55}
                    height={55}
                  />
                  </div> */}

                <HeaderTypography className={classes.smIntegrationHeader}>
                  {caseStudy.heading}
                </HeaderTypography>

                <div style={{ position: "relative" }}>
                  {pageData?.backButtonCard}
                </div>
              </div>

              <div className={classes.resourceContainer}>
                {pageData?.backButtonBadge}
                {caseStudy.tags && (
                  <p className={classes.tagName}>{caseStudy.tags}</p>
                )}
                <div className={classes.buttonContainer}>
                  {caseStudy.contactLink && (
                    <a
                      className="primaryButton font-16 font-wix-medium"
                      href={caseStudy.contactLink}
                    >
                      Connect now
                    </a>
                  )}
                  {caseStudy.getStarted && (
                    <a
                      className="primaryButtonOutline font-wix-medium font-16"
                      href={caseStudy.getStarted}
                    >
                      Get started
                    </a>
                  )}
                </div>
                <div>
                  {caseStudy.resources && (
                    <ParagraphTypography className={classes.resources}>
                      Resources
                    </ParagraphTypography>
                  )}

                  {caseStudy.resources &&
                    caseStudy.resources.map((resource) => (
                      <ParagraphTypography
                        className={classes.setupGuideHelpAndSupport}
                      >
                        <a
                          href={resource.url}
                          target={
                            resource.url.includes("peppercloud.com")
                              ? ""
                              : "_blank"
                          }
                          rel={
                            !resource.url.includes("peppercloud.com")
                              ? "nofollow"
                              : "follow"
                          }
                        >
                          {resource.title}
                        </a>
                      </ParagraphTypography>
                    ))}
                </div>
              </div>
            </Grid>
            <Grid item md={8} sm={12} className={classes.responsiveSize}>
              <Box className={classes.homeSliderText}>
                <HeaderTypography
                  component="h1"
                  className={classes.IntegrationHeader}
                  title={caseStudy.heading}
                >
                  {caseStudy.heading}
                </HeaderTypography>
                <HeaderTypography
                  component="h2"
                  className={classes.syncAndSendHeader}
                  title={caseStudy.toptitle}
                >
                  {caseStudy.toptitle}
                </HeaderTypography>

                <ParagraphTypography
                  component="p"
                  className={classes.efficientlyManageTasks}
                  title={caseStudy.topdescription}
                >
                  {caseStudy.topdescription}
                </ParagraphTypography>

                {caseStudy.heroBg && (
                  <Grid
                    component={Box}
                    item
                    lg={12}
                    maxWidth="80%"
                    md={12}
                    // paddingLeft="20px"
                    sm={12}
                    className={classes.bannerImg}
                  >
                    <img
                      alt={caseStudy.alt}
                      className={classes.img}
                      src={caseStudy.heroBg}
                    />
                  </Grid>
                )}

                {caseStudy.body.map((data, index) => (
                  <div key={index}>
                    <HeaderTypography className={classes.IntegrationFeatures}>
                      {data.title}
                    </HeaderTypography>

                    {data.description && (
                      <ParagraphTypography
                        className={classes.efficientlyManageTasks}
                      >
                        {data.description}
                      </ParagraphTypography>
                    )}

                    {data.pointers &&
                      data.pointers.map((pointer, idx) => (
                        <div
                          className={classes.customerCommunication}
                          key={idx}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                          }}
                        >
                          <div>
                            <img
                              src={pointerIcon}
                              alt="Pointer"
                              className={classes.pointer}
                              style={{
                                height: 18,
                                width: 18,
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <span>{pointer}</span>

                          {/* <br /> */}
                        </div>
                      ))}
                    {
                      data.boldPoints &&
                        // <ParagraphTypography
                        //   className={classes.customerCommunication}
                        // >
                        data.boldPoints.map((pointer, idx) => (
                          <div
                            key={idx}
                            className={classes.customerCommunication}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div>
                              <StaticImage
                                src="../../images/v2/crm-integration/pointer.png"
                                alt="Pointer"
                                className={classes.pointer}
                                style={{
                                  height: 18,
                                  width: 18,
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                            <span>
                              {" "}
                              <b>{pointer.boldText}</b> {pointer.text}
                            </span>

                            {/* <br /> */}
                          </div>
                        ))
                      // </ParagraphTypography>
                    }
                  </div>
                ))}

                <div className={classes.bottomLine}>
                  <ParagraphTypography className={classes.fordetailed}>
                    {caseStudy.additionalText}{" "}
                    <a href={caseStudy.url}>{caseStudy.IinkText}</a>
                  </ParagraphTypography>
                  <ParagraphTypography className={classes.bottomtextstyle}>
                    {caseStudy.bottomtext}
                  </ParagraphTypography>
                </div>
                {caseStudy.youtube && (
                  <div className={classes.ytContainer}>
                    <iframe
                      width="560"
                      height="315"
                      src={caseStudy.youtube}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                )}
                {caseStudy.userCases?.heading && (
                  <Box className={classes.userCaseContainer}>
                    <HeaderTypography className={classes.IntegrationFeatures}>
                      {caseStudy.userCases.heading}
                    </HeaderTypography>
                    {caseStudy.userCases.body.map((each, index) => (
                      <div
                        key={each.title}
                        className={classes.responsiveToogler}
                      >
                        <Box
                          className={classes.faqTitle}
                          m={0}
                          onClick={handleClickCollapse(index)}
                        >
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            justifyContent={"flex-start"}
                            gap={"10px"}
                          >
                            <ListItemIcon
                              style={{
                                marginRight: "0",
                                minWidth: "max-content",
                              }}
                            >
                              <CheckIcon className={classes.listItemIcon} />
                            </ListItemIcon>
                            <Box component="h3" fontSize={18} my={2}>
                              {each.title}
                            </Box>
                          </Box>
                          <div>
                            <IconButton
                              aria-label="Expand or Collapse"
                              className={classes.expendButton}
                              color="default"
                            >
                              {index !== open ? (
                                <AddIcon fontSize="small" />
                              ) : (
                                <RemoveIcon fontSize="small" />
                              )}
                            </IconButton>
                          </div>
                        </Box>
                        <Collapse
                          in={open === index}
                          timeout="auto"
                          unmountOnExit
                        >
                          {each.points.map((point, index) => (
                            <>
                              <p className={classes.faqAnswer} fontSize={16}>
                                {point}
                              </p>
                              <Divider />
                            </>
                          ))}
                        </Collapse>
                      </div>
                    ))}
                  </Box>
                )}
                {caseStudy.about && (
                  <HeaderTypography className={classes.IntegrationFeatures}>
                    {caseStudy.about.title}
                  </HeaderTypography>
                )}
                {caseStudy.about && (
                  <ParagraphTypography
                    className={classes.efficientlyManageTasks}
                  >
                    {caseStudy.about.text}
                  </ParagraphTypography>
                )}
                {caseStudy.faq?.title && (
                  <Box className={classes.userCaseContainer}>
                    <HeaderTypography className={classes.IntegrationFeatures}>
                      {caseStudy.faq.title}
                    </HeaderTypography>
                    {caseStudy.faq.body.map((each, index) => (
                      <div
                        key={each.question}
                        className={classes.responsiveToogler}
                      >
                        <Box
                          className={classes.faqTitle}
                          m={0}
                          onClick={handleClickCollapse(index)}
                        >
                          <Box
                            component="h3"
                            fontWeight={600}
                            fontSize={18}
                            my={2}
                          >
                            {each.question}
                          </Box>
                          <div>
                            <IconButton
                              aria-label="Expand or Collapse"
                              className={classes.expendButton}
                              color="default"
                            >
                              {index !== open ? (
                                <AddIcon fontSize="small" />
                              ) : (
                                <RemoveIcon fontSize="small" />
                              )}
                            </IconButton>
                          </div>
                        </Box>
                        <Collapse
                          in={open === index}
                          timeout="auto"
                          unmountOnExit
                        >
                          <p className={classes.faqAnswer} fontSize={16}>
                            {each.answer}
                          </p>
                        </Collapse>
                        <Divider />
                      </div>
                    ))}
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Divider />
      {pageData?.bottomCards && (
        <Box style={{ position: "relative" }}>
          <Container className="MuiContainer-maxWidthLg">
            <Grid
              container
              justify="center"
              spacing={7}
              className={classes.mobileResponsive}
            >
              <HeaderTypography
                className={clsx(
                  classes.pepperCloudCRMHelps,
                  classes.mobileHeading
                )}
                component="h4"
                fontSize={24}
                fontWeight={600}
                textAlign="center"
              >
                <span fontWeight={600}>Also popular in this category</span>
              </HeaderTypography>
              <Box className={classes.cardContainer}>
                {pageData?.bottomCards?.map((cardData) => (
                  // <Grid item xs={12} sm={6} lg={3} xl={3} key={cardData.id}>
                  <HomeCard
                    key={cardData.id}
                    image={cardData.image}
                    backgroundColor={cardData.backgroundColor}
                    link={cardData.link}
                    badgeText={cardData.badgeText}
                    badgeColor={cardData?.badgeColor}
                    badgeBackground={cardData?.badgeBackground}
                    heading={cardData.heading}
                    description={cardData.description}
                    logo={cardData.logo} // Pass logo path here
                    id={cardData.id}
                  />
                  // </Grid>
                ))}
              </Box>
            </Grid>
          </Container>
          <Box
            mb={2}
            mt={1}
            style={{
              position: "absolute",
              left: "0",
              right: "0",
              bottom: "10rem",
              zIndex: "-1",
            }}
          >
            {/* <Divider light /> */}
          </Box>
        </Box>
      )}
      <Box>
        <Box mb={0} className={classes.faqbackgroundDivder}>
          <Divider light />
        </Box>
        <TrustedByLogoStrip
          title={`Best CRM with ${caseStudy.pageTitle} integration - Trusted by many businesses`}
        />
      </Box>
      <Box className={classes.requestDemoRoot} py={10} textAlign="center">
        <Container>
          <Box alignItems="center" display="flex" justifyContent="center">
            <HeaderTypography
              color="common.white"
              fontSize={48}
              fontWeight={600}
              my={0}
              textAlign="center"
              component="h2"
              className={classes.boostText}
            >
              Navigate the future of business with our <br />
              intuitive CRM system integrations
            </HeaderTypography>
          </Box>
          <Grid item md={10} sm={12}>
            <Box className={classes.boostTextwidth}>
              <List className={classes.nopadding} pl={0}>
                {listFive.map((each) => (
                  <ListItem
                    alignItems="center"
                    className={classes.nopad}
                    key={each}
                  >
                    <ListItemIcon className={classes.tickImages}>
                      <Box alt="Check icon" component={"img"} src={tickImage} />
                    </ListItemIcon>
                    <ListItemText className={classes.listItemTextWhite}>
                      {each}
                    </ListItemText>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
          <Box mt={6} className={classes.footerButtonContainer}>
            <a
              className="primaryButton font-18"
              href={caseStudy.getStarted}
              target="_blank"
            >
              Get started
            </a>
          </Box>
        </Container>
      </Box>
    </React.Fragment>
  );
};

export const query = graphql`
  query {
    featureEngage: file(
      sourceInstanceName: { eq: "home-dynamic" }
      name: { eq: "feature-engage@2x" }
    ) {
      childImageSharp {
        gatsbyImageData(height: 500, placeholder: BLURRED)
      }
    }
    featureManage: file(
      sourceInstanceName: { eq: "home-dynamic" }
      name: { eq: "feature-manage@2x" }
    ) {
      childImageSharp {
        gatsbyImageData(height: 500, placeholder: BLURRED)
      }
    }
    featureExpand: file(
      sourceInstanceName: { eq: "home-dynamic" }
      name: { eq: "feature-expand@2x" }
    ) {
      childImageSharp {
        gatsbyImageData(height: 500, placeholder: BLURRED)
      }
    }
    featureAutomate: file(
      sourceInstanceName: { eq: "home-dynamic" }
      name: { eq: "feature-automate@2x" }
    ) {
      childImageSharp {
        gatsbyImageData(height: 500, placeholder: BLURRED)
      }
    }
  }
`;

CrmIntegration.propTypes = {
  data: PropTypes.object,
};

export default CrmIntegration;
